<template>
  <div class="containers">
    <div class="list" v-if="detail == false && areaAdd == false">
      <CAlert
          v-if="success == true"
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <CAlert
          v-else
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:red;border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <div class="headers" style="padding-left:20px;padding-right:20px;padding-top:24px;">
        <CRow class="no-gutters">
          <CCol sm="10" class="no-gutters p-0 m-0">
                    <span class="font-weight-bold" style="color:rgba(0, 0, 0, 1);font-size:18px">
                        Daftar Karyawan
                    </span>
          </CCol>
          <CCol sm="2" style="padding-left:8px">
                    <span>
                        <CButton v-if="tokenRole == 'Y'" type="button" @click="goSyncEmp()"
                                 class="btn btn-add">Sinkron</CButton>
                    </span>
          </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(224, 224, 224, 1)"/>
      </div>
      <div class="search-area">
        <CRow class="no-gutters" v-if="tokenRole == 'Y'">
          <CCol style="padding-right:4px" sm="2">
            <input type="text" v-model="searchValue" placeholder="Nama Pegawai / NIP" class="form-control"/>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <div class="autocomplete">
              <input type="text"
                     class="form-control"
                     @click="toggleVisibleUnitSearch()"
                     @blur="toggleCloseVisibleUnitSearch()"
                     v-text="selectedItemUnitSearch ? selectedItemUnitSearch['text'] : ''"
                     v-model="queryUnitSearch"
                     @keydown.up="upUnitSearch"
                     @keydown.down="downUnitSearch"
                     @keydown.enter="selectItemUnitSearch"
                     placeholder="Pilih Unit Level"
              >
              <div class="popovers" v-show="visibleUnitSearch">
                <div class="options" v-if="matchesUnitSearch.length != 0 && queryUnitSearch.length != 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in matchesUnitSearch"
                        :key="index"
                        :class="{ 'selected': (selectedUnitSearch == index)}"
                        @click="itemClickedUnitSearch(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesUnitSearch.length == 0 && queryUnitSearch.length != 0">
                  Data Tidak Ditemukan
                </div>
                <div class="options" v-if="matchesUnitSearch.length == 0 && queryUnitSearch.length == 0">
                  Start Typing...
                </div>
              </div>
            </div>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <div class="autocomplete">
              <input type="text"
                     class="form-control"
                     @click="toggleVisibleTipePegawai()"
                     @blur="toggleCloseVisibleTipePegawai()"
                     v-model="queryTipePegawai"
                     v-text="selectedItemTipePegawai ? selectedItemTipePegawai['text'] : ''"
                     @keydown.up="upTipePegawai"
                     @keydown.down="downTipePegawai"
                     @keydown.enter="selectItemTipePegawai"
                     placeholder="Pilih Tipe Pegawai"
              >
              <div class="popovers" v-show="visibleTipePegawai">
                <div class="options" v-if="matchesTipePegawai.length != 0 && queryTipePegawai.length != 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in matchesTipePegawai"
                        :key="index"
                        :class="{ 'selected': (selectedTipePegawai == index)}"
                        @click="itemClickedTipePegawai(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length == 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in dataTipePegawai"
                        :key="index"
                        :class="{ 'selected': (selectedKota == index)}"
                        @click="itemClickedTipePegawaiBefore(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length != 0">
                  Data Tidak Ditemukan
                </div>
              </div>
            </div>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <input type="text" v-model="searchJobPosition" placeholder="Jabatan" class="form-control"/>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control"
                          v-model="filterStatus" placeholder="Pilih Status"></model-select>
          </CCol>
          <CCol style="padding-left:4px" sm="2">
            <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
          </CCol>
        </CRow>
        <CRow class="no-gutters" v-else>
          <CCol style="padding-right:4px" sm="3">
            <input type="text" v-model="searchValue" placeholder="Nama Pegawai / NIP" class="form-control"/>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="3">
            <div class="autocomplete">
              <input type="text"
                     class="form-control"
                     @click="toggleVisibleTipePegawai()"
                     @blur="toggleCloseVisibleTipePegawai()"
                     v-model="queryTipePegawai"
                     v-text="selectedItemTipePegawai ? selectedItemTipePegawai['text'] : ''"
                     @keydown.up="upTipePegawai"
                     @keydown.down="downTipePegawai"
                     @keydown.enter="selectItemTipePegawai"
                     placeholder="Pilih Tipe Pegawai"
              >
              <div class="popovers" v-show="visibleTipePegawai">
                <div class="options" v-if="matchesTipePegawai.length != 0 && queryTipePegawai.length != 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in matchesTipePegawai"
                        :key="index"
                        :class="{ 'selected': (selectedTipePegawai == index)}"
                        @click="itemClickedTipePegawai(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length == 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in dataTipePegawai"
                        :key="index"
                        :class="{ 'selected': (selectedKota == index)}"
                        @click="itemClickedTipePegawaiBefore(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length != 0">
                  Data Tidak Ditemukan
                </div>
              </div>
            </div>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <input type="text" v-model="searchJobPosition" placeholder="Jabatan" class="form-control"/>
          </CCol>
          <CCol style="padding-right:4px;padding-left:4px" sm="2">
            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control"
                          v-model="filterStatus" placeholder="Pilih Status"></model-select>
          </CCol>
          <CCol style="padding-left:4px" sm="2">
            <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
          </CCol>
        </CRow>
      </div>
      <div class="sticky1">
        <CRow>
          <CCol sm="6" style="float:left">
            <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload"
                 width="20px" height="20px" style="cursor:pointer;float:left"/>
            <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer"
                 :src="downloadIcon" title="export to excel" width="20px" height="20px"/>
            <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
          </CCol>
          <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                    </span>
            <input @change="validatePage(page)" v-if="totalPage != 1"
                   style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page"
                   class="text-center rounded p-1" type="text">
            <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right"
                   v-model="page" class="text-center rounded p-1" type="text">
            <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span
                style="color:rgba(16, 16, 16, 1)">{{ firstPage }} - {{ lastPage }}</span> of {{ totalRow }}</span>
          </CCol>
        </CRow>
      </div>
      <Tables @sort="sorting" :data="datas" @detail="getDetails" :th="dataTh" :td="dataTd" :styleTable="styleTable"
              :errors="errorMessage"></Tables>
    </div>
    <div class="detail" v-if="detail == true">
      <CAlert
          v-if="successDetail == true"
          :show.sync="currentAlertCounterDetail"
          closeButton
          style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white;margin: 20px 20px 0 20px;"
      >
        {{ alertMessDetail }}
      </CAlert>
      <CAlert
          v-else
          :show.sync="currentAlertCounterDetail"
          closeButton
          style="background-color:red;border-radius:0;text-align:center;color:white;margin: 20px 20px 0 20px;"
      >
        {{ alertMessDetail }}
      </CAlert>
      <div class="headers" style="padding-left:20px;padding-right:20px;padding-top:24px;">
            <span class="font-weight-bold" style="color:rgba(0, 0, 0, 1);font-size:18px">
                Detail Karyawan
            </span>
        <hr style="border: 1px solid rgba(224, 224, 224, 1)"/>
      </div>
      <div class="sticky2">
        <CRow>
          <CCol sm="6">
            <img class="mr-4 mt-1" @click="move()" title="kembali" :src="backIcon" width="20px" height="20px"
                 style="cursor:pointer;float:left"/>
            <!-- <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                    <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/> -->
          </CCol>
        </CRow>
      </div>
      <div class="identity" style="padding-left:20px;padding-right:20px;padding-bottom:12px;padding-top:20px">
        <CRow>
          <CCol sm="2">
            <img v-if="arrDataEdit1[3] == '-'" :src="sampelImage" width="150px" height="150px"
                 style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
            <img v-if="arrDataEdit1[3] != '-'" :src="arrDataEdit1[3]" @error="changeDefault" width="150px"
                 height="150px" style="border-radius:50%;opacity: 1;background-color:#dcdcdc;object-fit: cover"/>
            <div v-if="arrDataEdit1[3] != '-'"
                 style="opacity: 0.1;background-color: black;width: 150px;height: 150px;position: absolute;top: 0;border-radius: 50%;"></div>
            <img v-if="tokenRole == 'Y'" :src="cameraIcon" width="36px" height="36px" class="image-cam"/>
            <input v-on:change="onFileChange" type="file" class="image-cam" style="width:36px;opacity:0;"
                   accept=".jpg, .png, .bmp, .jpeg"/>
          </CCol>
          <CCol sm="10">
            <CRow>
              <CCol sm="10" class="p-0">
                <span class="font-weight-bold" style="font-size:32px;color:rgba(16, 16, 16, 1)">{{ arrData1[4] }} <span
                    v-if="arrData1[5] != '-'">({{ arrData1[5] }})</span> <img v-if="tokenRole == 'Y'"
                                                                              @click="showModal('nama')"
                                                                              :src="pencilIcon" title="edit nama"
                                                                              style="cursor:pointer" width="24px"
                                                                              height="24px" class="ml-1"/></span>
              </CCol>
              <CCol sm="2" class="text-right">
                <CBadge v-if="arrData1[2] == 'Y'" color="primary">Active</CBadge>
                <CBadge v-else color="danger">Non Active</CBadge>
              </CCol>
            </CRow>
            <CRow class="mt-4">
              <CCol sm="12" class="p-0">
                <CRow>
                  <CCol sm="12">
                    <span class="font-weight-bold"
                          style="font-size:16px;color:rgba(16, 16, 16, 1)">My Team {{ totalDataTeam }}</span>
                  </CCol>
                </CRow>
                <CRow class="mt-2" v-if="arrDataTeam != ''">
                  <CCol sm="12">
                                    <span v-for="(data, index) in arrDataTeam" :key="index">
                                        <img @click="getTeam(data.idPegawai)" :title="data.nama"
                                             v-if="data.urlFoto == 'null' && index<50" :src="sampelImage" width="32px"
                                             height="32px" :style="loadStyleImage(index)"/>
                                        <img @click="getTeam(data.idPegawai)" :title="data.nama"
                                             v-if="data.urlFoto != 'null' && index<50" @error="changeDefault"
                                             :src="data.urlFoto" width="32px" height="32px"
                                             :style="loadStyleImage(index)"
                                             style="border-radius:50%;opacity: 1;background-color:#dcdcdc;object-fit: cover"/>
                                    </span>
                    <span style="cursor:pointer;font-size:16px" @click="moveMenu('team')" v-if="totalDataTeam>49"
                          class="font-italic ml-2 align-bottom">... and more</span>
                  </CCol>
                </CRow>
                <CRow class="mt-2" v-else>
                  <CCol sm="12">
                    -
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div class="navs mt-2" style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
        <div>
          <span v-if="menuFlag != '1'" @click="moveMenu('infoKepegawaian')"
                class="menu-non-active">Info Kepegawaian</span>
          <span v-if="menuFlag == '1'" @click="moveMenu('infoKepegawaian')" class="menu-active">Info Kepegawaian</span>
          <span v-if="menuFlag != '2'" @click="moveMenu('infoDataDiri')" class="menu-non-active">Info Data Diri</span>
          <span v-if="menuFlag == '2'" @click="moveMenu('infoDataDiri')" class="menu-active">Info Data Diri</span>
          <span v-if="menuFlag != '3'" @click="moveMenu('penempatanKerja')"
                class="menu-non-active">Penempatan Kerja</span>
          <span v-if="menuFlag == '3'" @click="moveMenu('penempatanKerja')" class="menu-active">Penempatan Kerja</span>
          <span v-if="menuFlag != '4'" @click="moveMenu('seragam')" class="menu-non-active">Seragam</span>
          <span v-if="menuFlag == '4'" @click="moveMenu('seragam')" class="menu-active">Seragam</span>
          <span v-if="menuFlag != '5'" @click="moveMenu('keluarga')" class="menu-non-active">Keluarga</span>
          <span v-if="menuFlag == '5'" @click="moveMenu('keluarga')" class="menu-active">Keluarga</span>
          <span v-if="menuFlag != '6'" @click="moveMenu('jadwalJamKerja')"
                class="menu-non-active">Jadwal Jam Kerja</span>
          <span v-if="menuFlag == '6'" @click="moveMenu('jadwalJamKerja')" class="menu-active">Jadwal Jam Kerja</span>
          <span v-if="menuFlag != '7'" @click="moveMenu('team')" class="menu-non-active">Team {{ totalDataTeam }}</span>
          <span v-if="menuFlag == '7'" @click="moveMenu('team')" class="menu-active">Team {{ totalDataTeam }}</span>
          <span v-if="menuFlag != '8'" @click="moveMenu('device')" class="menu-non-active">Device</span>
          <span v-if="menuFlag == '8'" @click="moveMenu('device')" class="menu-active">Device</span>
          <span v-if="menuFlag != '9'" @click="moveMenu('dokumen')" class="menu-non-active">Dokumen</span>
          <span v-if="menuFlag == '9'" @click="moveMenu('dokumen')" class="menu-active">Dokumen</span>
          <span v-if="menuFlag != '10'" @click="moveMenu('vaksin')" class="menu-non-active">Vaksin</span>
          <span v-if="menuFlag == '10'" @click="moveMenu('vaksin')" class="menu-active">Vaksin</span>

        </div>
      </div>
    </div>
    <div class="contents" v-if="detail == true">
      <div v-if="menuFlag == '1'" class="card card-menu">
        <CRow class="header-card no-gutters">
          <CCol sm="10">
            <img :src="kepegawaianIcon" class="mr-1" width="24px" height="24px"/> Info Kepegawaian
          </CCol>
          <CCol sm="2" class="text-right">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('kepegawaian')"
                 style="cursor:pointer" title="edit kepegawaian" width="24px" height="24px"/>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">NIP</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[6] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jabatan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[9] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Bidang - Divisi</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[8] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Atasan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[10] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Tipe Pegawai</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[15] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Tipe Role</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[16] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Wajib GPS</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData1[17] == 'Y'">Yes</span>
              <span class="sub-title-content" v-if="arrData1[17] == 'T'">No</span>
              <span class="sub-title-content" v-if="arrData1[17] == '-'">-</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Hide WFH</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData1[18] == 'Y'">Yes</span>
              <span class="sub-title-content" v-if="arrData1[18] == 'T'">No</span>
              <span class="sub-title-content" v-if="arrData1[18] == '-'">-</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Total Cuti</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[19] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Expired Date Cuti</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[22] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Total cuti yang digunakan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[20] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Sisa Cuti</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[21] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" v-if="arrData1[29] == '2'" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Penyedia Jasa Tenaga Kerja (PJTK)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[24] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" v-if="arrData1[29] == '1'" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jenjang Jabatan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[25] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Radius Pegawai (meter)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[13] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Sync Offline</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData1[26] == '1'">Yes</span>
              <span class="sub-title-content" v-if="arrData1[26] == '2'">No</span>
              <span class="sub-title-content" v-if="arrData1[18] == '-'">-</span>
            </CCol>
          </CCol>
          <CCol sm="6" v-if="arrData1[29] == '2' && tokenRole == 'Y'" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Harga Satuan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData1[28] }}</span>
            </CCol>
          </CCol>
        </CRow>
      </div>
      <div v-if="menuFlag == '2'" class="card card-menu">
        <CRow class="header-card no-gutters">
          <CCol sm="10">
            <img :src="sekilasIcon" class="mr-1" width="24px" height="24px"/> Sekilas
          </CCol>
          <CCol sm="2" class="text-right">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('sekilas')"
                 style="cursor:pointer" title="edit sekilas" width="24px" height="24px"/>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Tempat Tanggal Lahir</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[0] }}. {{ separatorTglLahir(arrData2[1]) }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Agama</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[8] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jenis Kelamin</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData2[4] == '1'">Laki-Laki</span>
              <span class="sub-title-content" v-if="arrData2[4] == '2'">Perempuan</span>
              <span class="sub-title-content" v-if="arrData2[4] == '-'">-</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Status</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData2[2] == '1'">Sudah Menikah</span>
              <span class="sub-title-content" v-if="arrData2[2] == '0'">Belum Menikah</span>
              <span class="sub-title-content" v-if="arrData2[2] == '-'">-</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Ijasah Terakhir</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[5] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Tangal Berakhir Kontrak</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ separatorTglLahir(arrData2[6]) }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'SMA/SMK/Setingkat'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Sekolah Menengah Atas (SMA)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[12] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan Sekolah Menengah Atas (SMA)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[13] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'D1'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas D1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[14] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan D1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[15] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) D1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[16] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'D2'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas D2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[17] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan D2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[18] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) D2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[19] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'D3'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas D3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[20] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan D3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[21] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) D3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[22] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'D4'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas D4</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[23] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan D4</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[24] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) D4</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[25] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'S1' || arrData2[5] == 'S2' || arrData2[5] == 'S3'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas S1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[26] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan S1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[27] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) S1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[28] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'S2' || arrData2[5] == 'S3'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas S2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[29] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan S2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[30] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) S2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[31] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'S3'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Universitas S3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[32] }}</span>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px;padding-right:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Jurusan S3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[33] }}</span>
            </CCol>
          </CCol>
          <CCol sm="2" style="padding-left:5px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Indeks Prestasi Kumulatif (IPK) S3</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[34] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Golongan Darah </span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[3] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Negara</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[7] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Ibu Kandung</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[9] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Periode GPS Tracking (Menit)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData2[10] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="header-card mt-4 no-gutters">
          <CCol sm="10">
            <img :src="kontakIcon" class="mr-1" width="24px" height="24px"/> Info Kontak
          </CCol>
          <CCol sm="2" class="text-right">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('kontak')"
                 style="cursor:pointer" title="edit kontak" width="24px" height="24px"/>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">No Handphone</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[0] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">No Whatsapp</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[1] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Username</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[6] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Username By</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content" v-if="arrData3[2] == '1'">LDAP</span>
              <span class="sub-title-content" v-if="arrData3[2] == '2'">Google</span>
              <span class="sub-title-content" v-if="arrData3[2] == '3'">-</span>
              <span class="sub-title-content" v-if="arrData3[2] == '4'">-</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Email</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[4] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Validasi Email</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[5] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Alamat Lengkap KTP</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[3] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Alamat Lengkap Domisili</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData3[7] }}</span>
            </CCol>
          </CCol>
        </CRow>
      </div>
      <div v-if="menuFlag == '3'" class="card card-menu">
        <template v-if="arrData4 != ''">
          <div v-for="(data, id) in arrData4" :key="id">
            <CRow class="header-card no-gutters">
              <CCol sm="10">
                <img :src="penempatanIcon" class="mr-1" width="24px" height="24px"/> Penempatan Kerja {{ id + 1 }}
              </CCol>
              <CCol sm="2" class="text-right">
                <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('penempatan',id)"
                     style="cursor:pointer" title="edit penempatan" width="24px" height="24px"/>
              </CCol>
            </CRow>
            <CRow class="mt-3 no-gutters mb-4">
              <CCol sm="6" style="padding-right:20px">
                <CCol sm="12" class="p-0">
                  <span class="sub-title">Lokasi</span>
                </CCol>
                <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                  <span class="sub-title-content">{{ data[1] }}</span>
                </CCol>
              </CCol>
              <CCol sm="6" style="padding-right:20px">
                <CCol sm="12" class="p-0">
                  <span class="sub-title">Tanggal Expired</span>
                </CCol>
                <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                  <span class="sub-title-content">{{ separatorTglLahir(data[3]) }}</span>
                </CCol>
              </CCol>
            </CRow>
          </div>
        </template>
        <template v-else>
          <CRow class="header-card no-gutters">
            <CCol sm="10">
              <img :src="penempatanIcon" class="mr-1" width="24px" height="24px"/> Penempatan Kerja
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('penempatan', 'null')"
                   style="cursor:pointer" title="edit penempatan" width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters mb-4">
            <CCol sm="12">
              Maaf, Data Penempatan Kerja Tidak Ditemukan
            </CCol>
          </CRow>
        </template>
      </div>
      <div v-if="menuFlag == '4'" class="card card-menu">
        <template v-if="arrData5 != ''">
          <CRow class="header-card no-gutters">
            <CCol sm="10">
              <img :src="seragamIcon" class="mr-1" width="24px" height="24px"/> Seragam 1
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('seragam')"
                   style="cursor:pointer" title="edit seragam" width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters">
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Tipe</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[0] }}</span>
              </CCol>
            </CCol>
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Ukuran</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[1] }}</span>
              </CCol>
            </CCol>
          </CRow>
          <CRow class="header-card no-gutters mt-4">
            <img :src="seragamIcon" class="mr-1" width="24px" height="24px"/> Seragam 2
          </CRow>
          <CRow class="mt-3 no-gutters">
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Tipe</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[2] }}</span>
              </CCol>
            </CCol>
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Ukuran</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[3] }}</span>
              </CCol>
            </CCol>
          </CRow>
          <CRow class="header-card no-gutters mt-4">
            <img :src="seragamIcon" class="mr-1" width="24px" height="24px"/> Seragam Olahraga
          </CRow>
          <CRow class="mt-3 no-gutters">
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Tipe</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[4] }}</span>
              </CCol>
            </CCol>
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Ukuran</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ arrData5[5] }}</span>
              </CCol>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters">
            <CCol sm="6" style="padding-right:20px">
              <CCol sm="12" class="p-0">
                <span class="sub-title">Hijab</span>
              </CCol>
              <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
                <span class="sub-title-content">{{ separatorHijab(arrData5[6]) }}</span>
              </CCol>
            </CCol>
          </CRow>
        </template>
        <template v-else>
          <CRow class="header-card no-gutters">
            <CCol sm="10">
              <img :src="seragamIcon" class="mr-1" width="24px" height="24px"/> Seragam
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('seragam')"
                   style="cursor:pointer" title="edit seragam" width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters mb-4">
            <CCol sm="12">
              Maaf, Data Seragam Tidak Ditemukan
            </CCol>
          </CRow>
        </template>
      </div>
      <div v-if="menuFlag == '5'" class="card card-menu">
        <template v-if="arrData6 != ''">
          <CRow class="no-gutters">
            <CCol sm="4" v-for="(data, id) in arrData6" :key="id" style="padding-right:20px;">
              <CRow class="header-card no-gutters">
                <CCol sm="10">
                  <img :src="istriIcon" class="mr-1" width="24px" height="24px"/> Info Pasangan {{ id + 1 }}
                </CCol>
                <CCol sm="2" class="text-right">
                  <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'"
                       @click="showModal('keluarga','pasangan', id)" style="cursor:pointer" title="edit pasangan"
                       width="20px" height="20px"/>
                </CCol>
              </CRow>
              <div class="mt-3 d-flex">
                <div class="card w-100 h-100 card-family">
                  <CRow class="no-gutters">
                    <CCol sm="3">
                      <img :src="photoKeluargaWanita" width="64px" height="64px"
                           style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
                    </CCol>
                    <CCol sm="9">
                      <CCol sm="12">
                        <span class="family-name">{{ data[0] }}</span>
                      </CCol>
                      <CCol sm="12">
                        <span class="family-lahir">{{ separatorTglLahir(data[2]) }}</span>
                      </CCol>
                      <CCol sm="12">
                        <span class="family-lahir">Menikah pada {{ separatorTglLahir(data[1]) }}</span>
                      </CCol>
                    </CCol>
                  </CRow>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5 no-gutters">
            <template v-if="arrData11 != ''">
              <CCol sm="4" style="padding-right:20px;" v-for="(data, id) in arrData11" :key="id">
                <CRow class="header-card no-gutters">
                  <CCol sm="10">
                    <img :src="istriIcon" class="mr-1" width="24px" height="24px"/>
                    <span v-if="id == 0">Anak Pertama</span>
                    <span v-if="id == 1">Anak Kedua</span>
                    <span v-if="id == 2">Anak Ketiga</span>
                    <span v-if="id == 3">Anak Keempat</span>
                    <span v-if="id == 4">Anak Kelima</span>
                    <span v-if="id == 5">Anak Keenam</span>
                    <span v-if="id == 6">Anak Ketujuh</span>
                    <span v-if="id == 7">Anak Kedelapan</span>
                    <span v-if="id == 8">Anak Kesembilan</span>
                    <span v-if="id == 9">Anak Kesepuluh</span>
                  </CCol>
                  <CCol sm="2" class="text-right">
                    <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('keluarga', 'anak', id)"
                         style="cursor:pointer" title="edit keluarga" width="20px" height="20px"/>
                  </CCol>
                </CRow>
                <div class="d-flex mt-3">
                  <div class="card w-100 card-family">
                    <CRow class="no-gutters">
                      <CCol sm="3">
                        <img :src="photoKeluargaPria" width="64px" height="64px"
                             style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
                      </CCol>
                      <CCol sm="9">
                        <CCol sm="12">
                          <span class="family-name">{{ data[0] }}</span>
                        </CCol>
                        <CCol sm="12">
                          <span class="family-lahir">{{ separatorTglLahir(data[2]) }}</span>
                        </CCol>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CCol>
            </template>
            <template v-else>
              <CCol sm="12">
                <CRow class="header-card no-gutters">
                  <CCol sm="10">
                    <img :src="istriIcon" class="mr-1" width="24px" height="24px"/>
                    Anak Pertama
                  </CCol>
                  <CCol sm="2" class="text-right">
                    <img :src="editIcon" class="mr-1" v-if="(tokenRole == 'Y') && arrData2[2] == '1'"
                         @click="showModal('keluarga','anak', 'null')" style="cursor:pointer" title="edit anak"
                         width="24px" height="24px"/>
                  </CCol>
                </CRow>
                <CRow class="no-gutters mt-3 mb-4">
                  <CCol sm="12">
                    Maaf, Data Anak Tidak Ditemukan
                  </CCol>
                </CRow>
              </CCol>
            </template>
          </CRow>
        </template>
        <template v-else>
          <CRow class="header-card no-gutters">
            <CCol sm="10">
              <img :src="istriIcon" class="mr-1" width="24px" height="24px"/> Info Keluarga
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="(tokenRole == 'Y') && arrData2[2] == '1'"
                   @click="showModal('keluarga','pasangan', 'null')" style="cursor:pointer" title="edit seragam"
                   width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters mb-4">
            <CCol sm="12">
              Maaf, Data Keluarga Tidak Ditemukan
            </CCol>
          </CRow>
        </template>
      </div>
      <div v-if="menuFlag == '6'" class="card card-menu">
        <template v-if="dataJamKerja != ''">
          <CRow class="header-card no-gutters">
            <CCol sm="11">
              <img :src="jadwalJamKerjaIcon" class="mr-1" width="24px" height="24px"/> Jadwal Jam Kerja
            </CCol>
            <CCol sm="1" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('jadwal', 'empty')"
                   style="cursor:pointer" title="edit jadwal" width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="no-gutters mt-4" v-if="statusSchadule != ''">
            <CCol sm="10">
              <CRow>
                <CCol sm="4">
                  Status Schedule
                </CCol>
                <CCol sm="8">
                  : {{ statusSchadule }}
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="4">
                  Tanggal Pengajuan Schedule
                </CCol>
                <CCol sm="8">
                  : {{ tanggalMengajukanSchadule }}
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="4">
                  Tanggal Schedule Disetujui
                </CCol>
                <CCol sm="8">
                  : {{ tanggalApproveSchadule }}
                </CCol>
              </CRow>
            </CCol>
            <CCol style="padding-left:4px" sm="2">
              <CButton type="button" @click="resetModalSchadule = true" class="btn btn-secondary w-100 align-middle">
                Reset Schedule
              </CButton>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters">
            <CCol style="padding-right:4px;" sm="5">
              <model-select :options="dataBulan" class="form-control" v-model="selectedBulan"
                            placeholder="Bulan"></model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="5">
              <model-select :options="dataYear" class="form-control" v-model="selectedTahun"
                            placeholder="Tahun"></model-select>
            </CCol>
            <CCol style="padding-left:4px" sm="2">
              <CButton type="button" @click="getDataJamKerja(idPegawaiJamKerja)" class="btn btn-edit">Go</CButton>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <img class="mr-4 mt-1" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px"
                   style="cursor:pointer;float:left"/>
              <!-- <img class="mr-4 mt-1" style="float:left;cursor:pointer" :src="downloadIcon" title="download excel"  width="20px" height="20px"/> -->
              <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
            </CCol>
            <CCol sm="6">
                        <span style="float:right">
                            <!-- <CButton class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton> -->
                            <CButton @click="prevMonth()" class="rounded"><font-awesome-icon
                                :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                          <!-- <CButton class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton> -->
                            <CButton @click="nextMonth()" class="rounded"><font-awesome-icon
                                :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                        </span>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters">
            <table>
              <thead>
              <tr>
                <th style="mac-width:100px">Tgl</th>
                <th style="max-width:200px">Hari</th>
                <th style="max-width:500px">Jadwal Masuk</th>
                <th v-if="tipeJamKerja == '1'" style="max-width:500px">Istirahat</th>
                <th style="max-width:500px">Jadwal Pulang</th>
                <th style="max-width:500px">Schedule</th>
              </tr>
              </thead>
              <tbody v-if="tipeJamKerja == '1'">
              <template v-for="(data, index) in dataJamKerja" :key="index">
                <tr v-if="data[6] == '1'">
                  <td>{{ data[0].split("/")[0] }}</td>
                  <td>{{ data[1] }}</td>
                  <td>
                    <img :src="jamMasukIcon" width="20px" height="20px"/>
                    {{ data[2] }}
                  </td>
                  <td>
                    <img :src="refreshIcon" width="20px" height="20px"/>
                    {{ data[4] }} - {{ data[5] }}
                  </td>
                  <td>
                    <img :src="jamKeluarIcon" width="20px" height="20px"/>
                    {{ data[3] }}
                  </td>
                  <td v-if="data[7] == 'WFH' || data[7] == 'WFA'"><span
                      class="text-warning font-weight-bold">{{ data[7] }}</span></td>
                  <td v-if="data[7] == 'WFO'"><span class="text-success font-weight-bold">{{ data[7] }}</span></td>
                </tr>
                <tr v-if="data[6] == '0'">
                  <td class="off">{{ data[0].split("/")[0] }}</td>
                  <td class="off">{{ data[1] }}</td>
                  <td colspan="4" class="off" v-if="data[7] == '-'">Off</td>
                  <td colspan="4" class="off" v-if="data[7] != '-'">{{ data[7] }}</td>
                </tr>
              </template>
              </tbody>
              <tbody v-if="tipeJamKerja != '1'">
              <template v-for="(data, index) in dataJamKerja" :key="index">
                <tr v-if="data[6] == '1'">
                  <td>{{ data[0].split("/")[0] }}</td>
                  <td>{{ data[1] }}</td>
                  <td>
                    <img :src="jamMasukIcon" width="20px" height="20px"/>
                    {{ data[2] }}
                  </td>
                  <td>
                    <img :src="jamKeluarIcon" width="20px" height="20px"/>
                    {{ data[5] }}
                  </td>
                  <td v-if="data[8] == 'WFH' || data[8] == 'WFA'"><span
                      class="text-warning font-weight-bold">{{ data[8] }}</span></td>
                  <td v-if="data[8] == 'WFO'"><span class="text-success font-weight-bold">{{ data[8] }}</span></td>
                </tr>
                <tr v-if="data[6] == '0'">
                  <td class="off">{{ data[0].split("/")[0] }}</td>
                  <td class="off">{{ data[1] }}</td>
                  <td colspan="3" class="off" v-if="data[7] == '-'">Off</td>
                  <td colspan="3" class="off" v-if="data[7] != '-'">{{ data[7] }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </CRow>
        </template>
        <template v-else>
          <CRow class="header-card no-gutters">
            <CCol sm="10">
              <img :src="jadwalJamKerjaIcon" class="mr-1" width="24px" height="24px"/> Jadwal Jam Kerja
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('jadwal', 'null')"
                   style="cursor:pointer" title="edit jadwal" width="24px" height="24px"/>
            </CCol>
          </CRow>
          <CRow class="mt-3 no-gutters mb-4">
            <CCol sm="12">
              Maaf, Data Jam Kerja Tidak Ditemukan
            </CCol>
          </CRow>
        </template>
      </div>
      <div v-if="menuFlag == '7'" class="card card-menu">
        <div class="header-card row no-gutters">
          <div class="col-12">
            <img :src="teamIcon" class="mr-1" width="24px" height="24px"/> Team {{ totalDataTeam }}
          </div>
        </div>
        <div class="row mt-3 no-gutters" style="margin-left:-10px;margin-right:-10px" v-if="arrDataTeam != ''">
          <div class="col-4 no-gutters d-flex" v-for="(data, id) in arrDataTeam" :key="id"
               style="padding-bottom: 10px;padding-right: 10px;padding-left: 10px;padding-top: 10px;">
            <div class="card mb-0 card-menu card-team w-100" @click="getTeam(data.idPegawai)">
              <CRow class="no-gutters">
                <CCol sm="3">
                  <img v-if="data.urlFoto == 'null'" :src="sampelImage" width="64px" height="64px"
                       style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
                  <img v-if="data.urlFoto != 'null'" :src="data.urlFoto" @error="changeDefault" width="64px"
                       height="64px" style="border-radius:50%;opacity: 1;background-color:#dcdcdc;object-fit: cover"/>
                  <div v-if="data.urlFoto != 'null'"
                       style="opacity: 0.1;background-color: black;width: 64px;height: 64px;position: absolute;top: 0;border-radius: 50%;"></div>
                </CCol>
                <CCol sm="9">
                  <CCol sm="12">
                    <span class="family-name">{{ data.nama }}</span>
                  </CCol>
                  <CCol sm="12">
                    <span class="family-lahir">{{ data.nik }}</span>
                  </CCol>
                  <CCol sm="12">
                    <span class="family-lahir">{{ data.email }}</span>
                  </CCol>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
        <div class="row mt-3 no-gutters mb-4" style="margin-left:-10px;margin-right:-10px" v-else>
          Maaf, Data Team Tidak Ditemukan
        </div>
      </div>
      <div v-if="menuFlag == '8'" class="card card-menu">
        <div class="header-card row no-gutters">
          <div class="col-10">
            <img :src="deviceIcon" class="mr-1" width="24px" height="24px"/> Device
            {{ arrData8.length }}/{{ editJumlahDevice }}
          </div>
          <div class="text-right col-2">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('device', 'jumlahDevice')"
                 style="cursor:pointer" title="edit jadwal" width="24px" height="24px"/>
          </div>
        </div>
        <div class="row mt-3 no-gutters" style="margin-left:-10px;margin-right:-10px" v-if="arrData8 != ''">
          <div class="col-4 no-gutters d-flex" v-for="(data, id) in arrData8" :key="id"
               style="padding-bottom: 10px;padding-right: 10px;padding-left: 10px;padding-top: 10px;">
            <div class="card mb-0 card-menu w-100">
              <CRow class="no-gutters">
                <CCol sm="2">
                  <img :src="androidImage" v-if="data[1] == 'ANDROID' || data[1] == 'android'" width="44px"
                       height="44px" style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
                  <img :src="iosImage" v-else width="44px" height="44px"
                       style="border-radius:50%;opacity: 1;background-color:#dcdcdc"/>
                </CCol>
                <CCol sm="9">
                  <CCol sm="12">
                    <span class="family-name">{{ data[0] }}</span>
                  </CCol>
                  <CCol sm="12">
                    <span class="family-lahir">{{ data[2] }}</span>
                  </CCol>
                </CCol>
                <CCol sm="1">
                  <img :src="pencilIcon" width="20px" height="20px" v-if="tokenRole == 'Y'"
                       @click="showModal('device',id)" style="cursor:pointer;top:0;right:0"/>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
        <div class="row mt-3 no-gutters mb-4" v-else>
          Maaf, Data Device Tidak Ditemukan
        </div>
      </div>
      <div v-if="menuFlag == '9'" class="card card-menu">
        <CRow class="header-card no-gutters">
          <CCol sm="10">
            <img :src="kepegawaianIcon" class="mr-1" width="24px" height="24px"/> Dokumen
          </CCol>
          <CCol sm="2" class="text-right">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('dokumen')"
                 style="cursor:pointer" title="edit sekilas" width="24px" height="24px"/>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor Pokok Wajib Pajak(NPWP)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[0] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor Kartu Tanda Penduduk(KTP)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[1] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor BPJS Kesehatan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[2] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor BPJS Ketenagakerjaan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[3] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor Rekening DPLK</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[4] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Bank DPLK</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[5] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor Rekening Payroll </span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[6] }}</span>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nama Bank Payroll</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[7] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow v-if="tokenOrganisasi == 'AA'" class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Nomor Kartu Ad Medika </span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1" style="border-bottom: 1px solid rgba(224, 224, 224, 1)">
              <span class="sub-title-content">{{ arrData9[8] }}</span>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="header-card mt-4 no-gutters">
          <CCol sm="10">
            <img :src="kepegawaianIcon" class="mr-1" width="24px" height="24px"/> Kelengkapan Dokumen
          </CCol>
          <CCol sm="2" class="text-right">
            <img :src="editIcon" class="mr-1" v-if="tokenRole == 'Y'" @click="showModal('kelengkapanDokumen')"
                 style="cursor:pointer" title="edit kontak" width="24px" height="24px"/>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Kartu Tanda Penduduk(KTP)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="arrData10[0] == '-'" class="cards-image">None</div>
              <img v-else :src="arrData10[0]" height="70" width="56"/>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Kartu Keluarga(KK)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="arrData10[1] == '-'" class="cards-image">None</div>
              <img v-else :src="arrData10[1]" height="70" width="56"/>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters" v-show="arrData2[5] == 'S2' || arrData2[5] == 'S3'">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Ijazah S1</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="docFotoIjasah1 == '-'" class="cards-image">None</div>
              <img v-else :src="docFotoIjasah1" height="70" width="56"/>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px" v-show="arrData2[5] == 'S3'">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Ijazah S2</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="docFotoIjasah2 == '-'" class="cards-image">None</div>
              <img v-else :src="docFotoIjasah2" height="70" width="56"/>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Ijazah {{ arrData2[5] }}</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="docFotoIjasah3 == '-'" class="cards-image">None</div>
              <img v-else :src="docFotoIjasah3" height="70" width="56"/>
            </CCol>
          </CCol>
          <CCol sm="4" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto Nomor Pokok Wajib Pajak(NPWP)</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="arrData10[3] == '-'" class="cards-image">None</div>
              <img v-else :src="arrData10[3]" height="70" width="56"/>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="mt-2 no-gutters">
          <CCol sm="6" style="padding-right:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto BPJS Kesehatan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="arrData10[4] == '-'" class="cards-image">None</div>
              <img v-else :src="arrData10[4]" height="70" width="56"/>
            </CCol>
          </CCol>
          <CCol sm="6" style="padding-left:20px">
            <CCol sm="12" class="p-0">
              <span class="sub-title">Foto BPJS Ketenagakerjaan</span>
            </CCol>
            <CCol sm="12" class="pl-0 pr-0 pb-2 pt-1">
              <div v-if="arrData10[5] == '-'" class="cards-image">None</div>
              <img v-else :src="arrData10[5]" height="70" width="56"/>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="header-card mt-4 no-gutters">
          <CCol sm="12">
            <img :src="kepegawaianIcon" class="mr-1" width="24px" height="24px"/> Dokumen Tambahan (Upload)
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters" v-if="tokenRole == 'Y'">
          <CCol sm="12" class="p-0 pl-3 pr-3">
             <input type="file" multiple @change="handleUploadPegawaiDocument" ref="pegawaiDocumentFiles" class="form-control-file mb-3" />
             
             <!-- List of selected files to set custom names -->
             <div v-if="selectedPegawaiDocs.length > 0" class="mb-3">
                 <h6>Daftar File yang akan diunggah:</h6>
                 <CRow v-for="(item, idx) in selectedPegawaiDocs" :key="'upload_'+idx" class="mb-2 align-items-center">
                     <CCol sm="5">
                         <span class="text-truncate d-block" :title="item.file.name">{{ item.file.name }}</span>
                     </CCol>
                     <CCol sm="6">
                         <input type="text" class="form-control form-control-sm" v-model="item.name" placeholder="Nama Dokumen (Opsional)" />
                     </CCol>
                     <CCol sm="1">
                         <CButton color="danger" size="sm" @click="removeSelectedDocument(idx)">X</CButton>
                     </CCol>
                 </CRow>
                 <CButton color="primary" class="mt-2" size="sm" @click="submitPegawaiDocument" :disabled="isUploadingPegawaiDoc">
                     {{ isUploadingPegawaiDoc ? 'Uploading...' : 'Upload Dokumen' }}
                 </CButton>
             </div>
          </CCol>
        </CRow>
        <CRow class="mt-3 no-gutters">
          <CCol sm="12" class="p-0 pl-3 pr-3 pb-3">
             <div v-if="pegawaiDocumentsList && pegawaiDocumentsList.length > 0" class="table-responsive">
               <table class="table table-bordered table-striped text-center">
                 <thead style="background-color: rgba(249, 250, 252, 1)">
                   <tr>
                     <th style="width: 5%">No</th>
                     <th style="text-align: left">Nama Dokumen</th>
                     <th style="width: 15%">Aksi</th>
                   </tr>
                 </thead>
                 <tbody>
                   <tr v-for="(doc, idx) in pegawaiDocumentsList" :key="idx">
                     <td>{{ idx + 1 }}</td>
                     <td style="text-align: left">{{ doc.fileName || doc.originalFileName }}</td>
                     <td>
                       <CButton color="info" size="sm" class="mr-2" @click="viewPegawaiDocument(doc.fileId, doc.fileName || doc.originalFileName)" :disabled="loadingViewDocId == doc.fileId">
                         {{ loadingViewDocId == doc.fileId ? 'Loading...' : 'View' }}
                       </CButton>
                       <CButton color="danger" size="sm" @click="deletePegawaiDocument(doc.fileId)" v-if="tokenRole == 'Y'">Hapus</CButton>
                     </td>
                   </tr>
                 </tbody>
               </table>
             </div>
             <span v-else class="text-muted">Belum ada dokumen tambahan</span>
          </CCol>
        </CRow>
      </div>
      <div v-if="menuFlag == '10'" class="card card-menu">
        <div class="header-card row no-gutters">
          <div class="col-12">
            <img :src="vaksinIcon" class="mr-1" width="24px" height="24px"/> Vaksin
          </div>
        </div>
        <div class="row mt-3 no-gutters" style="margin-left:-10px;margin-right:-10px" v-if="arrData12 != ''">
          <div class="col-12" style="padding-bottom: 20px;padding-right: 10px;padding-left: 10px;padding-top: 20px;">
            <span class="font-weight-bold">{{ arrData12[3][0] }} : {{ arrData12[3][1] }}</span>
          </div>
          <div class="col-4 no-gutters d-flex" v-for="(data, id) in arrData12" :key="id"
               style="padding-bottom: 10px;padding-right: 10px;padding-left: 10px;padding-top: 10px;">
            <div v-if="id<3" class="card mb-0 card-menu w-100">
              <CRow class="no-gutters">
                <CCol sm="12">
                  <CCol sm="12">
                    <span class="family-name">{{ data[0] }}</span>
                  </CCol>
                  <CCol sm="12 mt-3">
                    <span class="family-lahir">{{ separatorTglLahir(data[1]) }}</span>
                  </CCol>
                  <CCol sm="12">
                    <span class="family-lahir">{{ data[2] }}</span>
                  </CCol>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
        <div class="row mt-3 no-gutters mb-4" v-else>
          Maaf, Data Vaksin Tidak Ditemukan
        </div>
      </div>
    </div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="editModal"
        :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="headers-modal">
          <CRow>
            <CCol sm="10">
              <div v-if="idModal == '0'"><img :src="kepegawaianIcon" width="24px" height="24px"/> Info Kepegawaian</div>
              <div v-if="idModal == '1'"><img :src="sekilasIcon" class="mr-1" width="24px" height="24px"/> Sekilas</div>
              <div v-if="idModal == '2'"><img :src="kontakIcon" class="mr-1" width="24px" height="24px"/> Info Kontak
              </div>
              <div v-if="idModal == '3'">Nama</div>
              <div v-if="idModal == '4'"><img :src="seragamIcon" class="mr-1" width="24px" height="24px"/> Seragam</div>
              <div v-if="idModal == '5'"><img :src="jadwalJamKerjaIcon" class="mr-1" width="24px" height="24px"/> Jadwal
                Kerja
              </div>
              <div v-if="idModal == '6'"><img :src="penempatanIcon" class="mr-1" width="24px" height="24px"/> Penempatan
              </div>
              <div v-if="idModal == '7'"><img :src="istriIcon" class="mr-1" width="24px" height="24px"/> Keluarga</div>
              <div v-if="idModal == '8'"><img :src="deviceIcon" class="mr-1" width="24px" height="24px"/> Device</div>
              <div v-if="idModal == '9'"><img :src="kepegawaianIcon" width="24px" height="24px"/> Dokumen</div>
              <div v-if="idModal == '10'"><img :src="kepegawaianIcon" width="24px" height="24px"/> Kelengkapan Dokumen
              </div>
              <div v-if="idModal == '11'"><img :src="deviceIcon" width="24px" height="24px"/> Device</div>
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #body-wrapper>
        <div v-if="idModal == '0'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                NIP
              </label>
              <input class="form-control w-100" v-model="arrDataEdit1[6]" placeholder="NIP"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Bidang
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleUnit()"
                       @blur="toggleCloseVisibleUnit()"
                       v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                       v-model="queryUnit"
                       @keydown.up="upUnit"
                       @keydown.down="downUnit"
                       @keydown.enter="selectItemUnit"
                       placeholder="Pilih Unit Level"
                >
                <div class="popovers" v-show="visibleUnit">
                  <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesUnit"
                          :key="index"
                          :class="{ 'selected': (selectedUnit == index)}"
                          @click="itemClickedUnit(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Jabatan
              </label>
              <input class="form-control w-100" v-model="arrDataEdit1[9]" maxlength="100" placeholder="Jabatan"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Atasan
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisiblePegawai()"
                       @blur="toggleCloseVisiblePegawai()"
                       v-model="queryPegawai"
                       v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                       @keydown.up="upPegawai"
                       @keydown.down="downPegawai"
                       @keydown.enter="selectItemPegawai"
                       placeholder="Pilih Atasan"
                >
                <div class="popovers" v-show="visiblePegawai">
                  <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesPegawai"
                          :key="index"
                          :class="{ 'selected': (selectedPegawai == index)}"
                          @click="itemClickedPegawai(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Tipe Pegawai
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleEditTipePegawai()"
                       @blur="toggleCloseVisibleEditTipePegawai()"
                       v-model="queryEditTipePegawai"
                       v-text="selectedItemEditTipePegawai ? selectedItemEditTipePegawai['text'] : ''"
                       @keydown.up="upEditTipePegawai"
                       @keydown.down="downEditTipePegawai"
                       @keydown.enter="selectItemEditTipePegawai"
                       placeholder="Pilih Tipe Pegawai"
                >
                <div class="popovers" v-show="visibleEditTipePegawai">
                  <div class="options" v-if="matchesEditTipePegawai.length != 0 && queryEditTipePegawai.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesEditTipePegawai"
                          :key="index"
                          :class="{ 'selected': (selectedEditTipePegawai == index)}"
                          @click="itemClickedEditTipePegawai(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesEditTipePegawai.length == 0 && queryEditTipePegawai.length == 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in dataEditTipePegawai"
                          :key="index"
                          :class="{ 'selected': (selectedKota == index)}"
                          @click="itemClickedEditTipePegawaiBefore(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesEditTipePegawai.length == 0 && queryEditTipePegawai.length != 0">
                    Data Tidak Ditemukan
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Tipe Role
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleEditTipeRole()"
                       @blur="toggleCloseVisibleEditTipeRole()"
                       v-model="queryEditTipeRole"
                       v-text="selectedItemEditTipeRole ? selectedItemEditTipeRole['text'] : ''"
                       @keydown.up="upEditTipeRole"
                       @keydown.down="downEditTipeRole"
                       @keydown.enter="selectItemEditTipeRole"
                       placeholder="Pilih Tipe Role"
                >
                <div class="popovers" v-show="visibleEditTipeRole">
                  <div class="options" v-if="matchesEditTipeRole.length != 0 && queryEditTipeRole.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesEditTipeRole"
                          :key="index"
                          :class="{ 'selected': (selectedEditTipeRole == index)}"
                          @click="itemClickedEditTipeRole(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesEditTipeRole.length == 0 && queryEditTipeRole.length == 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in dataEditTipeRole"
                          :key="index"
                          :class="{ 'selected': (selectedKota == index)}"
                          @click="itemClickedEditTipeRoleBefore(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesEditTipeRole.length == 0 && queryEditTipeRole.length != 0">
                    Data Tidak Ditemukan
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Wajib GPS
              </label>
              <model-select :options="dataWajibGPS"
                            class="form-control model-select"
                            v-model="wajibGPS"
                            placeholder="Pilih Wajib GPS">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Hide WFH
              </label>
              <model-select :options="dataHideWFH"
                            class="form-control model-select"
                            v-model="hideWFH"
                            placeholder="Pilih Hide WFH">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Aktif
              </label>
              <model-select :options="dataAktif"
                            class="form-control model-select"
                            v-model="aktif"
                            placeholder="Pilih Aktif Account">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Radius Pegawai (meter)
              </label>
              <input class="form-control w-100" v-model="arrDataEdit1[13]" placeholder="Radius Pegawai"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-if="disEditJenjang == false || disEditPjtk == false">
            <CCol v-if="disEditJenjang == false" sm="6">
              <label class="params">
                Jenjang Jabatan
              </label>
              <model-select :options="dataJenjang"
                            class="form-control model-select"
                            v-model="jenjang"
                            placeholder="Pilih Jenjang Jabatan">
              </model-select>
            </CCol>
            <CCol v-if="disEditPjtk == false" sm="6">
              <label class="params">
                Penyedia Jasa Tenaga Kerja (PJTK)
              </label>
              <model-select :options="dataPJTK"
                            class="form-control model-select"
                            v-model="pjtk"
                            placeholder="Pilih PJTK">
              </model-select>
            </CCol>
            <CCol v-if="disEditPjtk == false && tokenRole== 'Y'" sm="6">
              <label class="params">
                Harga Satuan TAD
              </label>
              <input class="form-control w-100" @input="rupiahMode()" v-model="hargaSatuan"
                     placeholder="Harga Satuan TAD"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Sync Offline
              </label>
              <model-select :options="dataSync"
                            class="form-control model-select"
                            v-model="sync"
                            placeholder="Pilih Sync Offline">
              </model-select>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '1'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="3">
              <label class="params">
                Tempat Lahir
              </label>
              <input class="form-control w-100" v-model="arrDataEdit2[0]" placeholder="Tempat Lahir"/>
            </CCol>
            <CCol sm="3">
              <label class="params">
                Tanggal Lahir
              </label>
              <input type="date" :max="now" class="form-control w-100" v-model="arrDataEdit2[1]"
                     placeholder="Tanggal Lahir"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Agama
              </label>
              <model-select :options="dataAgama"
                            class="form-control model-select"
                            v-model="agama"
                            placeholder="Pilih Agama">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Jenis Kelamin
              </label>
              <model-select :options="dataSex"
                            class="form-control model-select"
                            v-model="sex"
                            placeholder="Pilih Jenis Kelamin">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Status
              </label>
              <model-select :options="dataMarrige"
                            class="form-control model-select"
                            v-model="marrige"
                            placeholder="Pilih Status">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Ijasah Terakhir
              </label>
              <model-select :options="dataIjasah"
                            class="form-control model-select"
                            v-model="ijasah"
                            placeholder="Pilih Ijasah">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Tanggal Berakhir Kontrak
              </label>
              <input type="date" class="form-control w-100" v-model="arrDataEdit2[6]" placeholder="Tanggal Berakhir"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'SMA/SMK/Setingkat'">
            <CCol sm="6">
              <label class="params">
                Nama Sekolah Menengah Atas (SMA)
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[12]"
                     placeholder="Sekolah Menengah Atas"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Jurusan Sekolah Menengah Atas (SMA)
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[13]"
                     placeholder="Sekolah Menengah Atas"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'D1'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas D1
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[14]"
                     placeholder="Nama Universitas D1"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan D1
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[15]" placeholder="Jurusan D1"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK D1
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[16]" placeholder="IPK D1"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'D2'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas D2
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[17]"
                     placeholder="Nama Universitas D2"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan D2
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[18]" placeholder="Jurusan D2"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK D2
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[19]" placeholder="IPK D2"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'D3'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas D3
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[20]"
                     placeholder="Nama Universitas D3"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan D3
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[21]" placeholder="Jurusan D3"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK D3
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[22]" placeholder="IPK D3"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'D4'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas D4
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[23]"
                     placeholder="Nama Universitas D4"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan D4
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[24]" placeholder="Jurusan D4"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK D4
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[25]" placeholder="IPK D4"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'S1' || ijasah.value == 'S2' || ijasah.value == 'S3'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas S1
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[26]"
                     placeholder="Nama Universitas S1"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan S1
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[27]" placeholder="Jurusan S1"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK S1
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[28]" placeholder="IPK S1"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'S2' || ijasah.value == 'S3'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas S2
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[29]"
                     placeholder="Nama Universitas S2"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan S2
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[30]" placeholder="Jurusan S2"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK S2
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[31]" placeholder="IPK S2"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-show="ijasah.value == 'S3'">
            <CCol sm="6">
              <label class="params">
                Nama Universitas S3
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[32]"
                     placeholder="Nama Universitas S3"/>
            </CCol>
            <CCol sm="4">
              <label class="params">
                Jurusan S3
              </label>
              <input type="text" class="form-control w-100" v-model="arrDataEdit2[33]" placeholder="Jurusan S3"/>
            </CCol>
            <CCol sm="2">
              <label class="params">
                IPK S3
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 46 && event.charCode <= 57))"
                  class="form-control w-100" v-model="arrDataEdit2[34]" placeholder="IPK S3"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Golongan Darah
              </label>
              <model-select :options="dataGolonganDarah"
                            class="form-control model-select"
                            v-model="golonganDarah"
                            placeholder="Pilih Golongan Darah">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Negara
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleNegara()"
                       @blur="toggleCloseVisibleNegara()"
                       v-text="selectedItemNegara ? selectedItemNegara['text'] : ''"
                       v-model="queryNegara"
                       @keydown.up="upNegara"
                       @keydown.down="downNegara"
                       @keydown.enter="selectItemNegara"
                       placeholder="Pilih Negara"
                >
                <div class="popovers" v-show="visibleNegara">
                  <div class="options" v-if="matchesNegara.length != 0 && queryNegara.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesNegara"
                          :key="index"
                          :class="{ 'selected': (selectedNegara == index)}"
                          @click="itemClickedNegara(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesNegara.length == 0 && queryNegara.length == 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in dataNegara"
                          :key="index"
                          :class="{ 'selected': (selectedNegara == index)}"
                          @click="itemClickedNegaraBefore(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesNegara.length == 0 && queryNegara.length != 0">
                    Data Tidak Ditemukan
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Nama Ibu Kandung
              </label>
              <input class="form-control w-100" v-model="arrDataEdit2[9]" placeholder="Nama Ibu Kandung"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Periode GPS Tracking (Menit)
              </label>
              <model-select :options="dataGpsInterval"
                            v-if="arrDataEdit1[17] != 'Y'"
                            :isDisabled="true"
                            class="form-control model-select"
                            v-model="gpsInterval"
                            placeholder="Pilih Periode GPS Interval">
              </model-select>
              <model-select :options="dataGpsInterval"
                            v-else
                            class="form-control model-select"
                            v-model="gpsInterval"
                            placeholder="Pilih Periode GPS Interval">
              </model-select>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '2'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                No Handphone
              </label>
              <input class="form-control w-100" v-model="arrDataEdit3[0]" placeholder="No Telepon"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                No Whatsapp
              </label>
              <input class="form-control w-100" v-model="arrDataEdit3[1]" placeholder="No Whatsapp"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Email
              </label>
              <input class="form-control w-100" v-model="arrDataEdit3[4]" placeholder="Email"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Username By
              </label>
              <model-select :options="dataUsernameBy"
                            class="form-control model-select"
                            v-model="usernameBy"
                            placeholder="Pilih Username By">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Alamat Lengkap KTP
              </label>
              <textarea class="form-control w-100" v-model="arrDataEdit3[3]" placeholder="Alamat Lengkap KTP"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Alamat Lengkap Domisili
              </label>
              <textarea class="form-control w-100" v-model="arrDataEdit3[7]" placeholder="Alamat Lengkap Domisili"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '3'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Nama Lengkap
              </label>
              <input class="form-control w-100" maxlength="50" v-model="arrDataEdit1[4]" placeholder="Nama Lengkap"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Nama Panggilan (Alias)
              </label>
              <input class="form-control w-100" maxlength="20" v-model="arrDataEdit1[5]" placeholder="Nama Panggilan"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '4'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Tipe Seragam Pertama
              </label>
              <model-select :options="dataTipeSeragam"
                            class="form-control model-select"
                            v-model="fut"
                            placeholder="Tipe Seragam Pertama">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Ukuran Seragam Pertama
              </label>
              <model-select :options="dataUkuranSeragam"
                            class="form-control model-select"
                            v-model="fus"
                            placeholder="Ukuran Seragam Pertama">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Tipe Seragam Kedua
              </label>
              <model-select :options="dataTipeSeragam"
                            class="form-control model-select"
                            v-model="sut"
                            placeholder="Tipe Seragam Kedua">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Ukuran Seragam Kedua
              </label>
              <model-select :options="dataUkuranSeragam"
                            class="form-control model-select"
                            v-model="sus"
                            placeholder="Ukuran Seragam Kedua">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Tipe Seragam Olahraga
              </label>
              <model-select :options="dataTipeSeragam"
                            class="form-control model-select"
                            v-model="st"
                            placeholder="Tipe Seragam Olahraga">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Ukuran Seragam Olahraga
              </label>
              <model-select :options="dataUkuranSeragam"
                            class="form-control model-select"
                            v-model="ss"
                            placeholder="Ukuran Seragam Olahraga">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Hijab
              </label>
              <model-select :options="dataHijabSeragam"
                            class="form-control model-select"
                            v-model="hijab"
                            placeholder="Hijab">
              </model-select>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '5'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Tipe Pola Absensi
              </label>
              <model-select :options="dataPolaAbsensi"
                            class="form-control model-select"
                            v-model="polaAbsensi"
                            placeholder="Pilih Pola Absensi">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Shift Ke-
              </label>
              <model-select :options="dataShiftKe"
                            :isDisabled="true"
                            v-if="polaAbsensi.value == '1'"
                            class="form-control model-select"
                            v-model="shiftAktif"
                            placeholder="Pilih Shift Ke-">
              </model-select>
              <model-select :options="dataShiftKe"
                            v-else
                            class="form-control model-select"
                            v-model="shiftAktif"
                            placeholder="Pilih Shift Ke-">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params">
                Kode Pola Absensi
              </label>
              <model-select :options="dataNormalOrShift"
                            class="form-control model-select"
                            v-model="kodePolaAbsensi"
                            placeholder="Pilih Kode Absensi">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Tanggal Mulai Kehadiran
              </label>
              <input type="date" class="form-control w-100" v-model="tanggalAktifKehadiran"
                     placeholder="Tanggal Mulai Kehadiran"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '6'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Nama Kantor
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleKantor()"
                       @blur="toggleCloseVisibleKantor()"
                       v-text="selectedItemKantor ? selectedItemKantor['text'] : ''"
                       v-model="queryKantor"
                       @keydown.up="upKantor"
                       @keydown.down="downKantor"
                       @keydown.enter="selectItemKantor"
                       placeholder="Pilih Kantor"
                >
                <div class="popovers" v-show="visibleKantor">
                  <div class="options" v-if="matchesKantor.length != 0 && queryKantor.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesKantor"
                          :key="index"
                          :class="{ 'selected': (selectedKantor == index)}"
                          @click="itemClickedKantor(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesKantor.length == 0 && queryKantor.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesKantor.length == 0 && queryKantor.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Tanggal Expired
              </label>
              <input type="date" class="form-control w-100" v-model="tanggalExpired" placeholder="Tanggal Expired"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '7'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Nama Lengkap
              </label>
              <input class="form-control w-100" v-model="namaKeluarga" placeholder="Nama Lengkap"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Tanggal Lahir
              </label>
              <input type="date" :max="now" class="form-control w-100" v-model="tanggalKeluargaLahir"
                     placeholder="Tanggal Lahir"/>
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="6">
              <label class="params">
                Tipe Keluarga
              </label>
              <model-select isDisabled :options="dataTipeKeluarga"
                            class="form-control model-select"
                            v-model="tipeKeluarga"
                            placeholder="Pilih Tipe Keluarga">
              </model-select>
            </CCol>
            <CCol sm="6" v-if="tipeKeluarga.value == 'S'">
              <label class="params">
                Tanggal Menikah
              </label>
              <input type="date" class="form-control w-100" v-model="tanggalKeluargaMenikah"
                     placeholder="Tanggal Menikah"/>
            </CCol>
          </CRow>
          <CRow v-if="tokenOrganisasi == 'AA'" class="mt-2">
            <CCol sm="6">
              <label class="params">
                Nomor Admedika
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  x class="form-control w-100" v-model="editNoAdmedika" placeholder="Nomor Admedika"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '8'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="3">
              Nama Device
            </CCol>
            <CCol sm="9">
              : {{ namaDevice }}
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="3">
              Tipe Device
            </CCol>
            <CCol sm="9">
              : {{ tipeDevice }}
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="3">
              Device ID
            </CCol>
            <CCol sm="9">
              : {{ deviceId }}
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '9'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label class="params">
                Nomor Pokok Wajib Pajak(NPWP)
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[0]" placeholder="NPWP"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Nomor Kartu Tanda Penduduk(KTP)
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[1]" placeholder="KTP"/>
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="6">
              <label class="params">
                Nomor BPJS Kesehatan
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[2]" placeholder="Nomor BPJS Kesehatan"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Nomor BPJS Ketenagakerjaan
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[3]" placeholder="Nomor BPJS Ketenagakerjaan"/>
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="6">
              <label class="params">
                Nomor Rekening DPLK
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[4]" placeholder="Nomor DPLK"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Nama Bank DPLK
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[5]" placeholder="Bank DPLK"/>
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="6">
              <label class="params">
                Nomor Rekening Payroll
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[6]" placeholder="Nomor Rekening Payroll"/>
            </CCol>
            <CCol sm="6">
              <label class="params">
                Nama Bank Payroll
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[7]" placeholder="Bank Payroll"/>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="tokenOrganisasi == 'AA'">
            <CCol sm="6">
              <label class="params">
                Nomor Kartu AdMedika
              </label>
              <input class="form-control w-100" v-model="arrDataEdit9[8]" placeholder="AdMedika"/>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '10'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="6">
              <label>Foto KTP</label>
              <div v-if="urlImageFotoKtp == '' || urlImageFotoKtp == 'null'">
                <input @change="onFileChangeEditFotoKtp" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoKtp" width="56" height="56"/>
                <button @click="editRemoveImage('ktp')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto Kartu Keluarga</label>
              <div v-if="urlImageFotoKk == '' || urlImageFotoKk == 'null'">
                <input @change="onFileChangeEditFotoKk" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoKk" width="56" height="56"/>
                <button @click="editRemoveImage('kk')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5" v-show="arrData2[5] == 'S2' || arrData2[5] == 'S3'">
            <CCol sm="6">
              <label>Foto Ijasah S1</label>
              <div v-if="urlImageFotoIjasah1 == '' || urlImageFotoIjasah1 == 'null'">
                <input @change="onFileChangeEditFotoIjasah1" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoIjasah1" width="56" height="56"/>
                <button @click="editRemoveImage('ijasah1')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6" v-show="arrData2[5] == 'S3'">
              <label>Foto Ijasah S2</label>
              <div v-if="urlImageFotoIjasah2 == '' || urlImageFotoIjasah2 == 'null'">
                <input @change="onFileChangeEditFotoIjasah2" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoIjasah2" width="56" height="56"/>
                <button @click="editRemoveImage('ijasah2')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="6">
              <label>Foto Ijasah {{ arrData2[5] }}</label>
              <div v-if="urlImageFotoIjasah3 == '' || urlImageFotoIjasah3 == 'null'">
                <input @change="onFileChangeEditFotoIjasah3" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoIjasah3" width="56" height="56"/>
                <button @click="editRemoveImage('ijasah3')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto NPWP</label>
              <div v-if="urlImageFotoNpwp == '' || urlImageFotoNpwp == 'null'">
                <input @change="onFileChangeEditFotoNpwp" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoNpwp" width="56" height="56"/>
                <button @click="editRemoveImage('npwp')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="6">
              <label>Foto Kartu BPJS Kesehatan</label>
              <div v-if="urlImageFotoBpjsKesehatan == '' || urlImageFotoBpjsKesehatan == 'null'">
                <input @change="onFileChangeEditFotoBpjsKesehatan" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoBpjsKesehatan" width="56" height="56"/>
                <button @click="editRemoveImage('bpjsKesehatan')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto Kartu BPJS Ketenagakerjaan</label>
              <div v-if="urlImageFotoBpjsKetenagakerjaan == '' || urlImageFotoBpjsKetenagakerjaan == 'null'">
                <input @change="onFileChangeEditFotoBpjsKetenagakerjaan" type="file" class="mr-2"
                       accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="urlImageFotoBpjsKetenagakerjaan" width="56" height="56"/>
                <button @click="editRemoveImage('bpjsKetenagakerjaan')" class="ml-3 btn btn-danger" size="sm">Delete
                </button>
              </div>
            </CCol>
          </CRow>
        </div>
        <div v-if="idModal == '11'" style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="12">
              <label class="params">
                Jumlah Device
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  class="form-control w-100"
                  v-model="jumlahDevice"
                  placeholder="Jumlah Device"
              />
            </CCol>
          </CRow>
        </div>
        <CRow v-if="errModal != ''" class="mt-4" style="padding-left:20px;padding-right:20px">
          <CCol sm="10">
            <span class="text-danger" style="font-size:10px">*{{ errModal }}</span>
          </CCol>
        </CRow>
        <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
          <CCol class="text-right" sm="12">
            <CButton @click="closeModal()" class="modal-buttons modal-button-cancel mr-1">Kembali</CButton>
            <CButton v-if="idModal == '10'" @click="saveImageKtp()" class="modal-buttons modal-button-simpan ml-1">
              Simpan
            </CButton>
            <CButton
                v-if="idModal == '0' || idModal == '3' || idModal == '1' || idModal == '2' || idModal == '4' || idModal == '5' || idModal == '9' || idModal == '11'"
                @click="onSubmit('')" class="modal-buttons modal-button-simpan ml-1">Simpan
            </CButton>
            <CButton v-if="idModal == '6' && createPenempatan == false" @click="onSubmitPenempatan('D')"
                     class="modal-buttons mr-1 ml-1" color="danger">Hapus
            </CButton>
            <CButton v-if="idModal == '6'" @click="onSubmitPenempatan('U')"
                     class="modal-buttons modal-button-simpan ml-1">Simpan
            </CButton>
            <CButton v-if="idModal == '7'" @click="onSubmitKeluarga()" class="modal-buttons modal-button-simpan ml-1">
              Simpan
            </CButton>
            <CButton v-if="idModal == '8'" @click="resetModal = true" class="modal-buttons modal-button-simpan ml-1">
              Reset
            </CButton>
          </CCol>
        </CRow>
      </template>
      <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="sm"
        :centered="true"
        color="white"
        :show.sync="resetModal"
        :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="headers-modal">
          <CRow>
            <CCol sm="10">
              <div>Konfirmasi Reset Device</div>
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="closeIcon" @click="resetModal = false, deviceAlasan = ''" style="cursor:pointer" width="20px"
                   height="20px"/>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #body-wrapper>
        <div style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="12">
              <label class="params">
                Alasan
              </label>
              <textarea class="form-control w-100 textarea" v-model="deviceAlasan" placeholder="Tulis Alasan"/>
            </CCol>
          </CRow>
        </div>
        <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
          <CCol class="text-right" sm="12">
            <CButton @click="resetModal = false, deviceAlasan = ''" class="modal-button-cancel mr-1">Kembali</CButton>
            <CButton @click="onSubmitDevice()" :isDisable="deviceAlasan.length == 0" class="modal-button-simpan ml-1">
              Ya, Reset
            </CButton>
          </CCol>
        </CRow>
      </template>
      <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="resetModalSchadule"
        :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="headers-modal">
          <CRow>
            <CCol sm="10">
              <div>Konfirmasi Reset Schadule WFH/WFO</div>
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="closeIcon" @click="resetModalSchadule = false" style="cursor:pointer" width="20px"
                   height="20px"/>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #body-wrapper>
        <div style="padding-right:20px;padding-left:20px">
          <CRow>
            <CCol sm="12">
              <span>Apakah anda yakin ingin mengatur ulang schadule WFH/WFO?</span>
            </CCol>
          </CRow>
        </div>
        <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
          <CCol class="text-right" sm="12">
            <CButton @click="resetModalSchadule = false" class="modal-button-cancel mr-1">Kembali</CButton>
            <CButton @click="resetSchadule()" class="modal-button-simpan ml-1">Ya, Reset</CButton>
          </CCol>
        </CRow>
      </template>
      <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="viewDocModal"
        :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="headers-modal">
          <CRow>
            <CCol sm="10">
              <div><img :src="kepegawaianIcon" width="24px" height="24px"/> Preview Dokumen</div>
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="closeIcon" @click="closeViewDocModal()" style="cursor:pointer" width="20px" height="20px"/>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #body-wrapper>
        <div style="padding: 20px; text-align: center; min-height: 400px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <iframe v-if="viewDocUrl && !viewDocIsImage" :src="viewDocUrl" style="width:100%; height: 60vh; border:none;"></iframe>
          <img v-else-if="viewDocUrl && viewDocIsImage" :src="viewDocUrl" style="max-width: 100%; max-height: 60vh;" />
          <div v-else-if="!viewDocUrl" class="text-muted mt-5">Memuat file dokumen... Mohon tunggu.</div>
        </div>
      </template>
      <template #footer-wrapper>
        <div class="text-center" style="margin-top:20px;margin-bottom:20px">
          <CButton color="primary" @click="closeViewDocModal()">Tutup</CButton>
        </div>
      </template>
    </CModal>

    <div class="add-area" v-if="areaAdd == true">
      <div class="headers-add">
        <div class="span-add">
          <span class="font-weight-bold">Tambah Karyawan</span>
        </div>
      </div>
      <div class="arrow-add">
        <div>
          <img class="mr-4" @click="areaAdd = false" style="float:left;cursor:pointer" :src="backIcon" title="kembali"
               width="20px" height="20px"/>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="kepegawaianIcon" class="mr-1" width="24px" height="24px"/>Info Kepegawaian
              </div>
            </div>
          </div>
          <div class="row no-gutters" style="margin-bottom:24px">
            <div class="col-12 text-center">
              <img v-if="addUrlImageFotoProfil == ''" :src="photo" width="200px" height="200px"
                   style="border-radius:50%;opacity: 1;background-color:#dcdcdc;"/>
              <img v-else :src="addUrlImageFotoProfil" width="200px" height="200px"
                   style="border-radius:50%;opacity: 1;background-color:#dcdcdc;"/>
              <img :src="cameraIcon" width="36px" height="36px" style="cursor:pointer;" class="image-cam-foto"/>
              <input v-on:change="onFileChangeFotoProfil" type="file" class="image-cam-foto"
                     style="width:36px;opacity:0;" accept=".jpg, .png, .bmp"/>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Nama Lengkap Pegawai<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input-add"
                  v-model.trim="$v.addNama.$model"
                  :class="{ 'is-invalid':$v.addNama.$error, 'is-valid': !$v.addNama.$invalid }"
                  placeholder="Nama Lengkap Pegawai"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                NIP<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input-add"
                  v-model.trim="$v.addNip.$model"
                  :class="{ 'is-invalid':$v.addNip.$error, 'is-valid': !$v.addNip.$invalid }"
                  placeholder="Nomor Induk Pegawai"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Divisi<span class="text-danger">*</span>
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleAddUnit()"
                       @blur="toggleCloseVisibleAddUnit()"
                       v-text="selectedItemAddUnit ? selectedItemAddUnit['text'] : ''"
                       :class="{ 'is-invalid':$v.queryAddUnit.$error, 'is-valid': !$v.queryAddUnit.$invalid }"
                       v-model.trim="$v.queryAddUnit.$model"
                       @keydown.up="upAddUnit"
                       @keydown.down="downAddUnit"
                       @keydown.enter="selectItemAddUnit"
                       placeholder="Pilih Divisi"
                >
                <div class="popovers" v-show="visibleAddUnit">
                  <div class="options" v-if="matchesAddUnit.length != 0 && queryAddUnit.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddUnit"
                          :key="index"
                          :class="{ 'selected': (selectedAddUnit == index)}"
                          @click="itemClickedAddUnit(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddUnit.length == 0 && queryAddUnit.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesAddUnit.length == 0 && queryAddUnit.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Bidang<span class="text-danger">*</span>
              </label>
              <input
                  disabled
                  class="form-control params-input-add"
                  v-model.trim="$v.addBidang.$model"
                  :class="{ 'is-invalid':$v.addBidang.$error, 'is-valid': !$v.addBidang.$invalid }"
                  placeholder="Bidang"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Jabatan<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input-add"
                  v-model.trim="$v.addJabatan.$model"
                  maxlength="100"
                  :class="{ 'is-invalid':$v.addJabatan.$error, 'is-valid': !$v.addJabatan.$invalid }"
                  placeholder="Jabatan"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Atasan<span class="text-danger">*</span>
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleAddPegawai()"
                       @blur="toggleCloseVisibleAddPegawai()"
                       v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                       :class="{ 'is-invalid':$v.queryAddPegawai.$error, 'is-valid': !$v.queryAddPegawai.$invalid }"
                       v-model.trim="$v.queryAddPegawai.$model"
                       @keydown.up="upAddPegawai"
                       @keydown.down="downAddPegawai"
                       @keydown.enter="selectItemAddPegawai"
                       placeholder="Pilih Atasan"
                >
                <div class="popovers" v-show="visibleAddPegawai">
                  <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddPegawai"
                          :key="index"
                          :class="{ 'selected': (selectedAddPegawai == index)}"
                          @click="itemClickedAddPegawai(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Tipe Pegawai<span class="text-danger">*</span>
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleAddTipePegawai()"
                       @blur="toggleCloseVisibleAddTipePegawai()"
                       v-text="selectedItemAddTipePegawai ? selectedItemAddTipePegawai['text'] : ''"
                       :class="{ 'is-invalid':$v.queryAddTipePegawai.$error, 'is-valid': !$v.queryAddTipePegawai.$invalid }"
                       v-model.trim="$v.queryAddTipePegawai.$model"
                       @keydown.up="upAddTipePegawai"
                       @keydown.down="downAddTipePegawai"
                       @keydown.enter="selectItemAddTipePegawai"
                       placeholder="Pilih Tipe Pegawai"
                >
                <div class="popovers" v-show="visibleAddTipePegawai">
                  <div class="options" v-if="matchesAddTipePegawai.length != 0 && queryAddTipePegawai.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddTipePegawai"
                          :key="index"
                          :class="{ 'selected': (selectedAddTipePegawai == index)}"
                          @click="itemClickedAddTipePegawai(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddTipePegawai.length == 0 && queryAddTipePegawai.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesAddTipePegawai.length == 0 && queryAddTipePegawai.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Tipe Role Aplikasi<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddRole"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddRole.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddRole.$error, 'is-valid select-valid': !$v.selectedAddRole.$invalid }"
                            placeholder="Pilih Role">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Radius (meter)
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  class="form-control params-input-add"
                  v-model="addRadius"
                  placeholder="Radius"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Nama Alias
              </label>
              <input
                  class="form-control params-input-add"
                  v-model="addNamaAlias"
                  placeholder="Nama Alias"/>
            </CCol>
          </CRow>
          <CRow v-if="disAddPjtk == false || disAddJenjang == false" class="mt-3">
            <CCol sm="6" v-if="disAddPjtk == false">
              <label class="params-add">
                Penyedia Jasa Tenaga Kerja (PJTK)
              </label>
              <model-select :options="addDataPJTK"
                            class="form-control model-select"
                            v-model="addPJTK"
                            placeholder="Pilih PJTK">
              </model-select>
            </CCol>
            <CCol sm="6" v-if="disAddJenjang == false">
              <label class="params-add">
                Jenjang Jabatan
              </label>
              <model-select :options="addDataJenjang"
                            class="form-control model-select"
                            v-model="addJenjang"
                            placeholder="Pilih Jenjang Jabatan">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="sekilasIcon" class="mr-1" width="24px" height="24px"/>Sekilas
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Tempat Tanggal Lahir
              </label>
              <CRow>
                <CCol sm="5">
                  <input v-model="addTempatLahir" class="form-control params-input-add" placeholder="Tempat Lahir"/>
                </CCol>
                <CCol sm="7">
                  <input type="text" onfocus="(this.type='date')" :max="now" onblur="(this.type='text')"
                         v-model="addTanggalLahir" placeholder="Tanggal Lahir" class="form-control params-input-add"/>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Status<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddStatus"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddStatus.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddStatus.$error, 'is-valid select-valid': !$v.selectedAddStatus.$invalid }"
                            placeholder="Pilih Status">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Golongan Darah
              </label>
              <model-select :options="dataAddGolonganDarah"
                            class="form-control model-select"
                            v-model="selectedAddGolonganDarah"
                            placeholder="Pilih Golongan Darah">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Agama
              </label>
              <model-select :options="dataAddAgama"
                            class="form-control model-select"
                            v-model="selectedAddAgama"
                            placeholder="Pilih Agama">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Jenis Kelamin<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddJenisKelamin"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddJenisKelamin.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddJenisKelamin.$error, 'is-valid select-valid': !$v.selectedAddJenisKelamin.$invalid }"
                            placeholder="Pilih Jenis Kelamin">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Ijasah Terakhir
              </label>
              <model-select :options="dataAddIjasah"
                            class="form-control model-select"
                            v-model="selectedAddIjasah"
                            placeholder="Pilih Ijasah">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Tanggal Berakhir Kontrak<span class="text-danger">*</span>
              </label>
              <input
                  type="text"
                  :disabled="checkTanggalBerakhir == true"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                  v-model.trim="$v.addBerakhirKontrak.$model"
                  :class="{ 'is-invalid':$v.addBerakhirKontrak.$error, 'is-valid': !$v.addBerakhirKontrak.$invalid }"
                  class="form-control params-input-add"
                  placeholder="Tanggal Berakhir"/>
              <div class="mt-2">
                <input type="checkbox" v-model="checkTanggalBerakhir" id="tanggalBerakhir" name="tanggalBerakhir">
                <label class="ml-2" style="color:rgba(154, 154, 154, 1);" for="tanggalBerakhir">Pegawai Tetap</label>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Negara Asal
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleAddNegara()"
                       @blur="toggleCloseVisibleAddNegara()"
                       v-text="selectedItemAddNegara ? selectedItemAddNegara['text'] : ''"
                       v-model="queryAddNegara"
                       @keydown.up="upAddNegara"
                       @keydown.down="downAddNegara"
                       @keydown.enter="selectItemAddNegara"
                       placeholder="Pilih Negara"
                >
                <div class="popovers" v-show="visibleAddNegara">
                  <div class="options" v-if="matchesAddNegara.length != 0 && queryAddNegara.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddNegara"
                          :key="index"
                          :class="{ 'selected': (selectedAddNegara == index)}"
                          @click="itemClickedAddNegara(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddNegara.length == 0 && queryAddNegara.length == 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in dataAddNegara"
                          :key="index"
                          :class="{ 'selected': (selectedAddNegara == index)}"
                          @click="itemClickedAddNegaraBefore(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddNegara.length == 0 && queryAddNegara.length != 0">
                    Data Tidak Ditemukan
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="kontakIcon" class="mr-1" width="24px" height="24px"/>Info Kontak
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                No Handphone<span class="text-danger">*</span>
              </label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  class="form-control params-input-add"
                  v-model.trim="$v.addTelp.$model"
                  :class="{ 'is-invalid':$v.addTelp.$error, 'is-valid': !$v.addTelp.$invalid }"
                  placeholder="Masukkan No Handphone"/>
              <div class="mt-2">
                <input type="checkbox" v-model="checkWa" id="wa" name="wa">
                <label class="ml-2" style="color:rgba(154, 154, 154, 1);" for="wa">Sama Dengan No Whatsapp</label>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Username By<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddUsernameBy"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddUsernameBy.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddUsernameBy.$error, 'is-valid select-valid': !$v.selectedAddUsernameBy.$invalid }"
                            placeholder="Pilih Username By">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                No Whatsapp
              </label>
              <input :disabled="checkWa == true" v-model="addWa" class="form-control params-input-add"
                     placeholder="Masukkan No Whatsapp"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Email<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input-add"
                  :onkeyup="this.addEmail = this.addEmail.toLowerCase()"
                  style="text-transform: lowercase"
                  v-model.trim="$v.addEmail.$model"
                  :class="{ 'is-invalid':$v.addEmail.$error, 'is-valid': !$v.addEmail.$invalid }"
                  placeholder="Masukkan Email"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Validasi Email<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input-add"
                  v-model.trim="$v.addValidasiEmail.$model"
                  :class="{ 'is-invalid':$v.addValidasiEmail.$error, 'is-valid': !$v.addValidasiEmail.$invalid }"
                  placeholder="Masukan Validasi Email"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Username
              </label>
              <input disabled v-model="addUsername" class="form-control params-input-add" placeholder="Username"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Alamat Lengkap KTP<span class="text-danger">*</span>
              </label>
              <CRow>
                <CCol sm="6">
                  <div class="autocomplete">
                    <input type="text"
                           :class="{ 'is-invalid':$v.queryAddProvinsi.$error, 'is-valid': !$v.queryAddProvinsi.$invalid }"
                           class="form-control"
                           @click="toggleVisibleAddProvinsi()"
                           @blur="toggleCloseVisibleAddProvinsi()"
                           v-text="selectedItemAddProvinsi ? selectedItemAddProvinsi['text'] : ''"
                           v-model.trim="$v.queryAddProvinsi.$model"
                           @keydown.up="upAddProvinsi"
                           @keydown.down="downAddProvinsi"
                           @keydown.enter="selectItemAddProvinsi"
                           placeholder="Pilih Provinsi"
                    >
                    <div class="popovers" v-show="visibleAddProvinsi">
                      <div class="options" v-if="matchesAddProvinsi.length != 0 && queryAddProvinsi.length != 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in matchesAddProvinsi"
                              :key="index"
                              :class="{ 'selected': (selectedAddProvinsi == index)}"
                              @click="itemClickedAddProvinsi(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddProvinsi.length == 0 && queryAddProvinsi.length != 0">
                        Data Tidak Ditemukan
                      </div>
                      <div class="options" v-if="matchesAddProvinsi.length == 0 && queryAddProvinsi.length == 0">
                        Start Typing...
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol sm="6">
                  <div class="autocomplete">
                    <input type="text"
                           :disabled="queryAddProvinsi.length == 0"
                           :class="{ 'is-invalid':$v.queryAddKota.$error, 'is-valid': !$v.queryAddKota.$invalid }"
                           class="form-control"
                           @click="toggleVisibleAddKota()"
                           @blur="toggleCloseVisibleAddKota()"
                           v-text="selectedItemAddKota ? selectedItemAddKota['text'] : ''"
                           v-model.trim="$v.queryAddKota.$model"
                           @keydown.up="upAddKota"
                           @keydown.down="downAddKota"
                           @keydown.enter="selectItemAddKota"
                           placeholder="Pilih Kota"
                    >
                    <div class="popovers" v-show="visibleAddKota">
                      <div class="options" v-if="matchesAddKota.length != 0 && queryAddKota.length != 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in matchesAddKota"
                              :key="index"
                              :class="{ 'selected': (selectedAddKota == index)}"
                              @click="itemClickedAddKota(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKota.length == 0 && queryAddKota.length == 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in dataAddKota"
                              :key="index"
                              :class="{ 'selected': (selectedAddKota == index)}"
                              @click="itemClickedAddKotaBefore(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKota.length == 0 && queryAddKota.length != 0">
                        Data Tidak Ditemukan
                      </div>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow class="mt-2">
                <CCol sm="6">
                  <div class="autocomplete">
                    <input type="text"
                           :disabled="queryAddKota.length == 0"
                           :class="{ 'is-invalid':$v.queryAddKecamatan.$error, 'is-valid': !$v.queryAddKecamatan.$invalid }"
                           class="form-control"
                           @click="toggleVisibleAddKecamatan()"
                           @blur="toggleCloseVisibleAddKecamatan()"
                           v-text="selectedItemAddKecamatan ? selectedItemAddKecamatan['text'] : ''"
                           v-model.trim="$v.queryAddKecamatan.$model"
                           @keydown.up="upAddKecamatan"
                           @keydown.down="downAddKecamatan"
                           @keydown.enter="selectItemAddKecamatan"
                           placeholder="Pilih Kecamatan"
                    >
                    <div class="popovers" v-show="visibleAddKecamatan">
                      <div class="options" v-if="matchesAddKecamatan.length != 0 && queryAddKecamatan.length != 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in matchesAddKecamatan"
                              :key="index"
                              :class="{ 'selected': (selectedAddKecamatan == index)}"
                              @click="itemClickedAddKecamatan(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKecamatan.length == 0 && queryAddKecamatan.length == 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in dataAddKecamatan"
                              :key="index"
                              :class="{ 'selected': (selectedAddKecamatan == index)}"
                              @click="itemClickedAddKecamatanBefore(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKecamatan.length == 0 && queryAddKecamatan.length != 0">
                        Data Tidak Ditemukan
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol sm="6">
                  <div class="autocomplete">
                    <input type="text"
                           :disabled="queryAddKecamatan.length == 0"
                           :class="{ 'is-invalid':$v.queryAddKelurahan.$error, 'is-valid': !$v.queryAddKelurahan.$invalid }"
                           class="form-control"
                           @click="toggleVisibleAddKelurahan()"
                           @blur="toggleCloseVisibleAddKelurahan()"
                           v-text="selectedItemAddKelurahan ? selectedItemAddKelurahan['text'] : ''"
                           v-model.trim="$v.queryAddKelurahan.$model"
                           @keydown.up="upAddKelurahan"
                           @keydown.down="downAddKelurahan"
                           @keydown.enter="selectItemAddKelurahan"
                           placeholder="Pilih Kelurahan"
                    >
                    <div class="popovers" v-show="visibleAddKelurahan">
                      <div class="options" v-if="matchesAddKelurahan.length != 0 && queryAddKelurahan.length != 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in matchesAddKelurahan"
                              :key="index"
                              :class="{ 'selected': (selectedAddKelurahan == index)}"
                              @click="itemClickedAddKelurahan(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKelurahan.length == 0 && queryAddKelurahan.length == 0"
                           ref="optionsList">
                        <ul>
                          <li v-for="(match, index) in dataAddKelurahan"
                              :key="index"
                              :class="{ 'selected': (selectedAddKelurahan == index)}"
                              @click="itemClickedAddKelurahanBefore(index)"
                              v-text="match['text']"></li>
                        </ul>
                      </div>
                      <div class="options" v-if="matchesAddKelurahan.length == 0 && queryAddKelurahan.length != 0">
                        Data Tidak Ditemukan
                      </div>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow class="mt-2">
                <CCol sm="12">
                                <textarea
                                    class="form-control params-input-add"
                                    style="backgorund-color:#f9fafc"
                                    v-model.trim="$v.addAlamat.$model"
                                    :class="{ 'is-invalid':$v.addAlamat.$error, 'is-valid': !$v.addAlamat.$invalid }"
                                    placeholder="Tulis No. Rumah, Blok, RT/RW"/>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Alamat Lengkap Domisili<span class="text-danger">*</span>
              </label>
              <textarea
                  class="form-control params-input-add"
                  style="backgorund-color:#f9fafc"
                  v-model="addAlamatDomisili"
                  placeholder="Tulis No. Rumah, Blok, RT/RW, Kelurahan, Kecamatan, Kabupaten/Kota, Provinsi"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="penempatanIcon" class="mr-1 mb-1" width="24px" height="24px"/>Penempatan Kerja
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Lokasi<span class="text-danger">*</span>
              </label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleAddKantor()"
                       @blur="toggleCloseVisibleAddKantor()"
                       :class="{ 'is-invalid':$v.queryAddKantor.$error, 'is-valid': !$v.queryAddKantor.$invalid }"
                       v-model.trim="$v.queryAddKantor.$model"
                       v-text="selectedItemAddKantor ? selectedItemAddKantor['text'] : ''"
                       @keydown.up="upAddKantor"
                       @keydown.down="downAddKantor"
                       @keydown.enter="selectItemAddKantor"
                       placeholder="Pilih Lokasi Kantor"
                >
                <div class="popovers" v-show="visibleAddKantor">
                  <div class="options" v-if="matchesAddKantor.length != 0 && queryAddKantor.length != 0"
                       ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddKantor"
                          :key="index"
                          :class="{ 'selected': (selectedAddKantor == index)}"
                          @click="itemClickedAddKantor(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddKantor.length == 0 && queryAddKantor.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesAddKantor.length == 0 && queryAddKantor.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Tanggal Expired Penempatan<span class="text-danger">*</span>
              </label>
              <input
                  type="text"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                  v-model.trim="$v.addTanggalExpiredPenempatan.$model"
                  :class="{ 'is-invalid':$v.addTanggalExpiredPenempatan.$error, 'is-valid': !$v.addTanggalExpiredPenempatan.$invalid }"
                  class="form-control params-input-add"
                  placeholder="Tanggal Berakhir"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="seragamIcon" class="mr-1 mb-1" width="24px" height="24px"/>Seragam 1
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Tipe
              </label>
              <model-select :options="dataAddTipeSeragam1"
                            class="form-control model-select"
                            v-model="selectedAddTipeSeragam1"
                            placeholder="Pilih Tipe Seragam 1">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Ukuran
              </label>
              <model-select :options="dataAddSizeSeragam1"
                            class="form-control model-select"
                            v-model="selectedAddSizeSeragam1"
                            placeholder="Pilih Ukuran Seragam 1">
              </model-select>
            </CCol>
          </CRow>
          <div class="row no-gutters mt-4">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="seragamIcon" class="mr-1 mb-1" width="24px" height="24px"/>Seragam 2
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Tipe
              </label>
              <model-select :options="dataAddTipeSeragam2"
                            class="form-control model-select"
                            v-model="selectedAddTipeSeragam2"
                            placeholder="Pilih Tipe Seragam 2">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Ukuran
              </label>
              <model-select :options="dataAddSizeSeragam2"
                            class="form-control model-select"
                            v-model="selectedAddSizeSeragam2"
                            placeholder="Pilih Ukuran Seragam 2">
              </model-select>
            </CCol>
          </CRow>
          <div class="row no-gutters mt-4">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="seragamIcon" class="mr-1 mb-1" width="24px" height="24px"/>Seragam Olahraga
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Tipe
              </label>
              <model-select :options="dataAddTipeOlahraga"
                            class="form-control model-select"
                            v-model="selectedAddTipeOlahraga"
                            placeholder="Pilih Tipe Olahraga">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Ukuran
              </label>
              <model-select :options="dataAddSizeOlahraga"
                            class="form-control model-select"
                            v-model="selectedAddSizeOlahraga"
                            placeholder="Pilih Ukuran Seragam Olahraga">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-2">
            <CCol sm="6">
              <label class="params-add">
                Hijab
              </label>
              <model-select :options="dataAddHijab"
                            class="form-control model-select"
                            v-model="selectedAddHijab"
                            placeholder="Pilih Hijab">
              </model-select>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="istriIcon" class="mr-1" width="24px" height="24px"/>Keluarga
              </div>
            </div>
          </div>
          <CRow class="mb-3" v-if="selectedAddStatus.value == '1'">
            <CCol sm="3">
              <label class="params-add">
                Nama Pasangan
              </label>
              <input v-model="addNamaPasangan" class="form-control params-input-add" placeholder="Nama Pasangan"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                No Admedika Pasangan
              </label>
              <input v-model="addNoAdmedikaPasangan"
                     onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                     class="form-control params-input-add" placeholder="Nomor Admedika"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                Tanggal Lahir Pasangan
              </label>
              <input type="text" :max="now" onfocus="(this.type='date')" onblur="(this.type='text')"
                     v-model="addTanggalLahirPasangan" class="form-control params-input-add"
                     placeholder="Tanggal Lahir Pasangan"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                Tanggal Menikah
              </label>
              <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" v-model="addTanggalMenikah"
                     class="form-control params-input-add" placeholder="Tanggal Menikah"/>
            </CCol>
          </CRow>
          <CRow class="mb-2 mt-2" v-if="selectedAddStatus.value == '1'">
            <CCol sm="6">
              <label class="params-add">
                Nama Anak Ke 1
              </label>
              <input v-model="addNamaAnak1" class="form-control params-input-add" placeholder="Nama Anak 1"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                Tanggal Lahir Anak Ke 1
              </label>
              <input type="text" :max="now" onfocus="(this.type='date')" onblur="(this.type='text')"
                     v-model="addTanggalLahirAnak1" class="form-control params-input-add"
                     placeholder="Tanggal Lahir Anak 1"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                No Admedika Anak 1
              </label>
              <input v-model="addNoAdmedikaAnak1"
                     onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                     class="form-control params-input-add" placeholder="Nomor Admedika"/>
            </CCol>
          </CRow>
          <CRow class="mb-2" v-if="selectedAddStatus.value == '1'">
            <CCol sm="6">
              <label class="params-add">
                Nama Anak Ke 2
              </label>
              <input v-model="addNamaAnak2" class="form-control params-input-add" placeholder="Nama Anak 2"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                Tanggal Lahir Anak Ke 2
              </label>
              <input type="text" :max="now" onfocus="(this.type='date')" onblur="(this.type='text')"
                     v-model="addTanggalLahirAnak2" class="form-control params-input-add"
                     placeholder="Tanggal Lahir Anak 2"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                No Admedika Anak 2
              </label>
              <input v-model="addNoAdmedikaAnak2"
                     onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                     class="form-control params-input-add" placeholder="Nomor Admedika"/>
            </CCol>
          </CRow>
          <CRow class="mb-3" v-if="selectedAddStatus.value == '1'">
            <CCol sm="6">
              <label class="params-add">
                Nama Anak Ke 3
              </label>
              <input v-model="addNamaAnak3" class="form-control params-input-add" placeholder="Nama Anak 3"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                Tanggal Lahir Anak Ke 3
              </label>
              <input type="text" :max="now" onfocus="(this.type='date')" onblur="(this.type='text')"
                     v-model="addTanggalLahirAnak3" class="form-control params-input-add"
                     placeholder="Tanggal Lahir Anak 3"/>
            </CCol>
            <CCol sm="3">
              <label class="params-add">
                No Admedika Anak 3
              </label>
              <input v-model="addNoAdmedikaAnak3"
                     onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                     class="form-control params-input-add" placeholder="Nomor Admedika"/>
            </CCol>
          </CRow>
          <CRow class="mt-1">
            <CCol sm="6">
              <label class="params-add">
                Nama Ibu Kandung
              </label>
              <input v-model="addNamaIbuKandung" class="form-control params-input-add" placeholder="Nama Ibu Kandung"/>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="jadwalJamKerjaIcon" class="mr-1" width="24px" height="24px"/>Jadwal Jam Kerja
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Tanggal Mulai Aktif Kerja<span class="text-danger">*</span>
              </label>
              <input
                  class="form-control params-input"
                  type="text"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                  v-model.trim="$v.addTanggalAktif.$model"
                  :class="{ 'is-invalid':$v.addTanggalAktif.$error, 'is-valid': !$v.addTanggalAktif.$invalid }"
                  placeholder="Tanggal Mulai Aktif Kerja"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Pola Absensi<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddPolaAbsensi"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddPolaAbsensi.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddPolaAbsensi.$error, 'is-valid select-valid': !$v.selectedAddPolaAbsensi.$invalid }"
                            placeholder="Pilih Pola Absensi">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Kode Pola Absensi<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddKodePolaAbsensi"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddKodePolaAbsensi.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddKodePolaAbsensi.$error, 'is-valid select-valid': !$v.selectedAddKodePolaAbsensi.$invalid }"
                            placeholder="Pilih Kode Pola Absensi">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Shift Ke-
              </label>
              <model-select :options="dataAddShiftKe"
                            :isDisabled="true"
                            v-if="selectedAddPolaAbsensi.value == '1'"
                            class="form-control model-select"
                            v-model="selectedAddShiftKe"
                            placeholder="Pilih Shift">
              </model-select>
              <model-select :options="dataAddShiftKe"
                            v-else
                            class="form-control model-select"
                            v-model="selectedAddShiftKe"
                            placeholder="Pilih Shift">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                GPS Tracking (Fitur ini akan men-Tracking pegawai secara periodik)<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddWajibGps"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddWajibGps.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddWajibGps.$error, 'is-valid select-valid': !$v.selectedAddWajibGps.$invalid }"
                            placeholder="Pilih Wajib GPS">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Hide WFH<span class="text-danger">*</span>
              </label>
              <model-select :options="dataAddHideWfh"
                            class="form-control model-select"
                            v-model.trim="$v.selectedAddHideWfh.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedAddHideWfh.$error, 'is-valid select-valid': !$v.selectedAddHideWfh.$invalid }"
                            placeholder="Pilih Hide WFH">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol v-if="selectedAddWajibGps.value == 'Y'" sm="6">
              <label class="params-add">
                Periode GPS Tracking (Menit)
              </label>
              <model-select :options="dataAddGpsInterval"
                            class="form-control model-select"
                            v-model="selectedAddGpsInterval"
                            placeholder="Pilih Periode GPS Tracking">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Sync Offline
              </label>
              <model-select :options="dataAddSync"
                            class="form-control model-select"
                            v-model="addSync"
                            placeholder="Sync Offline">
              </model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                <img :src="deviceIcon" class="mr-1" width="24px" height="24px"/>Device<span class="text-danger">*</span>
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <CRow class="no-gutters">
                <CCol v-if="addJumlahDevice != 1 && addJumlahDevice != 0 && addJumlahDevice != ''"
                      @click="countJumlahDevice('min')" sm="1 text-center"
                      style="cursor:pointer;padding-top:4px;border: 1px solid rgba(221, 221, 221, 1);border-radius:4px">
                  <img :src="minIcon" width="20px" height="20px"/>
                </CCol>
                <CCol sm="10" class="pl-2 pr-2">
                  <input
                      class="form-control params-input text-center"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                      v-model.trim="$v.addJumlahDevice.$model"
                      :class="{ 'is-invalid':$v.addJumlahDevice.$error, 'is-valid': !$v.addJumlahDevice.$invalid }"
                      placeholder="Jumlah Device"/>
                </CCol>
                <CCol @click="countJumlahDevice('add')" sm="1 text-center"
                      style="cursor:pointer;padding-top:4px;border: 1px solid rgba(221, 221, 221, 1);border-radius:4px">
                  <img :src="plusIcon" width="20px" height="20px"/>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="12">
              <span style="font-size:10px" class="text-danger">*Wajib Diisi</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                Kelengkapan Dokumen
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label class="params-add">
                Nomor Induk Kependudukan (NIK)
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addNik"
                  placeholder="NIK"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Nomor NPWP
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addNpwp"
                  placeholder="Nomor Pokok Wajib Pajak"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Nomor BPJS Kesehatan
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addBpjsKesehatan"
                  placeholder="BPJS Kesehatan"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Nomor BPJS Ketenagakerjaan
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addBpjsKetenagakerjaan"
                  placeholder="BPJS Ketenagakerjaan"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Nomor Rekening DPLK
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addNoRekDplk"
                  placeholder="No Rekening DPLK"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Nama Bank DPLK
              </label>
              <input
                  class="form-control params-input-add"
                  v-model="addNamaBankDplk"
                  placeholder="Nama Bank DPLK"/>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label class="params-add">
                Nomor Rekening Pembayaran Gaji
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addNoRekGaji"
                  placeholder="No Rekening Gaji"/>
            </CCol>
            <CCol sm="6">
              <label class="params-add">
                Nama Bank Pembayaran Gaji
              </label>
              <input
                  class="form-control params-input-add"
                  v-model="addNamaBankGaji"
                  placeholder="Nama Bank Pembayaran Gaji"/>
            </CCol>
          </CRow>
          <CRow class="mt-3" v-if="tokenOrganisasi == 'AA'">
            <CCol sm="6">
              <label class="params-add">
                Nomor Kartu Ad Medika
              </label>
              <input
                  class="form-control params-input-add"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="addNoAdMedika"
                  placeholder="No Kartu Ad Medika"/>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="card cards-add mb-0">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="title-add font-weight-bold">
                Unggah Kelengkapan Dokumen
              </div>
            </div>
          </div>
          <CRow>
            <CCol sm="6">
              <label>Foto KTP</label>
              <div v-if="addUrlImageFotoKtp == '' || addUrlImageFotoKtp == 'null'">
                <input @change="onFileChangeFotoKtp" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoKtp" width="56" height="56"/>
                <button @click="addRemoveImage('ktp')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto Kartu Keluarga</label>
              <div v-if="addUrlImageFotoKk == '' || addUrlImageFotoKk == 'null'">
                <input @change="onFileChangeFotoKk" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoKk" width="56" height="56"/>
                <button @click="addRemoveImage('kk')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="6">
              <label>Foto NPWP</label>
              <div v-if="addUrlImageFotoNpwp == '' || addUrlImageFotoNpwp == 'null'">
                <input @change="onFileChangeFotoNpwp" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoNpwp" width="56" height="56"/>
                <button @click="addRemoveImage('npwp')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto Ijasah</label>
              <div v-if="addUrlImageFotoIjasah == '' || addUrlImageFotoIjasah == 'null'">
                <input @change="onFileChangeFotoIjasah" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoIjasah" width="56" height="56"/>
                <button @click="addRemoveImage('ijasah')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="6">
              <label>Foto Kartu BPJS Kesehatan</label>
              <div v-if="addUrlImageFotoBpjsKesehatan == '' || addUrlImageFotoBpjsKesehatan == 'null'">
                <input @change="onFileChangeFotoBpjsKesehatan" type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoBpjsKesehatan" width="56" height="56"/>
                <button @click="addRemoveImage('bpjsKesehatan')" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Foto Kartu BPJS Ketenagakerjaan</label>
              <div v-if="addUrlImageFotoBpjsKetenagakerjaan == '' || addUrlImageFotoBpjsKetenagakerjaan == 'null'">
                <input @change="onFileChangeFotoBpjsKetenagakerjaan" type="file" class="mr-2"
                       accept=".jpg, .png, .bmp"/>
              </div>
              <div v-else>
                <img :src="addUrlImageFotoBpjsKetenagakerjaan" width="56" height="56"/>
                <button @click="addRemoveImage('bpjsKetenagakerjaan')" class="ml-3 btn btn-danger" size="sm">Delete
                </button>
              </div>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="6">
              <span>*File harus .jpg, .png atau .bmp </span>
            </CCol>
          </CRow>
          <CRow class="mt-1">
            <CCol sm="6">
              <span>*File Maksimal 2MB</span>
            </CCol>
          </CRow>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="row no-gutters">
          <div v-if="errModal != ''" class="col-12 text-right">
            <span class="text-danger" style="font-size:12px">*{{ errModal }}</span>
          </div>
        </div>
      </div>
      <div class="info-kepegawaian-add">
        <div class="row no-gutters">
          <div class="col-12 text-right">
            <CButton @click="areaAdd = false" class="button-add btn-kembali-add mr-1">Kembali</CButton>
            <CButton :disabled="loadingAdd == true" @click="submitForm()" class="button-add btn-submit-add">
              <span v-if="loadingAdd == false">Submit</span>
              <CSpinner v-else color="default" size="sm"/>
            </CButton>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Tables from '../../../component/tablesPegawai'
import {DataApi, DataApiUpload} from "../../../service/DataApi"
import {ModelSelect} from 'vue-search-select'
import {email, maxLength, minLength, required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'

const xlsx = require('json-as-xlsx')

export default {
  components: {
    Tables,
    ModelSelect
  },
  mixins: [validationMixin],
  validations: {

    // MANDATORY KEPEGAWAIAN
    addNama: {
      required,
    },
    addNip: {
      required,
    },
    addJabatan: {
      required
    },
    addBidang: {
      required
    },
    queryAddUnit: {
      required
    },
    queryAddPegawai: {
      required
    },
    queryAddTipePegawai: {
      required
    },
    selectedAddRole: {
      text: {
        required
      },
      value: {
        required
      }
    },

    // MANDATORY SEKILAS
    selectedAddStatus: {
      text: {
        required
      },
      value: {
        required
      }
    },
    selectedAddJenisKelamin: {
      text: {
        required
      },
      value: {
        required
      }
    },
    addBerakhirKontrak: {
      required
    },

    // MANDATORY KONTAK
    addTelp: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(13)
    },
    addEmail: {
      required,
      email,
      maxLength: maxLength(50)
    },
    addValidasiEmail: {
      required: (function () {
        if (this.addValidasiEmail.length != 0) {
          if (this.addValidasiEmail == this.addEmail) {
            return true
          } else {
            return false
          }
        } else {
          return ''
        }
      })
    },
    selectedAddUsernameBy: {
      text: {
        required
      },
      value: {
        required
      }
    },
    queryAddProvinsi: {
      required
    },
    queryAddKota: {
      required
    },
    queryAddKecamatan: {
      required
    },
    queryAddKelurahan: {
      required
    },
    addAlamat: {
      required
    },

    // MANDATORY PENEMPATAN
    queryAddKantor: {
      required
    },
    addTanggalExpiredPenempatan: {
      required
    },

    // MANDATORY JAM KERJA
    addTanggalAktif: {
      required
    },
    selectedAddPolaAbsensi: {
      value: {
        required
      },
      text: {
        required
      }
    },
    selectedAddKodePolaAbsensi: {
      value: {
        required
      },
      text: {
        required
      }
    },
    // selectedAddShiftKe: {
    //     value: {
    //         required
    //     },
    //     text: {
    //         required
    //     }
    // },
    selectedAddWajibGps: {
      value: {
        required
      },
      text: {
        required
      }
    },
    selectedAddHideWfh: {
      value: {
        required
      },
      text: {
        required
      }
    },

    // MANDATORY DEVICE
    addJumlahDevice: {
      required
    }
  },
  data() {
    return {
      pegawaiDocumentsList: [],
      isUploadingPegawaiDoc: false,
      selectedPegawaiDocs: [],
      flagSearch: false,
      now: '',
      success: true,
      successDetail: true,
      alertMessDetail: '',
      currentAlertCounterDetail: 0,
      loadingViewDocId: null,
      viewDocModal: false,
      viewDocUrl: null,
      viewDocIsImage: false,
      itemHeight: 39,
      alertMess: '',
      currentAlertCounter: 0,
      mainValueDetail: '',
      dataStatus: [],
      filterStatus: {
        value: '',
        text: ''
      },

      // data search pegawai
      dataPegawai: [],
      titlePegawai: "Pilih Atasan",
      selectedItemPegawai: null,
      selectedPegawai: 0,
      queryPegawai: '',
      visiblePegawai: false,
      idAtasan: '',

      // data search kantor
      dataKantor: [],
      titleKantor: "Pilih Kantor",
      selectedItemKantor: null,
      selectedKantor: 0,
      queryKantor: '',
      visibleKantor: false,
      idKantor: '',

      // data search unit
      dataUnit: [],
      titleUnit: "Pilih Unit Level",
      selectedItemUnit: null,
      selectedUnit: 0,
      queryUnit: '',
      visibleUnit: false,
      idUnits: '',

      // data search unit on search bar
      dataUnitSearch: [],
      titleUnitSearch: "Pilih Unit Level",
      selectedItemUnitSearch: null,
      selectedUnitSearch: 0,
      queryUnitSearch: '',
      visibleUnitSearch: false,
      idUnitSearch: '',

      // data search Tipe Pegawai
      dataTipePegawai: [],
      titleTipePegawai: "Pilih Tipe Pegawai",
      selectedItemTipePegawai: null,
      selectedTipePegawai: 0,
      queryTipePegawai: '',
      visibleTipePegawai: false,
      kodeTipePegawai: '',

      // data search Edit Tipe Pegawai
      dataEditTipePegawai: [],
      titleEditTipePegawai: "Pilih Tipe Pegawai",
      selectedItemEditTipePegawai: null,
      selectedEditTipePegawai: 0,
      queryEditTipePegawai: '',
      visibleEditTipePegawai: false,
      kodeEditTipePegawai: '',

      // data search Edit Tipe Role
      dataEditTipeRole: [],
      titleEditTipeRole: "Pilih Tipe Role",
      selectedItemEditTipeRole: null,
      selectedEditTipeRole: 0,
      queryEditTipeRole: '',
      visibleEditTipeRole: false,
      kodeEditTipeRole: '',

      // data search edit negara
      titleNegara: "Pilih Negara",
      selectedItemNegara: null,
      selectedNegara: 0,
      queryNegara: '',
      visibleNegara: false,

      dataSex: [],
      sex: {
        value: '',
        text: ''
      },
      dataMarrige: [],
      marrige: {
        value: '',
        text: ''
      },
      dataGolonganDarah: [],
      golonganDarah: {
        value: '',
        text: ''
      },
      dataAgama: [],
      agama: {
        value: '',
        text: ''
      },
      dataIjasah: [],
      ijasah: {
        value: '',
        text: ''
      },
      dataUsernameBy: [],
      usernameBy: {
        value: '',
        text: ''
      },
      fullDataShift: [],
      dataShiftKe: [],
      shiftAktif: {
        value: '',
        text: ''
      },
      dataPolaAbsensi: [],
      polaAbsensi: {
        text: '',
        value: ''
      },
      dataJenjang: [],
      jenjang: {
        text: '',
        value: ''
      },
      dataSync: [],
      sync: {
        text: 'No',
        value: '2'
      },
      disEditJenjang: true,
      dataNormalOrShift: [],
      kodePolaAbsensi: {
        value: '',
        text: ''
      },
      tanggalAktifKehadiran: '',
      dataUkuranSeragam: [],
      fus: {
        value: '',
        text: ''
      },
      sus: {
        value: '',
        text: ''
      },
      ss: {
        value: '',
        text: ''
      },
      dataTipeSeragam: [],
      fut: {
        value: '',
        text: ''
      },
      sut: {
        value: '',
        text: ''
      },
      st: {
        value: '',
        text: ''
      },
      dataHijabSeragam: [],
      hijab: {
        value: '0',
        text: ''
      },
      dataTipeKeluarga: [],
      tipeKeluarga: {
        value: '',
        text: ''
      },
      dataWajibGPS: [],
      wajibGPS: {
        value: '',
        text: ''
      },
      dataGpsInterval: [],
      gpsInterval: {
        value: '',
        text: ''
      },
      dataHideWFH: [],
      hideWFH: {
        value: '',
        text: ''
      },
      dataAktif: [],
      aktif: {
        value: '',
        text: ''
      },
      dataPJTK: [],
      pjtk: {
        value: '',
        text: ''
      },
      photo: require('@/assets/image/images.svg'),
      hargaSatuan: '',

      sampelImage: require('@/assets/image/images.svg'),
      photoKeluargaWanita: require('@/assets/image/icon_bg_woman.png'),
      photoKeluargaPria: require('@/assets/image/icon_bg_man.png'),
      androidImage: require('@/assets/image/icon_android.png'),
      iosImage: require('@/assets/image/icon_ios.png'),
      minIcon: require('../../../assets/menu/icon_min.svg'),
      plusIcon: require('../../../assets/menu/icon_plus.svg'),

      deviceIcon: require('../../../assets/menu/icon_device.svg'),
      istriIcon: require('../../../assets/menu/icon_istri.svg'),
      jadwalJamKerjaIcon: require('../../../assets/menu/icon_jadwal_jam_kerja.svg'),
      kontakIcon: require('../../../assets/menu/icon_kontak_info.svg'),
      teamIcon: require('../../../assets/menu/icon_my_team.svg'),
      sekilasIcon: require('../../../assets/menu/icon_sekilas.svg'),
      kepegawaianIcon: require('../../../assets/menu/icon_info_kepegawaian.svg'),
      penempatanIcon: require('../../../assets/menu/icon_master_perusahaan.svg'),
      seragamIcon: require('../../../assets/menu/icon_seragam.svg'),
      editIcon: require('../../../assets/menu/icon_edit.svg'),
      pencilIcon: require('../../../assets/menu/icon_pencil.svg'),
      vaksinIcon: require('../../../assets/menu/icon_vaksin.svg'),

      refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
      cameraIcon: require('../../../assets/menu/icon_camera.svg'),
      wfhIcon: require('../../../assets/menu/icon_wfh.svg'),
      jamKeluarIcon: require('../../../assets/menu/icon_jam_keluar.svg'),
      jamMasukIcon: require('../../../assets/menu/icon_jam_masuk.svg'),
      totalJamIcon: require('../../../assets/menu/icon_total_jam_masuk.svg'),
      moreIcon: require('../../../assets/menu/icon_more.svg'),
      backIcon: require('../../../assets/menu/icon_goback.svg'),
      closeIcon: require('../../../assets/menu/icon_close.svg'),
      downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
      dataTh: ['Nama Pegawai', 'NIP', 'Email', 'Jenis Kelamin', 'Tipe', 'Divisi', 'Jabatan'],
      dataTd: [['urlFoto', 'nama'], 'nik', 'tipePegawai', 'email', 'sex', 'bidang', 'jabatan'],
      styleTable: ['150px', '100px', '100px', '120px', '80px', '140px', '120px'],
      classReload: 'reloadOff',
      detail: false,

      // paging
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      // filter
      searchValue: '',
      searchJobPosition: '',

      // datas
      datas: [],

      pegawaiID: '',
      tokenRole: '',
      tokenOrganisasi: '',
      tokenLvl: '',

      urlImage: '',
      showImage: '',

      // error
      errorMessage: '',
      errModal: '',

      menuFlag: '1',
      tanggal: new Date(),
      dataYear: [],
      dataBulan: [],
      selectedBulan: {
        value: '',
        text: ''
      },
      selectedTahun: {
        value: '',
        text: ''
      },

      arrData1: [],
      arrDataEdit1: [],
      arrData2: [],
      arrDataEdit2: [],
      tanggalExpired: '',
      editKantorID: '',
      arrData3: [],
      arrDataEdit3: [],
      arrData4: [],
      arrDataEdit4: [],
      arrData5: [],
      arrDataEdit5: [],
      editKeluargaID: '',
      namaKeluarga: '',
      tanggalKeluargaMenikah: '',
      tanggalKeluargaLahir: '',
      editNoAdmedika: '',
      arrData6: [],
      arrDataEdit6: [],
      arrData7: [],
      arrDataEdit7: [],
      arrData8: [],
      arrDataEdit8: [],
      arrData9: [],
      arrDataEdit9: [],
      arrData10: [],
      arrDataEdit10: [],
      arrData11: [],
      arrDataEdit11: [],
      arrData12: [],
      arrDataEdit12: [],
      deviceAlasan: [],
      namaDevice: '',
      tipeDevice: '',
      deviceId: '',
      arrDataTeam: [],
      totalDataTeam: '',
      idPeg: '',
      lvlTeam: '',
      dataJamKerja: [],
      tipeJamKerja: '',
      idPegawaiJamKerja: '',
      editModal: false,
      resetModal: false,
      statusSchadule: '',
      tanggalApproveSchadule: '',
      tanggalMengajukanSchadule: '',
      resetModalSchadule: false,
      idModal: '',
      createPenempatan: false,
      editJumlahDevice: '',
      jumlahDevice: '',

      // edit kelengkapan dokumen
      urlImageFotoKtp: '',
      showImageFotoKtp: '',
      urlPathFotoKtp: '',

      urlImageFotoKk: '',
      showImageFotoKk: '',
      urlPathFotoKk: '',

      urlImageFotoIjasah1: '',
      showImageFotoIjasah1: '',
      urlPathFotoIjasah1: '',
      docFotoIjasah1: '',
      docFotoIjasahEdit1: '',

      urlImageFotoIjasah2: '',
      showImageFotoIjasah2: '',
      urlPathFotoIjasah2: '',
      docFotoIjasah2: '',
      docFotoIjasahEdit2: '',

      urlImageFotoIjasah3: '',
      showImageFotoIjasah3: '',
      urlPathFotoIjasah3: '',
      docFotoIjasah3: '',
      docFotoIjasahEdit3: '',

      urlImageFotoNpwp: '',
      showImageFotoNpwp: '',
      urlPathFotoNpwp: '',

      urlImageFotoBpjsKesehatan: '',
      showImageFotoBpjsKesehatan: '',
      urlPathFotoBpjsKesehatan: '',

      urlImageFotoBpjsKetenagakerjaan: '',
      showImageFotoBpjsKetenagakerjaan: '',
      urlPathFotoBpjsKetenagakerjaan: '',


      /**
       * ADD AREA
       */
      areaAdd: false,
      loadingAdd: false,

      // Kepegawaian
      addUrlImageFotoProfil: '',
      addShowImageFotoProfil: '',
      addUrlPathFotoProfil: '',

      addNama: '',
      addNip: '',
      addJabatan: '',
      addRadius: '',
      addBidang: '',

      dataAddUnit: [],
      titleAddUnit: "Pilih Divisi",
      selectedItemAddUnit: null,
      selectedAddUnit: 0,
      queryAddUnit: '',
      visibleAddUnit: false,
      idAddUnit: '',

      dataAddPegawai: [],
      titleAddPegawai: "Pilih Atasan",
      selectedItemAddPegawai: null,
      selectedAddPegawai: 0,
      queryAddPegawai: '',
      visibleAddPegawai: false,
      idAddPegawai: '',

      dataAddTipePegawai: [],
      titleAddTipePegawai: "Pilih Tipe Pegawai",
      selectedItemAddTipePegawai: null,
      selectedAddTipePegawai: 0,
      queryAddTipePegawai: '',
      visibleAddTipePegawai: false,
      kodeAddTipePegawai: '',

      selectedAddRole: {
        value: '',
        text: ''
      },
      dataAddRole: [],

      addPJTK: {
        value: '',
        text: ''
      },
      addDataPJTK: [],

      addDataJenjang: [],
      addJenjang: {
        text: '',
        value: ''
      },
      disAddJenjang: true,

      addNamaAlias: '',

      // sekilas
      addTempatLahir: '',
      addTanggalLahir: '',

      selectedAddStatus: {
        value: '',
        text: ''
      },
      dataAddStatus: [],

      selectedAddGolonganDarah: {
        value: '',
        text: ''
      },
      dataAddGolonganDarah: [],

      selectedAddAgama: {
        value: '',
        text: ''
      },
      dataAddAgama: [],

      selectedAddJenisKelamin: {
        value: '',
        text: ''
      },
      dataAddJenisKelamin: [],

      selectedAddIjasah: {
        value: '',
        text: ''
      },
      dataAddIjasah: [],

      addBerakhirKontrak: '',
      checkTanggalBerakhir: '',

      titleAddNegara: "Pilih Negara",
      selectedItemAddNegara: null,
      selectedAddNegara: 0,
      queryAddNegara: '',
      visibleAddNegara: false,

      // kontak
      addTelp: '',
      checkWa: '',
      addWa: '',
      addEmail: '',
      addValidasiEmail: '',
      addUsername: '',
      dataAddUsernameBy: [],
      selectedAddUsernameBy: {
        text: '',
        value: ''
      },
      titleAddProvinsi: "Pilih Provinsi",
      selectedItemAddProvinsi: null,
      selectedAddProvinsi: 0,
      queryAddProvinsi: '',
      visibleAddProvinsi: false,

      titleAddKota: "Pilih Kota",
      selectedItemAddKota: null,
      selectedAddKota: 0,
      queryAddKota: '',
      visibleAddKota: false,

      titleAddKecamatan: "Pilih Kecamatan",
      selectedItemAddKecamatan: null,
      selectedAddKecamatan: 0,
      queryAddKecamatan: '',
      visibleAddKecamatan: false,

      titleAddKelurahan: "Pilih Kelurahan",
      selectedItemAddKelurahan: null,
      selectedAddKelurahan: 0,
      queryAddKelurahan: '',
      visibleAddKelurahan: false,

      addAlamat: '',
      addAlamatDomisili: '',

      // penempatan
      dataAddKantor: [],
      titleAddKantor: "Pilih AddKantor",
      selectedItemAddKantor: null,
      selectedAddKantor: 0,
      queryAddKantor: '',
      visibleAddKantor: false,
      idAddKantor: '',

      addTanggalExpiredPenempatan: '',

      // seragam
      dataAddTipeSeragam1: [],
      dataAddTipeSeragam2: [],
      dataAddTipeOlahraga: [],
      dataAddSizeSeragam1: [],
      dataAddSizeSeragam2: [],
      dataAddSizeOlahraga: [],
      dataAddHijab: [],
      selectedAddTipeSeragam1: {
        value: '',
        text: ''
      },
      selectedAddTipeSeragam2: {
        value: '',
        text: ''
      },
      selectedAddTipeOlahraga: {
        value: '',
        text: ''
      },
      selectedAddSizeSeragam1: {
        value: '',
        text: ''
      },
      selectedAddSizeSeragam2: {
        value: '',
        text: ''
      },
      selectedAddSizeOlahraga: {
        value: '',
        text: ''
      },
      selectedAddHijab: {
        value: '',
        text: ''
      },

      // keluarga
      addNamaPasangan: '',
      addTanggalLahirPasangan: '',
      addTanggalMenikah: '',
      addNamaAnak1: '',
      addNamaAnak2: '',
      addNamaAnak3: '',
      addTanggalLahirAnak1: '',
      addTanggalLahirAnak2: '',
      addTanggalLahirAnak3: '',
      addNamaIbuKandung: '',
      addNoAdmedikaPasangan: '',
      addNoAdmedikaAnak1: '',
      addNoAdmedikaAnak2: '',
      addNoAdmedikaAnak3: '',
      addKeluargaStatus: 'U',

      // jam kerja
      addTanggalAktif: '',

      dataAddPolaAbsensi: [],
      selectedAddPolaAbsensi: {
        value: '',
        text: ''
      },

      dataAddKodePolaAbsensi: [],
      selectedAddKodePolaAbsensi: {
        value: '',
        text: ''
      },

      dataAddShiftKe: [],
      selectedAddShiftKe: {
        value: '',
        text: ''
      },
      addTempShift: [],

      dataAddWajibGps: [],
      selectedAddWajibGps: {
        value: '',
        text: ''
      },

      dataAddGpsInterval: [],
      selectedAddGpsInterval: {
        value: '',
        text: ''
      },

      dataAddHideWfh: [],
      selectedAddHideWfh: {
        value: '',
        text: ''
      },
      dataAddSync: [],
      addSync: {
        value: '2',
        text: 'No'
      },

      // device
      addJumlahDevice: 1,

      // kelengkapan dokumen
      addNik: '',
      addNpwp: '',
      addBpjsKesehatan: '',
      addBpjsKetenagakerjaan: '',
      addNoRekDplk: '',
      addNamaBankDplk: '',
      addNoRekGaji: '',
      addNamaBankGaji: '',
      addNoAdMedika: '',

      // unggah kelengkapan dokumen
      addUrlImageFotoKtp: '',
      addShowImageFotoKtp: '',
      addUrlPathFotoKtp: '',

      addUrlImageFotoKk: '',
      addShowImageFotoKk: '',
      addUrlPathFotoKk: '',

      addUrlImageFotoIjasah: '',
      addShowImageFotoIjasah: '',
      addUrlPathFotoIjasah: '',

      addUrlImageFotoNpwp: '',
      addShowImageFotoNpwp: '',
      addUrlPathFotoNpwp: '',

      addUrlImageFotoBpjsKesehatan: '',
      addShowImageFotoBpjsKesehatan: '',
      addUrlPathFotoBpjsKesehatan: '',

      addUrlImageFotoBpjsKetenagakerjaan: '',
      addShowImageFotoBpjsKetenagakerjaan: '',
      addUrlPathFotoBpjsKetenagakerjaan: '',

      disAddPjtk: true,
      disEditPjtk: true,
    }
  },
  watch: {
    page() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    detail() {
      if (this.detail == false) {
        this.getData()
      }
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    searchValue() {
      this.flagSearch = true
    },
    searchJobPosition() {
      this.flagSearch = true
    },
    menuFlag() {
      window.scroll({
        top: 50,
        left: 0,
        behavior: 'smooth'
      });
    },
    queryPegawai() {
      if (this.queryPegawai == '') {
        this.idAtasan = ''
      }
      this.getDataPegawai('null')
    },
    queryUnit() {
      this.getDataUnit('null')
    },
    queryUnitSearch() {
      if (this.queryUnitSearch == '') {
        this.idUnitSearch = ''
      }
      this.flagSearch = true
      this.getDataUnitSerach()
    },
    filterStatus() {
      this.flagSearch = true
    },
    queryKantor() {
      this.getDataKantor('null')
    },
    polaAbsensi() {
      this.kodePolaAbsensi.value = ''
      this.kodePolaAbsensi.text = ''
      this.getNormalOrShift()
    },
    kodePolaAbsensi() {
      this.getDataShiftKe('null')
    },
    queryTipePegawai() {
      this.flagSearch = true
      if (this.queryTipePegawai == '') {
        this.kodeTipePegawai = ''
      }
      this.getDataTipePegawai()
    },
    queryEditTipePegawai() {
      if (this.queryEditTipePegawai == '') {
        this.kodeEditTipePegawai = ''
        this.disEditPjtk = true
      }
      this.getDataEditTipePegawai('null')
    },
    queryEditTipeRole() {
      if (this.queryEditTipeRole == '') {
        this.kodeEditTipeRole = ''
      }
      this.getDataEditTipeRole('null')
    },
    queryAddUnit() {
      if (this.queryAddUnit == '') {
        this.addBidang = ''
        this.idAddUnit = ''
      }
      this.getDataAddUnit()
    },
    queryAddPegawai() {
      if (this.queryAddPegawai == '') {
        this.idAddPegawai = ''
      }
      this.getDataAddPegawai()
    },
    queryAddTipePegawai() {
      if (this.queryAddTipePegawai == '') {
        this.kodeAddTipePegawai = ''
      }
      this.getDataAddTipePegawai()
    },
    checkWa() {
      if (this.checkWa == true) {
        this.addWa = this.addTelp
      } else {
        this.addWa = ''
      }
    },
    checkTanggalBerakhir() {
      if (this.checkTanggalBerakhir == true) {
        this.addBerakhirKontrak = '9999-12-31'
      } else {
        this.addBerakhirKontrak = ''
      }
    },
    addEmail() {
      if (this.$v.addEmail.$invalid == false) {
        this.addUsername = this.addEmail.split("@")[0]
      } else {
        this.addUsername = ''
      }
    },
    queryAddProvinsi() {
      this.getAddProvinsi()
      this.dataAddKota = []
      this.queryAddKota = ''
      this.dataAddKecamatan = []
      this.queryAddKecamatan = ''
      this.dataAddKelurahan = []
      this.queryAddKelurahan = ''
    },
    queryAddKota() {
      this.getAddKota()
      this.dataAddKecamatan = []
      this.queryAddKecamatan = ''
      this.dataAddKelurahan = []
      this.queryAddKelurahan = ''
    },
    queryAddKecamatan() {
      this.getAddKecamatan()
      this.dataAddKelurahan = []
      this.queryAddKelurahan = ''
    },
    queryAddKelurahan() {
      this.getAddKelurahan()
    },
    queryAddNegara() {
      this.getDataAddNegara()
    },
    queryNegara() {
      this.getDataNegara('null')
    },
    queryAddKantor() {
      if (this.queryAddKantor == '') {
        this.idAddKantor = ''
      }
      this.getDataAddKantor()
    },
    selectedAddPolaAbsensi() {
      this.selectedAddKodePolaAbsensi.value = ''
      this.selectedAddKodePolaAbsensi.text = ''
      this.getAddNormalOrShift()
    },
    selectedAddKodePolaAbsensi() {
      this.selectedAddShiftKe.value = ''
      this.selectedAddShiftKe.text = ''
      this.getDataAddShiftKe()
    },
    selectedItemEditTipePegawai() {
      if (this.selectedItemEditTipePegawai.pjtk == 'Y') {
        this.disEditPjtk = false
      } else {
        this.disEditPjtk = true
        this.pjtk.value = ''
        this.pjtk.text = ''
        this.getDataPJTK()
      }

      if (this.selectedItemEditTipePegawai.pegawai == 'Y') {
        this.disEditJenjang = false
      } else {
        this.disEditJenjang = true
        this.jenjang.value = ''
        this.jenjang.text = ''
        this.getDataJenjang()
      }
    },
    selectedItemAddTipePegawai() {
      if (this.selectedItemAddTipePegawai.pjtk == 'Y') {
        this.disAddPjtk = false
      } else {
        this.disAddPjtk = true
        this.addPJTK.value = ''
        this.addPJTK.text = ''
        this.getDataAddPJTK()
      }

      if (this.selectedItemAddTipePegawai.pegawai == 'Y') {
        this.disAddJenjang = false
      } else {
        this.disAddJenjang = true
        this.addJenjang.value = ''
        this.addJenjang.text = ''
        this.getDataAddJenjang()
      }
    }
  },
  methods: {
    sorting(value) {
      if (value == 0) {
        function compare(a, b) {
          if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
            return -1
          }
          if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 1) {
        function compare(a, b) {
          if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
            return -1
          }
          if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 2) {
        function compare(a, b) {
          if (a.email.toLowerCase() < b.email.toLowerCase()) {
            return -1
          }
          if (a.email.toLowerCase() > b.email.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 3) {
        function compare(a, b) {
          if (a.sex.toLowerCase() < b.sex.toLowerCase()) {
            return -1
          }
          if (a.sex.toLowerCase() > b.sex.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 4) {
        function compare(a, b) {
          if (a.tipePegawai.toLowerCase() < b.tipePegawai.toLowerCase()) {
            return -1
          }
          if (a.tipePegawai.toLowerCase() > b.tipePegawai.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 5) {
        function compare(a, b) {
          if (a.bidang.toLowerCase() < b.bidang.toLowerCase()) {
            return -1
          }
          if (a.bidang.toLowerCase() > b.bidang.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 6) {
        function compare(a, b) {
          if (a.jabatan.toLowerCase() < b.jabatan.toLowerCase()) {
            return -1
          }
          if (a.jabatan.toLowerCase() > b.jabatan.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      }
    },

    /**
     * GET PRIMARY DATA
     */
    getDetails(value) {
      let limit = 1
      let nama = ""
      let page = 1
      let bidang = ""
      let jabatan = ""
      let pegawaiId = this.datas[value].idPegawai
      let aktif = ""

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: "",
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let data = response.data.data
              this.getDataDetail(data[0].idPegawai)
              this.getDataTeam(data[0].lvl)
              this.getDataJamKerja(data[0].idPegawai)
              this.idPeg = data[0].idPegawai
              setTimeout(this.loadDetails, 500);

            }
          })
    },
    loadDetails() {
      this.detail = true
    },
    getDataDetail(id) {
      let payload = {
        pegawaiId: id
      }
      DataApi.post("pegawai/lihat/detail/backoffice", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let data1 = response.data.Data1
              let data2 = response.data.Data2
              let data3 = response.data.Data3
              let data4 = response.data.Data4
              let data5 = response.data.Data5
              let data6 = response.data.Data6
              let data7 = response.data.Data7
              let data8 = response.data.Data8
              let data9 = response.data.Data9
              let data10 = response.data.Data10
              let data11 = response.data.Data11
              let data12 = response.data.Data12
              this.pharData1(data1)
              this.pharData2(data2)
              this.pharData3(data3)
              this.pharData4(data4)
              this.pharData5(data5)
              this.pharData6(data6)
              this.pharData7(data7)
              this.pharData8(data8)
              this.pharData9(data9)
              this.pharData10(data10)
              this.pharData11(data11)
              this.pharData12(data12)
            }
          })
    },
    pharData1(data) {
      this.arrData1 = []
      this.arrDataEdit1 = []
      let arr = data.split("##")
      let arry = data.split("##")
      var i = 0
      for (i = 0; i < arr.length; i++) {
        if (arr[i] == '' || arr[i] == 'null') {
          arr[i] = '-'
          arry[i] = ''
        }
      }
      this.arrDataEdit1 = arry
      this.arrData1 = arr
    },
    pharData2(data) {
      this.arrData2 = []
      this.arrDataEdit2 = []
      let arr = data.split("##")
      let arry = data.split("##")
      var i = 0
      for (i = 0; i < arr.length; i++) {
        if (arr[i] == '' || arr[i] == 'null') {
          arr[i] = '-'
          arry[i] = ''
        }
      }
      this.arrDataEdit2 = arry
      this.arrData2 = arr
    },
    pharData3(data) {
      this.arrData3 = []
      this.arrDataEdit3 = []
      let arr = data.split("##")
      let arry = data.split("##")
      var i = 0
      for (i = 0; i < arr.length; i++) {
        if (arr[i] == '' || arr[i] == 'null') {
          arr[i] = '-'
          arry[i] = ''
        }
      }
      this.arrDataEdit3 = arry
      this.arrData3 = arr
    },
    pharData4(data) {
      if (data == '') {
        this.arrData4 = ''
      } else {
        this.arrData4 = []
        this.arrDataEdit4 = []
        let arr = data.split("@@")
        var i = 0
        for (i = 0; i < arr.length - 1; i++) {
          let inPush = arr[i].split('##')
          let onPush = arr[i].split("##")
          var j = 0
          for (j = 0; j < onPush.length; j++) {
            if (onPush[j] == '' || onPush[j] == 'null') {
              onPush[j] = '-'
              inPush[j] = ''
            }
          }
          this.arrDataEdit4.push(inPush)
          this.arrData4.push(onPush)
        }
      }
    },
    pharData5(data) {
      if (data == '') {
        this.arrData5 = ''
        this.arrDataEdit5 = ''
      } else {
        this.arrData5 = []
        this.arrDataEdit5 = []
        let arr = data.split("##")
        let arry = data.split("##")
        var i = 0
        for (i = 0; i < arr.length; i++) {
          if (arr[i] == '' || arr[i] == 'null') {
            arr[i] = '-'
            arry[i] = ''
          }
        }
        this.arrDataEdit5 = arry
        this.arrData5 = arr
      }
    },
    pharData6(data) {
      if (data == '') {
        this.arrData6 = ''
      } else {
        this.arrData6 = []
        this.arrDataEdit6 = []
        let arr = data.split("@@")
        var i = 0
        for (i = 0; i < arr.length - 1; i++) {
          let inPush = arr[i].split('##')
          let onPush = arr[i].split("##")
          var j = 0
          for (j = 0; j < onPush.length; j++) {
            if (onPush[j] == '' || onPush[j] == 'null') {
              onPush[j] = '-'
              inPush[j] = ''
            }
          }
          this.arrDataEdit6.push(inPush)
          this.arrData6.push(onPush)
        }
      }

    },
    pharData7(data) {
      if (data == '') {
        this.arrData7 = ''
        this.arrDataEdit7 = ''
      } else {
        this.arrData7 = []
        this.arrDataEdit7 = []
        let arr = data.split("##")
        let arry = data.split("##")
        var i = 0
        for (i = 0; i < arr.length; i++) {
          if (arr[i] == '' || arr[i] == 'null') {
            arr[i] = '-'
            arry[i] = ''
          }
        }
        this.arrDataEdit7 = arry
        this.arrData7 = arr
      }
    },
    pharData8(dataFull) {
      this.editJumlahDevice = dataFull.split("$$")[0]
      this.jumlahDevice = dataFull.split("$$")[0]
      let data = dataFull.split("$$")[1]
      if (data == '') {
        this.arrData8 = ''
      } else {
        this.arrData8 = []
        this.arrDataEdit8 = []
        let arr = data.split("@@")
        var i = 0
        for (i = 0; i < arr.length - 1; i++) {
          let onPush = arr[i].split("##")
          let inPush = arr[i].split("##")
          var j = 0
          for (j = 0; j < onPush.length; j++) {
            if (onPush[j] == '' || onPush[j] == 'null') {
              onPush[j] = '-'
              inPush[j] = ''
            }
          }
          this.arrData8.push(onPush)
          this.arrDataEdit8.push(inPush)
        }
      }
    },
    pharData9(data) {
      if (data == '') {
        this.arrData9 = ''
        this.arrDataEdit9 = ''
      } else {
        this.arrData9 = []
        this.arrDataEdit9 = []
        let arr = data.split("##")
        let arry = data.split("##")
        var i = 0
        for (i = 0; i < arr.length; i++) {
          if (arr[i] == '' || arr[i] == 'null') {
            arr[i] = '-'
            arry[i] = ''
          }
        }
        this.arrDataEdit9 = arry
        this.arrData9 = arr
      }
    },
    pharData10(data) {
      if (data == '') {
        this.arrData10 = ''
        this.arrDataEdit10 = ''
      } else {
        this.arrData10 = []
        this.arrDataEdit10 = []
        let arr = data.split("##")
        let arry = data.split("##")
        var i = 0
        for (i = 0; i < arr.length; i++) {
          if (arr[i] == '' || arr[i] == 'null') {
            arr[i] = '-'
            arry[i] = ''
          }
        }
        this.arrDataEdit10 = arry
        this.arrData10 = arr

        if (this.arrData2[5] == 'S3') {
          this.docFotoIjasah1 = arr[10]
          this.docFotoIjasah2 = arr[11]
          this.docFotoIjasah3 = arr[12]
        } else if (this.arrData2[5] == 'S2') {
          this.docFotoIjasah1 = arr[10]
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[11]
        } else if (this.arrData2[5] == 'S1') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[10]
        } else if (this.arrData2[5] == 'D1') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[6]
        } else if (this.arrData2[5] == 'D2') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[7]
        } else if (this.arrData2[5] == 'D3') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[8]
        } else if (this.arrData2[5] == 'D4') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[9]
        } else if (this.arrData2[5] == 'SMA/SMK/Setingkat') {
          this.docFotoIjasah1 = '-'
          this.docFotoIjasah2 = '-'
          this.docFotoIjasah3 = arr[2]
        }
      }
    },
    pharData11(data) {
      if (data == '') {
        this.arrData11 = ''
      } else {
        this.arrData11 = []
        this.arrDataEdit11 = []
        let arr = data.split("@@")
        var i = 0
        for (i = 0; i < arr.length - 1; i++) {
          let inPush = arr[i].split('##')
          let onPush = arr[i].split("##")
          var j = 0
          for (j = 0; j < onPush.length; j++) {
            if (onPush[j] == '' || onPush[j] == 'null') {
              onPush[j] = '-'
              inPush[j] = ''
            }
          }
          this.arrDataEdit11.push(inPush)
          this.arrData11.push(onPush)
        }
      }
    },
    pharData12(data) {
      if (data == '') {
        this.arrData12 = ''
      } else {
        this.arrData12 = []
        this.arrDataEdit12 = []
        let arr = data.split("@@")
        var i = 0
        for (i = 0; i < arr.length; i++) {
          let inPush = arr[i].split('##')
          let onPush = arr[i].split("##")
          var j = 0
          for (j = 0; j < onPush.length; j++) {
            if (onPush[j] == '' || onPush[j] == 'null') {
              onPush[j] = '-'
              inPush[j] = ''
            }
          }
          this.arrDataEdit12.push(inPush)
          this.arrData12.push(onPush)
        }
      }
    },
    getDataTeam(data) {
      if (data != '') {
        this.lvlTeam = data
        let payload = {
          lvl: data,
        }
        DataApi.post("pegawai/team/member", payload)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataTeam = response.data.data
                this.totalDataTeam = response.data.totalRow
                if (this.arrDataTeam.length == 0) {
                  this.arrDataTeam = ''
                  this.totalDataTeam = ''
                }
              }
            })
      } else {
        this.totalDataTeam = ''
        this.arrDataTeam = ''
      }
    },
    getDataJamKerja(data) {
      this.idPegawaiJamKerja = data
      let tahun = this.selectedTahun.value.toString()
      let payload = {
        idPegawai: data,
        bulan: this.selectedBulan.value,
        tahun: tahun
      }
      DataApi.post("pegawai/jadwal/kerja", payload)
          .then(res => {
            this.dataJamKerja = []
            let response = res.data
            if (response.success == true) {
              let data = response.data.Data1
              this.tanggalAktifKehadiran = response.data.Data2
              if (data == '') {
                this.dataJamKerja = []
              } else {
                this.dataJamKerja = []
                let arr = data.split("@@")
                var i = 0
                for (i = 0; i < arr.length; i++) {
                  if (i == 0) {
                    this.tipeJamKerja = arr[0]
                  } else {
                    let onPush = arr[i].split("##")
                    var j = 0
                    for (j = 0; j < onPush.length; j++) {
                      if (onPush[j] == '' || onPush[j] == 'null') {
                        onPush[j] = '-'
                      }
                    }
                    this.dataJamKerja.push(onPush)
                  }
                }
              }
            }
            this.getDataSchadule()
          })
    },
    getDataSchadule() {
      let payload = {
        idPegawai: this.idPegawaiJamKerja,
        bulan: this.selectedBulan.value,
        tahun: this.selectedTahun.value.toString()
      }
      DataApi.post("pegawai/wfh/lihat", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let temp = response.data
              if (temp.length != 0) {
                let data = this.dataJamKerja
                this.statusSchadule = temp[0].status
                this.tanggalApproveSchadule = temp[0].tanggalApprove
                this.tanggalMengajukanSchadule = temp[0].tanggalMengajukan
                let list = temp[0].listTanggal
                var i, j
                for (i = 0; i < data.length; i++) {
                  let one = data[i][0].split("/")[0]
                  let flags = false
                  for (j = 0; j < list.length; j++) {
                    let two = list[j].split("-")[2]
                    if (one == two) {
                      flags = true
                      break
                    } else {
                      flags = false
                    }
                  }
                  if (flags == true) {
                    this.dataJamKerja[i].push("WFH")
                  } else {
                    this.dataJamKerja[i].push("WFO")
                  }
                }
              } else {
                var k
                let data1 = this.dataJamKerja
                this.statusSchadule = ''
                this.tanggalApproveSchadule = ''
                this.tanggalMengajukanSchadule = ''
                for (k = 0; k < data1.length; k++) {
                  this.dataJamKerja[k].push("WFO")
                }
              }
            }
          })
    },
    resetSchadule() {
      let payload = {
        idPegawai: this.idPegawaiJamKerja,
        bulan: this.selectedBulan.value,
        status: 'W',
        tahun: this.selectedTahun.value.toString()
      }
      DataApi.post("pegawai/wfh/simpan", payload)
          .then(res => {
            this.getDataJamKerja(this.idPegawaiJamKerja)
            this.resetModalSchadule = false
          })
    },
    getData() {
      if (this.flagSearch == true) {
        this.page = 1
      }
      this.$store.state.loadingScreen = true
      let limit = this.size
      let nama = this.searchValue
      let page = this.page
      let bidang = this.idUnitSearch
      let jabatan = this.searchJobPosition
      let pegawaiId = ''
      let aktif = this.filterStatus.value

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: this.kodeTipePegawai,
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              this.datas = response.data.data
              this.totalRow = response.data.totalRow
              this.firstPage = (((this.page - 1) * this.size) + 1)
              this.lastPage = (((this.page - 1) * this.size) + this.datas.length)
              this.totalPage = Math.floor(this.totalRow / this.size)
              let modAr = this.totalRow % this.size
              if (modAr != 0) {
                this.totalPage = this.totalPage + 1
              } else {
                //
              }
            } else {
              this.datas = []
              this.totalRow = 0
              this.firstPage = 0
              this.lastPage = 0
              this.totalPage = 1
              this.errorMessage = response.message
            }
            this.flagSearch = false
            this.$store.state.loadingScreen = false
          })
    },
    getDownload() {
      this.$store.state.loadingScreen = true
      let limit = this.totalRow
      let nama = this.searchValue
      let page = 1
      let bidang = this.idUnitSearch
      let jabatan = this.searchJobPosition
      let pegawaiId = ''
      let aktif = this.filterStatus.value

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: this.kodeTipePegawai,
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let downloads = response.data.data
              let data = [
                {
                  sheet: 'Data Pegawai',
                  columns: [
                    {label: 'Nama', value: 'nama'},
                    {label: 'NIP', value: 'nik'},
                    {label: 'Email', value: 'email'},
                    {label: 'Jabatan', value: 'jabatan'},
                    {label: 'Jenjang Jabatan', value: 'jenjangJabatan'},
                    {label: 'Bidang', value: 'bidang'},
                    {label: 'Tipe Pegawai', value: 'keteranganTipePegawai'},
                    {label: 'Telepon', value: 'telepon'},
                    {label: 'Alamat', value: 'alamat'},
                    {label: 'Jenis Kelamin', value: 'sex'},
                    {label: 'Nama Atasan', value: 'namaAtasan'},
                    {label: 'Tipe Absen', value: 'shift'},
                    {label: 'Status', value: 'aktif'},
                    {label: 'Kuota Cuti', value: 'kuotaCuti'},
                    {label: 'Cuti yang dipakai', value: 'cutiPakai'},
                    {label: 'Sisa Cuti', value: 'sisaCuti'},

                  ],
                  content: downloads
                }
              ]
              let settings = {
                fileName: 'Data Pegawai'
              }
              xlsx(data, settings)
            }
            this.$store.state.loadingScreen = false
          })
    },
    getTeam(id, flag) {
      this.getDataDetail(id)
      this.setDate()
      this.getDataJamKerja(id)

      this.idPeg = id
      if (flag == '1') {
        //
      } else {
        this.menuFlag = '1'
      }
      setTimeout(this.getTeamUpdate, 1000);
    },
    getTeamUpdate() {
      let lvl = this.arrDataEdit1[7]
      this.getDataTeam(lvl)
    },


    // MODAL
    showModal(obj, ket, ids) {
      if (obj == 'kepegawaian') {
        this.idModal = '0'
        if (this.arrDataEdit1[7] == '') {
          this.getDataUnit('null')
        } else {
          this.getDataUnit(this.arrDataEdit1[7])
        }

        if (this.arrDataEdit1[14] == '') {
          this.getDataPegawai('null')
        } else {
          this.getDataPegawai(this.arrDataEdit1[14])
        }

        if (this.arrDataEdit1[15] == '') {
          this.getDataEditTipePegawai('null')
        } else {
          this.getDataEditTipePegawai(this.arrDataEdit1[15])
        }

        if (this.arrDataEdit1[16] == '') {
          this.getDataEditTipeRole('null')
        } else {
          this.getDataEditTipeRole(this.arrDataEdit1[16])
        }

        this.urlImage = this.arrData1[3]

        let data2 = this.dataWajibGPS
        var k = 0
        for (k = 0; k < data2.length; k++) {
          if (this.arrDataEdit1[17] == data2[k].value) {
            this.wajibGPS.value = data2[k].value
            this.wajibGPS.text = data2[k].text
            break
          } else {
            this.wajibGPS.value = ''
            this.wajibGPS.text = ''
          }
        }
        let data3 = this.dataHideWFH
        var l = 0
        for (l = 0; l < data3.length; l++) {
          if (this.arrDataEdit1[18] == data3[l].value) {
            this.hideWFH.value = data3[l].value
            this.hideWFH.text = data3[l].text
            break
          } else {
            this.hideWFH.value = ''
            this.hideWFH.text = ''
          }
        }

        let data4 = this.dataAktif
        var m = 0
        for (m = 0; m < data4.length; m++) {
          if (this.arrDataEdit1[2] == data4[m].value) {
            this.aktif.value = data4[m].value
            this.aktif.text = data4[m].text
            break
          } else {
            this.aktif.value = ''
            this.aktif.text = ''
          }
        }

        let data5 = this.dataPJTK
        var n = 0
        for (n = 0; n < data5.length; n++) {
          if (this.arrDataEdit1[23] == data5[n].value) {
            this.pjtk.value = data5[n].value
            this.pjtk.text = data5[n].text
            break
          } else {
            this.pjtk.value = ''
            this.pjtk.text = ''
          }
        }

        let data6 = this.dataJenjang
        var jn = 0
        for (jn = 0; jn < data6.length; jn++) {
          if (this.arrDataEdit1[25] == data6[jn].value) {
            this.jenjang.value = data6[jn].value
            this.jenjang.text = data6[jn].text
            break
          } else {
            this.jenjang.value = ''
            this.jenjang.text = ''
          }
        }

        let data7 = this.sync
        var sn = 0
        for (sn = 0; sn < data7.length; sn++) {
          if (this.arrDataEdit1[26] == data7[sn].value) {
            this.sync.value = data7[sn].value
            this.sync.text = data7[sn].text
            break
          } else {
            this.sync.value = ''
            this.sync.text = ''
          }
        }

        this.hargaSatuan = this.arrData1[28]
      }
      if (obj == 'sekilas') {
        this.idModal = '1'
        this.getDataNegara(this.arrDataEdit2[7])
        let data = this.dataSex
        var i = 0
        for (i = 0; i < data.length; i++) {
          if (this.arrDataEdit2[4] == data[i].value) {
            this.sex.value = data[i].value
            this.sex.text = data[i].text
            break
          } else {
            this.sex.value = ''
            this.sex.text = ''
          }
        }
        let data1 = this.dataMarrige
        var j = 0
        for (j = 0; j < data1.length; j++) {
          if (this.arrDataEdit2[2] == data1[j].value) {
            this.marrige.value = data1[j].value
            this.marrige.text = data1[j].text
            break
          } else {
            this.marrige.value = ''
            this.marrige.text = ''
          }
        }
        let data2 = this.dataIjasah
        var k = 0
        for (k = 0; k < data2.length; k++) {
          if (this.arrDataEdit2[5] == data2[k].value) {
            this.ijasah.value = data2[k].value
            this.ijasah.text = data2[k].text
            break
          } else {
            this.ijasah.value = ''
            this.ijasah.text = ''
          }
        }
        let data3 = this.dataGolonganDarah
        var l = 0
        for (l = 0; l < data3.length; l++) {
          if (this.arrDataEdit2[3] == data3[l].value) {
            this.golonganDarah.value = data3[l].value
            this.golonganDarah.text = data3[l].text
            break
          } else {
            this.golonganDarah.value = ''
            this.golonganDarah.text = ''
          }
        }
        let data4 = this.dataAgama
        var m = 0
        for (m = 0; m < data4.length; m++) {
          if (this.arrDataEdit2[8] == data4[m].value) {
            this.agama.value = data4[m].value
            this.agama.text = data4[m].text
            break
          } else {
            this.agama.value = ''
            this.agama.text = ''
          }
        }
        let data5 = this.dataGpsInterval
        var n = 0
        for (n = 0; n < data5.length; n++) {
          if (this.arrDataEdit2[10] == data5[n].value) {
            this.gpsInterval.value = data5[n].value
            this.gpsInterval.text = data5[n].text
            break
          } else {
            this.gpsInterval.value = ''
            this.gpsInterval.text = ''
          }
        }
      }
      if (obj == 'kontak') {
        this.idModal = '2'
        let data = this.dataUsernameBy
        var i = 0
        for (i = 0; i < data.length; i++) {
          if (this.arrDataEdit3[2] == data[i].value) {
            this.usernameBy.value = data[i].value
            this.usernameBy.text = data[i].text
            break
          } else {
            this.usernameBy.value = ''
            this.usernameBy.text = ''
          }
        }
      }
      if (obj == 'nama') {
        this.idModal = '3'
      }
      if (obj == 'seragam') {
        this.idModal = '4'
        let ukuran = this.dataUkuranSeragam
        let tipe = this.dataTipeSeragam
        var u1 = 0
        var t1 = 0
        var u2 = 0
        var t2 = 0
        var u3 = 0
        var t3 = 0
        for (t1 = 0; t1 < tipe.length; t1++) {
          if (this.arrDataEdit5[0] == tipe[t1].text) {
            this.fut.value = tipe[t1].value
            this.fut.text = tipe[t1].text
            break
          } else {
            this.fut.value = ''
            this.fut.text = ''
          }
        }
        for (t2 = 0; t2 < tipe.length; t2++) {
          if (this.arrDataEdit5[2] == tipe[t2].text) {
            this.sut.value = tipe[t2].value
            this.sut.text = tipe[t2].text
            break
          } else {
            this.sut.value = ''
            this.sut.text = ''
          }
        }
        for (t3 = 0; t3 < tipe.length; t3++) {
          if (this.arrDataEdit5[4] == tipe[t3].text) {
            this.st.value = tipe[t3].value
            this.st.text = tipe[t3].text
            break
          } else {
            this.st.value = ''
            this.st.text = ''
          }
        }
        for (u1 = 0; u1 < ukuran.length; u1++) {
          if (this.arrDataEdit5[1] == ukuran[u1].text) {
            this.fus.value = ukuran[u1].value
            this.fus.text = ukuran[u1].text
            break
          } else {
            this.fus.value = ''
            this.fus.text = ''
          }
        }
        for (u2 = 0; u2 < ukuran.length; u2++) {
          if (this.arrDataEdit5[3] == ukuran[u2].text) {
            this.sus.value = ukuran[u2].value
            this.sus.text = ukuran[u2].text
            break
          } else {
            this.sus.value = ''
            this.sus.text = ''
          }
        }
        for (u3 = 0; u3 < ukuran.length; u3++) {
          if (this.arrDataEdit5[5] == ukuran[u3].text) {
            this.ss.value = ukuran[u3].value
            this.ss.text = ukuran[u3].text
            break
          } else {
            this.ss.value = ''
            this.ss.text = ''
          }
        }
        if (this.arrDataEdit5[6] == '1') {
          this.hijab.value = '1'
          this.hijab.text = 'Yes'
        } else if (this.arrDataEdit5[6] == '2') {
          this.hijab.value = '2'
          this.hijab.text = 'No'
        } else {
          this.hijab.value = '0'
          this.hijab.text = ''
        }
      }
      if (obj == 'jadwal') {
        this.idModal = '5'
        if (ket != 'null') {
          if (this.arrDataEdit7[1] == '1') {
            this.polaAbsensi.value = '1'
            this.polaAbsensi.text = 'Normal'
            this.getDataNormal(this.arrDataEdit7[2])
          } else {
            this.polaAbsensi.value = '0'
            this.polaAbsensi.text = 'Shift'
            this.getDataShift(this.arrDataEdit7[2])
          }
        } else {
          this.polaAbsensi.value = ''
          this.polaAbsensi.text = ''
          this.kodePolaAbsensi.value = ''
          this.kodePolaAbsensi.text = ''
          this.shiftAktif.value = ''
          this.shiftAktif.text = ''
          this.tanggalAktifKehadiran = ''
        }
      }
      if (obj == 'penempatan') {
        if (ket == 'null') {
          this.idModal = '6'
          this.tanggalExpired = ''
          this.getDataKantor('null')
          this.editKantorID = ''
          this.createPenempatan = true
        } else {
          this.idModal = '6'
          this.tanggalExpired = this.arrDataEdit4[ket][3]
          this.getDataKantor(this.arrDataEdit4[ket][0])
          this.editKantorID = ket
          this.createPenempatan = false
        }
      }
      if (obj == 'keluarga') {
        this.idModal = '7'
        if (ids != 'null') {
          this.addKeluargaStatus = 'U'
          if (ket == 'pasangan') {
            this.tipeKeluarga.value = 'S'
            this.tipeKeluarga.text = 'Pasangan'
            this.tanggalKeluargaMenikah = this.arrDataEdit6[ids][1]
            this.tanggalKeluargaLahir = this.arrDataEdit6[ids][2]
            this.namaKeluarga = this.arrDataEdit6[ids][0]
            this.editKeluargaID = this.arrDataEdit6[ids][4]
            this.editNoAdmedika = this.arrDataEdit6[ids][5]
          } else {
            this.tipeKeluarga.value = 'K'
            this.tipeKeluarga.text = 'Anak'
            this.editKeluargaID = this.arrDataEdit11[ids][4]
            this.namaKeluarga = this.arrDataEdit11[ids][0]
            this.tanggalKeluargaMenikah = ''
            this.tanggalKeluargaLahir = this.arrDataEdit11[ids][2]
            this.editNoAdmedika = this.arrDataEdit11[ids][5]
          }
        } else {
          this.addKeluargaStatus = 'C'
          if (ket == 'pasangan') {
            this.tipeKeluarga.value = 'S'
            this.tipeKeluarga.text = 'Pasangan'
            this.tanggalKeluargaMenikah = ''
            this.tanggalKeluargaLahir = ''
            this.namaKeluarga = ''
            this.editKeluargaID = ''
            this.editNoAdmedika = ''
          } else {
            this.tipeKeluarga.value = 'K'
            this.tipeKeluarga.text = 'Anak'
            this.editKeluargaID = ''
            this.namaKeluarga = ''
            this.tanggalKeluargaMenikah = ''
            this.tanggalKeluargaLahir = ''
            this.editNoAdmedika = ''
          }
        }
      }
      if (obj == 'device') {
        if (ket == 'jumlahDevice') {
          this.idModal = '11'
        } else {
          this.idModal = '8'
          this.namaDevice = this.arrDataEdit8[ket][0]
          this.tipeDevice = this.arrDataEdit8[ket][1]
          this.deviceId = this.arrDataEdit8[ket][2]
        }
      }
      if (obj == 'dokumen') {
        this.idModal = '9'
      }
      if (obj == 'kelengkapanDokumen') {
        this.idModal = '10'
        this.urlImageFotoKtp = this.arrDataEdit10[0]
        this.urlImageFotoKk = this.arrDataEdit10[1]
        this.urlImageFotoNpwp = this.arrDataEdit10[3]
        this.urlImageFotoBpjsKesehatan = this.arrDataEdit10[4]
        this.urlImageFotoBpjsKetenagakerjaan = this.arrDataEdit10[5]
        if (this.arrData2[5] == 'S3') {
          this.urlImageFotoIjasah1 = this.arrDataEdit10[10]
          this.urlImageFotoIjasah2 = this.arrDataEdit10[11]
          this.urlImageFotoIjasah3 = this.arrDataEdit10[12]
        } else if (this.arrData2[5] == 'S2') {
          this.urlImageFotoIjasah1 = this.arrDataEdit10[10]
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[12]
        } else if (this.arrData2[5] == 'S1') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[10]
        } else if (this.arrData2[5] == 'D1') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[6]
        } else if (this.arrData2[5] == 'D2') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[7]
        } else if (this.arrData2[5] == 'D3') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[8]
        } else if (this.arrData2[5] == 'D4') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[9]
        } else if (this.arrData2[5] == 'SMA/SMK/Setingkat') {
          this.urlImageFotoIjasah1 = ''
          this.urlImageFotoIjasah2 = ''
          this.urlImageFotoIjasah3 = this.arrDataEdit10[2]
        }
      }

      this.editModal = true
    },
    closeModal() {
      this.errModal = ''
      this.editModal = false
      this.getDataUnit('null')
      this.getDataPegawai('null')
      this.getDataKantor('null')
      this.getDataEditTipePegawai('null')
      this.getDataEditTipeRole('null')
      this.getDataSex()
      this.getDataAgama()
      this.getDataMarrige()
      this.getDataIjasah()
      this.getDataGolonganDarah()
      this.getDataUsernameBy()
      this.getDataPolaAbsensi()
      this.getDataTipeKeluarga()
      this.getDataSeragam()
      this.getDataWajibGPS()
      this.getDataGpsInterval()
      this.getDataHideWFH()
      this.getDataAktif()
      this.getDataPJTK()
      this.getDataJenjang()
      this.getDataSync()

      this.replaceArrData1()
      this.replaceArrData3()
      this.replaceArrData2()
      this.replaceArrData4()
      this.replaceArrData5()
      this.replaceArrData6()
      this.replaceArrData7()
      this.replaceArrData8()
      this.replaceArrData9()
      this.replaceArrData10()
      this.replaceArrData11()
      this.replaceArrData12()
    },
    replaceArrData1() {
      this.arrDataEdit1 = []
      let data = this.arrData1
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit1[i] = ''
        } else {
          this.arrDataEdit1[i] = data[i]
        }
      }
    },
    replaceArrData2() {
      this.arrDataEdit2 = []
      let data = this.arrData2
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit2[i] = ''
        } else {
          this.arrDataEdit2[i] = data[i]
        }
      }
    },
    replaceArrData3() {
      this.arrDataEdit3 = []
      let data = this.arrData3
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit3[i] = ''
        } else {
          this.arrDataEdit3[i] = data[i]
        }
      }

    },
    replaceArrData4() {
      this.arrDataEdit4 = []
      let data = this.arrData4
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit4[i] = ''
        } else {
          this.arrDataEdit4[i] = data[i]
        }
      }
    },
    replaceArrData5() {
      this.arrDataEdit5 = []
      let data = this.arrData5
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit5[i] = ''
        } else {
          this.arrDataEdit5[i] = data[i]
        }
      }
    },
    replaceArrData6() {
      this.arrDataEdit6 = []
      let data = this.arrData6
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit6[i] = ''
        } else {
          this.arrDataEdit6[i] = data[i]
        }
      }
    },
    replaceArrData7() {
      this.arrDataEdit7 = []
      let data = this.arrData7
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit7[i] = ''
        } else {
          this.arrDataEdit7[i] = data[i]
        }
      }
    },
    replaceArrData8() {
      this.arrDataEdit8 = []
      let data = this.arrData8
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit8[i] = ''
        } else {
          this.arrDataEdit8[i] = data[i]
        }
      }
    },
    replaceArrData9() {
      this.arrDataEdit9 = []
      let data = this.arrData9
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit9[i] = ''
        } else {
          this.arrDataEdit9[i] = data[i]
        }
      }
    },
    replaceArrData10() {
      this.arrDataEdit10 = []
      let data = this.arrData10
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit10[i] = ''
        } else {
          this.arrDataEdit10[i] = data[i]
        }
      }
    },
    replaceArrData11() {
      this.jumlahDevice = this.editJumlahDevice
    },
    replaceArrData12() {
      this.arrDataEdit12 = []
      let data = this.arrData12
      var i = 0
      for (i = 0; i < data.length; i++) {
        if (data[i] == '-') {
          this.arrDataEdit12[i] = ''
        } else {
          this.arrDataEdit12[i] = data[i]
        }
      }
    },


    /**
     * SUBMIT
     */
    onSubmit(value) {
      let x = '##'
      let gapFoto = '%%'
      let data1 = ''
      let data2 = ''
      let data3 = ''
      let data4 = ''
      let data5 = ''
      let data6 = ''
      let data7 = ''
      let data8 = ''
      let data9 = ''
      let data10 = ''

      // data1
      let organisasi = this.arrDataEdit1[0]
      let idPegawai = this.arrDataEdit1[1]
      let aktif = this.aktif.value
      let fotoProfil = this.arrDataEdit1[3]
      let nama = this.arrDataEdit1[4]
      let namaAlias = this.arrDataEdit1[5]
      let nip = this.arrDataEdit1[6]
      let lvl = this.idUnits
      let bidang = this.queryUnit.split(" - ")[0]
      let jabatan = this.arrDataEdit1[9]
      let atasan = this.idAtasan
      let tipePegawai = this.kodeEditTipePegawai
      let role = this.kodeEditTipeRole
      let radius = this.arrDataEdit1[13]
      let pjtk = this.pjtk.value
      let jenjang = this.jenjang.value
      let sync = this.sync.value
      let num = this.hargaSatuan.replace("Rp. ", '')
      let harga = num.replaceAll(".", '')

      // data2
      let tempatLahir = this.arrDataEdit2[0]
      let tanggalLahir = this.arrDataEdit2[1]
      let status = this.marrige.value
      let golonganDarah = this.golonganDarah.value
      let jenisKelamin = this.sex.value
      let ijasah = this.ijasah.value
      let tanggalBerakhirKontrak = this.arrDataEdit2[6]
      let negara = this.queryNegara
      let agama = this.agama.value
      let gpsInterval = ''
      if (this.arrDataEdit1[17] == 'Y') {
        if (this.gpsInterval.value == '') {
          gpsInterval = '15'
        } else {
          gpsInterval = this.gpsInterval.value
        }
      } else {
        gpsInterval = '0'
      }
      let smp = this.arrDataEdit2[11]
      let namaSma = this.ijasah.value == 'SMA/SMK/Setingkat' ? this.arrDataEdit2[12] : ''
      let jurusanSma = this.ijasah.value == 'SMA/SMK/Setingkat' ? this.arrDataEdit2[13] : ''
      let namaD1 = this.ijasah.value == 'D1' ? this.arrDataEdit2[14] : ''
      let jurusanD1 = this.ijasah.value == 'D1' ? this.arrDataEdit2[15] : ''
      let ipkD1 = this.ijasah.value == 'D1' ? this.arrDataEdit2[16] : ''
      let namaD2 = this.ijasah.value == 'D2' ? this.arrDataEdit2[17] : ''
      let jurusanD2 = this.ijasah.value == 'D2' ? this.arrDataEdit2[18] : ''
      let ipkD2 = this.ijasah.value == 'D2' ? this.arrDataEdit2[19] : ''
      let namaD3 = this.ijasah.value == 'D3' ? this.arrDataEdit2[20] : ''
      let jurusanD3 = this.ijasah.value == 'D3' ? this.arrDataEdit2[21] : ''
      let ipkD3 = this.ijasah.value == 'D3' ? this.arrDataEdit2[22] : ''
      let namaD4 = this.ijasah.value == 'D4' ? this.arrDataEdit2[23] : ''
      let jurusanD4 = this.ijasah.value == 'D4' ? this.arrDataEdit2[24] : ''
      let ipkD4 = this.ijasah.value == 'D4' ? this.arrDataEdit2[25] : ''
      let namaS1 = this.ijasah.value == 'S1' || this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[26] : ''
      let jurusanS1 = this.ijasah.value == 'S1' || this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[27] : ''
      let ipkS1 = this.ijasah.value == 'S1' || this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[28] : ''
      let namaS2 = this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[29] : ''
      let jurusanS2 = this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[30] : ''
      let ipkS2 = this.ijasah.value == 'S2' || this.ijasah.value == 'S3' ? this.arrDataEdit2[31] : ''
      let namaS3 = this.ijasah.value == 'S3' ? this.arrDataEdit2[32] : ''
      let jurusanS3 = this.ijasah.value == 'S3' ? this.arrDataEdit2[33] : ''
      let ipkS3 = this.ijasah.value == 'S3' ? this.arrDataEdit2[34] : ''

      //data3
      let telp = this.arrDataEdit3[0]
      let wa = this.arrDataEdit3[1]
      let usernameBy = this.usernameBy.value
      let alamat = this.arrDataEdit3[3]
      let alamatDomisili = this.arrDataEdit3[7]
      let email = this.arrDataEdit3[4]
      let validasiEmail = this.arrDataEdit3[4]
      let username = this.arrDataEdit3[4].split("@")[0]

      // data5
      let tipeSeragam1 = this.fut.value
      let sizeSeragam1 = this.fus.value
      let tipeSeragam2 = this.sut.value
      let sizeSeragam2 = this.sus.value
      let tipeOlahraga = this.st.value
      let sizeOlahraga = this.ss.value
      let hijab = this.hijab.value

      // data6
      let namaIbuKandung = this.arrDataEdit2[9]

      // data7
      let tanggalAktifKerja = this.tanggalAktifKehadiran
      let polaAbsensi = this.polaAbsensi.value
      let kodePolaAbsensi = this.kodePolaAbsensi.value
      let shiftKe = this.shiftAktif.value
      let wajibGps = this.wajibGPS.value
      let hideWfh = this.hideWFH.value

      // data8
      let jumlahDevice = this.jumlahDevice

      // data9
      let noNpwp = this.arrDataEdit9[0]
      let nik = this.arrDataEdit9[1]
      let bpjsk = this.arrDataEdit9[2]
      let bpjstk = this.arrDataEdit9[3]
      let noDplk = this.arrDataEdit9[4]
      let bankDplk = this.arrDataEdit9[5]
      let noGaji = this.arrDataEdit9[6]
      let bankGaji = this.arrDataEdit9[7]
      let adMedika = this.arrDataEdit9[8]


      // data10
      let fotoKtp = this.arrDataEdit10[0]
      let fotoKk = this.arrDataEdit10[1]
      let fotoNpwp = this.arrDataEdit10[3]
      let fotoBpjsK = this.arrDataEdit10[4]
      let fotoBpjsTK = this.arrDataEdit10[5]

      let docSma = ''
      let docD1 = ''
      let docD2 = ''
      let docD3 = ''
      let docD4 = ''
      let docS1 = ''
      let docS2 = ''
      let docS3 = ''

      if (this.arrData2[5] == 'S3') {
        docS1 = this.docFotoIjasahEdit1
        docS2 = this.docFotoIjasahEdit2
        docS3 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'S2') {
        docS1 = this.docFotoIjasahEdit1
        docS2 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'S1') {
        docS1 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'D1') {
        docD1 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'D2') {
        docD2 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'D3') {
        docD3 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'D4') {
        docD4 = this.docFotoIjasahEdit3
      } else if (this.arrData2[5] == 'SMA/SMK/Setingkat') {
        docSma = this.docFotoIjasahEdit3
      }

      let tipe = ''
      if (value == '') {
        if (this.idModal == '1') {
          tipe = 'U2'
          data2 = tempatLahir + x + tanggalLahir + x + status + x + golonganDarah + x + jenisKelamin + x + ijasah + x + tanggalBerakhirKontrak + x + negara + x + agama + x + gpsInterval + x + smp + x + namaSma + x + jurusanSma + x + namaD1 + x + jurusanD1 + x + ipkD1 + x + namaD2 + x + jurusanD2 + x + ipkD2 + x + namaD3 + x + jurusanD3 + x + ipkD3 + x + namaD4 + x + jurusanD4 + x + ipkD4 + x + namaS1 + x + jurusanS1 + x + ipkS1 + x + namaS2 + x + jurusanS2 + x + ipkS2 + x + namaS3 + x + jurusanS3 + x + ipkS3
          data6 = x + x + x + x + x + x + x + x + x + x + x + x + x + namaIbuKandung
        } else if (this.idModal == '2') {
          tipe = 'U3'
          data3 = telp + x + wa + x + usernameBy + x + alamat + x + email + x + validasiEmail + x + username + x + alamatDomisili
        } else if (this.idModal == '4') {
          tipe = 'U5'
          data5 = tipeSeragam1 + x + sizeSeragam1 + x + tipeSeragam2 + x + sizeSeragam2 + x + tipeOlahraga + x + sizeOlahraga + x + hijab
        } else if (this.idModal == '5') {
          tipe = 'U7'
          data7 = tanggalAktifKerja + x + polaAbsensi + x + kodePolaAbsensi + x + shiftKe + x + x
        } else if (this.idModal == '9') {
          tipe = 'U9'
          data9 = noNpwp + x + nik + x + bpjsk + x + bpjstk + x + noDplk + x + bankDplk + x + noGaji + x + bankGaji + x + adMedika
        } else if (this.idModal == '0') {
          tipe = 'U1'
          data1 = organisasi + x + idPegawai + x + aktif + x + x + x + x + nip + x + lvl + x + bidang + x + jabatan + x + atasan + x + tipePegawai + x + role + x + radius + x + pjtk + x + jenjang + x + sync + x + harga
          data7 = x + x + x + x + wajibGps + x + hideWfh
        } else if (this.idModal == '3') {
          tipe = 'UN'
          data1 = x + x + x + x + nama + x + namaAlias + x + x + x + x + x + x + x + x + x + x + x + x + x
          data7 = x + x + x + x + x
        } else if (this.idModal == '11') {
          tipe = 'U8'
          data8 = jumlahDevice
        }
      } else if (value == 'foto') {
        tipe = 'UF'
        data1 = x + x + x + fotoProfil + x + x + x + x + x + x + x + x + x + x + x + x + x + x + x
        data7 = x + x + x + x + x
      } else if (value == 'U10') {
        tipe = 'U10'
        data10 = fotoKtp + x + fotoKk + x + docSma + x + fotoNpwp + x + fotoBpjsK + x + fotoBpjsTK + x + docD1 + x + docD2 + x + docD3 + x + docD4 + x + docS1 + x + docS2 + x + docS3
      }

      let payload = {
        data1: data1,
        data2: data2,
        data3: data3,
        data4: data4,
        data5: data5,
        data6: data6,
        data7: data7,
        data8: data8,
        data9: data9,
        data10: data10,
        tipe: tipe,
        idPegawai: idPegawai
      }
      DataApi.post("pegawai/save/detail", payload)
          .then(res => {
            let show = res.data.data
            if (show.Data1 == 'T') {
              this.errModal = show.Data2
            } else {
              this.errModal = ''
              this.getTeam(this.idPeg, '1')
              this.closeModal()
            }
          })
    },
    onSubmitPenempatan(par) {
      let tipe = ''
      let unix = ''
      if (this.createPenempatan == false) {
        unix = this.arrDataEdit4[this.editKantorID][4]
        tipe = 'U'
      } else {
        tipe = 'C'
        unix = ''
      }
      if (par == 'D') {
        tipe = 'D'
      }
      let payload = {
        idKantor: this.idKantor,
        idPegawai: this.idPeg,
        tglExpired: this.tanggalExpired,
        tipe: tipe,
        unix: unix
      }
      DataApi.post("pegawai/save/kantor", payload)
          .then(res => {
            let show = res
            this.getTeam(this.idPeg, '1')
            this.queryKantor = ''
            this.tanggalExpired = ''
            this.closeModal()
          })
    },
    onSubmitKeluarga() {
      let payload = {
        birthDate: this.tanggalKeluargaLahir,
        familyType: this.tipeKeluarga.value,
        idPegawai: this.idPeg,
        marriedDate: this.tanggalKeluargaMenikah,
        nama: this.namaKeluarga,
        status: 'A',
        urlFile: '',
        tipe: this.addKeluargaStatus,
        unix: this.editKeluargaID,
        noKartu: this.editNoAdmedika
      }
      DataApi.post("pegawai/save/family", payload)
          .then(res => {
            let show = res
            this.getTeam(this.idPeg, '1')
            this.closeModal()
          })
    },
    onSubmitDevice() {
      let payload = {
        alasan: this.deviceAlasan,
        idAtasan: this.pegawaiID,
        idDevice: this.deviceId,
        idPegawai: this.idPeg
      }
      DataApi.post("pegawai/delete/device/backoffice", payload)
          .then(res => {
            let show = res
            this.getTeam(this.idPeg, '1')
            this.resetModal = false
            this.closeModal()
          })
    },

    // GET DATA SUPPORT
    getDataStatus() {
      this.dataStatus = [
        {value: 'Y', text: 'Active'},
        {value: 'T', text: 'Non Active'}
      ]
    },
    getDataSex() {
      this.dataSex = [
        {text: 'Laki-Laki', value: '1'},
        {text: 'Perempuan', value: '2'}
      ]
    },
    getDataAgama() {
      this.dataAgama = [
        {
          text: 'Islam',
          value: 'Islam'
        },
        {
          text: 'Kristen',
          value: 'Kristen'
        },
        {
          text: 'Katolik',
          value: 'Katolik'
        },
        {
          text: 'Hindu',
          value: 'Hindu'
        },
        {
          text: 'Budha',
          value: 'Budha'
        },
        {
          text: 'Khonghucu',
          value: 'Khonghucu'
        },
        {
          text: 'Lainnya',
          value: 'Lainnya'
        }
      ]
    },
    getDataMarrige() {
      this.dataMarrige = [
        {text: 'Belum Menikah', value: '0'},
        {text: 'Sudah Menikah', value: '1'}
      ]
    },
    getDataGolonganDarah() {
      this.dataGolonganDarah = [
        {
          text: 'A',
          value: 'A'
        },
        {
          text: 'B',
          value: 'B'
        },
        {
          text: 'AB',
          value: 'AB'
        },
        {
          text: 'O',
          value: 'O'
        }
      ]
    },
    getDataIjasah() {
      this.dataIjasah = [
        {
          text: 'SMA/SMK/Setingkat',
          value: 'SMA/SMK/Setingkat'
        },
        {
          text: 'D1',
          value: 'D1'
        },
        {
          text: 'D2',
          value: 'D2'
        },
        {
          text: 'D3',
          value: 'D3'
        },
        {
          text: 'D4',
          value: 'D4'
        },
        {
          text: 'S1',
          value: 'S1'
        },
        {
          text: 'S2',
          value: 'S2'
        },
        {
          text: 'S3',
          value: 'S3'
        },
      ]
    },
    getDataUsernameBy() {
      this.dataUsernameBy = [
        {value: '1', text: 'LDAP'},
        {value: '2', text: 'Google'},
      ]
    },
    getDataNormal(obj) {
      this.dataNormalOrShift = []
      this.shiftAktif.value = ''
      this.shiftAktif.text = ''
      this.dataShiftKe = []
      let payload = ''
      if (obj == 'null') {
        payload = {
          limit: 9999,
          kode: '',
          pageIn: 1,
        }
      } else {
        payload = {
          limit: 10,
          kode: obj,
          pageIn: 1,
        }
      }
      DataApi.post("jam_kerja/lihat", payload)
          .then(res => {
            let response = res.data.data
            let tempData = response.data
            let data = []
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              data.push(onPush)
            }
            let filter = []
            var j
            for (j = 0; j < data.length; j++) {
              if (filter.length == 0) {
                let inPush = {
                  value: data[j].value,
                  text: data[j].text
                }
                filter.push(inPush)
              } else {
                var k
                let status = false
                for (k = 0; k < filter.length; k++) {
                  if (data[j].value == filter[k].value) {
                    status = true
                    break
                  } else {
                    status = false
                  }
                }
                if (status == false) {
                  let inPush = {
                    value: data[j].value,
                    text: data[j].text
                  }
                  filter.push(inPush)
                }
              }
            }
            this.dataNormalOrShift = filter
            if (obj != 'null') {
              this.kodePolaAbsensi.value = this.dataNormalOrShift[0].value
              this.kodePolaAbsensi.text = this.dataNormalOrShift[0].text
            }
          })
    },
    getDataShift(obj) {
      this.dataNormalOrShift = []
      let payload = ''
      if (obj == 'null') {
        payload = {
          limit: 9999,
          kodeShift: '',
          deskripsi: '',
          pageIn: 1,
        }
      } else {
        payload = {
          limit: 10,
          kodeShift: obj,
          deskripsi: '',
          pageIn: 1,
        }
      }
      DataApi.post("shift/lihat", payload)
          .then(res => {
            let response = res.data.data
            let tempData = response.data
            this.fullDataShift = tempData
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              this.dataNormalOrShift.push(onPush)
            }
            if (obj != 'null') {
              this.kodePolaAbsensi.value = this.dataNormalOrShift[0].value
              this.kodePolaAbsensi.text = this.dataNormalOrShift[0].text
              this.getDataShiftKe(this.arrDataEdit7[3])
            }
          })
    },
    getDataShiftKe(obj) {
      if (this.polaAbsensi.text == 'Shift') {
        var i = 0
        this.dataShiftKe = []
        for (i = 0; i < this.fullDataShift.length; i++) {
          if (this.kodePolaAbsensi.value == this.fullDataShift[i].kode) {
            let shift1 = parseInt(this.fullDataShift[i].shift1Hari)
            let shift2 = parseInt(this.fullDataShift[i].shift2Hari)
            let shift3 = parseInt(this.fullDataShift[i].shift3Hari)
            let shift4 = parseInt(this.fullDataShift[i].shift4Hari)
            let totalShift = shift1 + shift2 + shift3 + shift4
            var j = 0
            for (j = 0; j < totalShift; j++) {
              let push = {
                text: (j + 1).toString(),
                value: j + 1
              }
              this.dataShiftKe.push(push)
            }
          }
        }
        if (obj != 'null') {
          var s = 0
          for (s = 0; s < this.dataShiftKe.length; s++) {
            if (this.dataShiftKe[s].text == obj) {
              this.shiftAktif.value = this.dataShiftKe[s].value
              this.shiftAktif.text = this.dataShiftKe[s].text
              break
            } else {
              this.shiftAktif.value = ''
              this.shiftAktif.text = ''
            }
          }
        }
      } else {
        this.shiftAktif.value = ''
        this.shiftAktif.text = ''
      }
    },
    getNormalOrShift() {
      if (this.polaAbsensi.value != '') {
        if (this.polaAbsensi.value == '1') {
          this.getDataNormal('null')
          this.shiftAktif.value = ''
          this.shiftAktif.text = ''
        } else {
          this.getDataShift('null')
        }
      }
    },
    getDataPolaAbsensi() {
      this.dataPolaAbsensi = [
        {text: 'Normal', value: '1'},
        {text: 'Shift', value: '0'}
      ]
    },
    getDataSeragam() {
      this.dataUkuranSeragam = [
        {text: 'S', value: 'S'},
        {text: 'M', value: 'M'},
        {text: 'L', value: 'L'},
        {text: 'XL', value: 'XL'},
        {text: 'XXL', value: 'XXL'},
      ]
      this.dataTipeSeragam = [
        {text: 'Long', value: 'Long'},
        {text: 'Short', value: 'Short'},
      ]
      this.dataHijabSeragam = [
        {text: 'Yes', value: '1'},
        {text: 'No', value: '2'},
      ]
    },
    getDataBulan() {
      this.dataBulan = [
        {
          text: 'Januari',
          value: '1'
        },
        {
          text: 'Februari',
          value: '2'
        },
        {
          text: 'Maret',
          value: '3'
        },
        {
          text: 'April',
          value: '4'
        },
        {
          text: 'Mei',
          value: '5'
        },
        {
          text: 'Juni',
          value: '6'
        },
        {
          text: 'Juli',
          value: '7'
        },
        {
          text: 'Agustus',
          value: '8'
        },
        {
          text: 'September',
          value: '9'
        },
        {
          text: 'Oktober',
          value: '10'
        },
        {
          text: 'November',
          value: '11'
        },
        {
          text: 'Desember',
          value: '12'
        },
      ]
    },
    getDataTahun() {
      let now = this.tanggal.getFullYear()
      this.dataYear = [
        {
          text: now - 5,
          value: now - 5
        },
        {
          text: now - 4,
          value: now - 4
        },
        {
          text: now - 3,
          value: now - 3
        },
        {
          text: now - 2,
          value: now - 2
        },
        {
          text: now - 1,
          value: now - 1
        },
        {
          text: now,
          value: now
        },
        {
          text: now + 1,
          value: now + 1
        },
        {
          text: now + 2,
          value: now + 2
        },
        {
          text: now + 3,
          value: now + 3
        },
        {
          text: now + 4,
          value: now + 4
        },
        {
          text: now + 5,
          value: now + 5
        }
      ]
    },
    getDataTipeKeluarga() {
      this.dataTipeKeluarga = [
        {text: 'Pasangan', value: 'S'},
        {text: 'Anak', value: 'K'}
      ]
    },
    getDataWajibGPS() {
      this.dataWajibGPS = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
    },
    getDataGpsInterval() {
      this.dataGpsInterval = [
        {value: '15', text: '15 Menit'},
        {value: '30', text: '30 Menit'},
        {value: '60', text: '60 Menit'},
        {value: '120', text: '120 Menit'},
      ]
    },
    getDataHideWFH() {
      this.dataHideWFH = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
    },
    getDataAktif() {
      this.dataAktif = [
        {value: 'Y', text: 'Active'},
        {value: 'T', text: 'Non Active'}
      ]
    },
    getDataPJTK() {
      let limit = 9999
      let page = 1
      let nama = ''

      let payload = {
        limit: 9999,
        namaOrganisasi: "",
        organisasi: "",
        pageIn: page,
        pjtk: 'Y'
      }
      DataApi.post("perusahaan/get", payload)
          .then(res => {
            this.dataPJTK = []
            let response = res.data
            if (response.success == true) {
              let temp = response.data.data
              var i
              for (i = 0; i < temp.length; i++) {
                let push = {
                  text: temp[i].nama,
                  value: temp[i].kode
                }
                this.dataPJTK.push(push)
              }
            }
          })
    },
    getDataJenjang() {
      let payload = {
        jenjang: ''
      }
      DataApi.post("pegawai/jenjang/lihat", payload)
          .then(response => {
            this.dataJenjang = []
            let res = response.data
            if (res.success == true) {
              let data = res.data
              var i
              for (i = 0; i < data.length; i++) {
                let onPush = {
                  value: data[i].jenjang,
                  text: data[i].jenjang
                }
                this.dataJenjang.push(onPush)
              }
            }
          })
    },
    getDataSync() {
      this.dataSync = [
        {value: '1', text: 'Yes'},
        {value: '2', text: 'No'}
      ]
    },

    // CONFIGURE
    findData() {
      this.getData()
    },
    movePage(direction) {
      if (direction == 'prev') {
        this.page = this.page - 1
      } else {
        this.page = this.page + 1
      }
      this.getData()
    },
    validatePage(page) {
      if (page > this.totalPage) {
        this.page = this.totalPage
      }
    },
    reload() {
      this.searchValue = ''
      this.filterStatus.value = ''
      this.filterStatus.text = ''
      this.searchJobPosition = ''
      this.kodeTipePegawai = ''
      this.queryTipePegawai = ''
      this.idUnitSearch = ''
      this.queryUnitSearch = ''
      this.getDataStatus()
      this.flagSearch = true
      this.getData()
      if (this.classReload == 'reloadOff') {
        this.classReload = 'reloadOn'
      } else {
        this.classReload = 'reloadOff'
      }
    },
    move() {
      this.detail = false
      this.menuFlag = '1'
      this.arrData1 = []
      this.arrDataEdit1 = []
      this.arrData2 = []
      this.arrDataEdit2 = []
      this.arrData3 = []
      this.arrDataEdit3 = []
      this.arrData4 = []
      this.arrDataEdit4 = []
      this.arrData5 = []
      this.arrDataEdit5 = []
      this.arrData6 = []
      this.arrDataEdit6 = []
      this.arrData7 = []
      this.arrDataEdit7 = []
      this.arrData8 = []
      this.arrDataEdit8 = []
      this.arrData9 = []
      this.arrDataEdit9 = []
      this.arrData10 = []
      this.arrDataEdit10 = []
      this.arrData11 = []
      this.arrDataEdit11 = []
      this.arrData12 = []
      this.arrDataEdit12 = []
      this.arrDataTeam = []
      this.dataJamKerja = []
      this.queryUnit = ''
      this.idUnits = ''
      this.queryPegawai = ''
      this.idAtasan = ''
      this.queryKantor = ''
      this.idKantor = ''
      this.queryEditTipePegawai = ''
      this.kodeEditTipePegawai = ''
      this.queryEditTipeRole = ''
      this.kodeEditTipeRole = ''
      this.queryNegara = ''
      this.urlImageFotoIjasah1 = ''
      this.showImageFotoIjasah1 = ''
      this.urlPathFotoIjasah1 = ''
      this.docFotoIjasah1 = ''
      this.docFotoIjasahEdit1 = ''
      this.urlImageFotoIjasah2 = ''
      this.showImageFotoIjasah2 = ''
      this.urlPathFotoIjasah2 = ''
      this.docFotoIjasah2 = ''
      this.docFotoIjasahEdit2 = ''
      this.urlImageFotoIjasah3 = ''
      this.showImageFotoIjasah3 = ''
      this.urlPathFotoIjasah3 = ''
      this.docFotoIjasah3 = ''
      this.docFotoIjasahEdit3 = ''
    },
    moveMenu(param) {
      if (param == 'infoKepegawaian') {
        this.menuFlag = '1'
      } else if (param == 'infoDataDiri') {
        this.menuFlag = '2'
      } else if (param == 'penempatanKerja') {
        this.menuFlag = '3'
      } else if (param == 'seragam') {
        this.menuFlag = '4'
      } else if (param == 'keluarga') {
        this.menuFlag = '5'
      } else if (param == 'jadwalJamKerja') {
        this.menuFlag = '6'
      } else if (param == 'team') {
        this.menuFlag = '7'
      } else if (param == 'device') {
        this.menuFlag = '8'
      } else if (param == 'dokumen') {
        this.menuFlag = '9'
        this.getPegawaiDocumentsList()
      } else if (param == 'vaksin') {
        this.menuFlag = '10'
      }
    },
    async getPegawaiDocumentsList() {
      let idPegawai = this.arrDataEdit1[1];
      if (!idPegawai) return;
      try {
        let res = await DataApi.get(`admin/pegawai/documents/${idPegawai}`);
        if (res.data.success) {
          this.pegawaiDocumentsList = res.data.data;
        } else {
          this.pegawaiDocumentsList = [];
        }
      } catch (e) {
        console.log(e);
        this.pegawaiDocumentsList = [];
      }
    },
    handleUploadPegawaiDocument(e) {
      let files = Array.from(e.target.files);
      let newDocs = files.map(f => ({
          file: f,
          name: f.name.replace(/\.[^/.]+$/, "")
      }));
      this.selectedPegawaiDocs = [...this.selectedPegawaiDocs, ...newDocs];
      if (this.$refs.pegawaiDocumentFiles) this.$refs.pegawaiDocumentFiles.value = null;
    },
    removeSelectedDocument(idx) {
      this.selectedPegawaiDocs.splice(idx, 1);
    },
    async submitPegawaiDocument() {
      if (!this.selectedPegawaiDocs || this.selectedPegawaiDocs.length === 0) {
        this.successDetail = false;
        this.alertMessDetail = 'Pilih file terlebih dahulu';
        this.currentAlertCounterDetail = 5;
        return;
      }
      
      let hasEmptyName = this.selectedPegawaiDocs.some(item => !item.name || item.name.trim() === '');
      if (hasEmptyName) {
        this.successDetail = false;
        this.alertMessDetail = 'Nama dokumen tidak boleh kosong';
        this.currentAlertCounterDetail = 5;
        return;
      }

      this.isUploadingPegawaiDoc = true;
      let idPegawai = this.arrDataEdit1[1];
      let fd = new FormData();
      fd.append('idPegawai', idPegawai);
      this.selectedPegawaiDocs.forEach(item => {
        fd.append('files', item.file);
        fd.append('fileNames', item.name.trim());
      });
      try {
        let res = await DataApi.post('admin/pegawai/documents/upload', fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.data.success) {
          this.successDetail = true;
          this.alertMessDetail = 'Berhasil mengunggah dokumen';
          this.currentAlertCounterDetail = 5;
          this.selectedPegawaiDocs = [];
          this.getPegawaiDocumentsList();
        } else {
          this.successDetail = false;
          this.alertMessDetail = res.data.message || 'Gagal mengunggah dokumen';
          this.currentAlertCounterDetail = 5;
        }
      } catch (e) {
        console.log(e);
        this.successDetail = false;
        this.alertMessDetail = 'Terjadi kesalahan saat mengunggah dokumen';
        this.currentAlertCounterDetail = 5;
      } finally {
        this.isUploadingPegawaiDoc = false;
      }
    },
    async deletePegawaiDocument(fileId) {
      if (!confirm('Yakin ingin menghapus dokumen ini?')) return;
      let idPegawai = this.arrDataEdit1[1];
      try {
        let res = await DataApi.delete(`admin/pegawai/documents/delete?fileId=${fileId}&idPegawai=${idPegawai}`);
        if (res.data.success) {
          this.successDetail = true;
          this.alertMessDetail = 'Berhasil menghapus dokumen';
          this.currentAlertCounterDetail = 5;
          this.getPegawaiDocumentsList();
        } else {
          this.successDetail = false;
          this.alertMessDetail = res.data.message || 'Gagal menghapus dokumen';
          this.currentAlertCounterDetail = 5;
        }
      } catch (e) {
        console.log(e);
        this.successDetail = false;
        this.alertMessDetail = 'Terjadi kesalahan sistem';
        this.currentAlertCounterDetail = 5;
      }
    },
    async viewPegawaiDocument(fileId, fileName) {
      if (this.loadingViewDocId) return;
      this.loadingViewDocId = fileId;
      this.viewDocUrl = null;
      this.viewDocIsImage = false;
      this.viewDocModal = true;
      try {
        let res = await DataApi.get(`admin/pegawai/documents/view?fileId=${fileId}`, { responseType: 'blob' });
        
        let ext = fileName ? fileName.split('.').pop().toLowerCase() : '';
        let mimeType = 'application/pdf'; // Default fallback
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(ext)) {
            mimeType = 'image/' + (ext === 'jpg' ? 'jpeg' : ext === 'svg' ? 'svg+xml' : ext);
        } else if (ext === 'pdf') {
            mimeType = 'application/pdf';
        } else if (res.headers['content-type'] && res.headers['content-type'] !== 'application/octet-stream') {
            mimeType = res.headers['content-type'];
        }

        this.viewDocIsImage = mimeType.startsWith('image/');
        const blob = new Blob([res.data], { type: mimeType });
        this.viewDocUrl = window.URL.createObjectURL(blob);
      } catch (e) {
        console.log(e);
        this.viewDocModal = false;
        this.successDetail = false;
        this.alertMessDetail = 'Gagal memuat file dokumen';
        this.currentAlertCounterDetail = 5;
      } finally {
        this.loadingViewDocId = null;
      }
    },
    closeViewDocModal() {
      this.viewDocModal = false;
      if (this.viewDocUrl) {
        window.URL.revokeObjectURL(this.viewDocUrl);
        this.viewDocUrl = null;
      }
    },
    setDate() {
      let month = this.tanggal.getMonth() + 1
      let year = this.tanggal.getFullYear()
      this.selectedTahun.value = year
      this.selectedTahun.text = year
      if (month == 1) {
        this.selectedBulan.value = '1'
        this.selectedBulan.text = 'Januari'
      }
      if (month == 2) {
        this.selectedBulan.value = '2'
        this.selectedBulan.text = 'Februari'
      }
      if (month == 3) {
        this.selectedBulan.value = '3'
        this.selectedBulan.text = 'Maret'
      }
      if (month == 4) {
        this.selectedBulan.value = '4'
        this.selectedBulan.text = 'April'
      }
      if (month == 5) {
        this.selectedBulan.value = '5'
        this.selectedBulan.text = 'Mei'
      }
      if (month == 6) {
        this.selectedBulan.value = '6'
        this.selectedBulan.text = 'Juni'
      }
      if (month == 7) {
        this.selectedBulan.value = '7'
        this.selectedBulan.text = 'Juli'
      }
      if (month == 8) {
        this.selectedBulan.value = '8'
        this.selectedBulan.text = 'Agustus'
      }
      if (month == 9) {
        this.selectedBulan.value = '9'
        this.selectedBulan.text = 'September'
      }
      if (month == 10) {
        this.selectedBulan.value = '10'
        this.selectedBulan.text = 'Oktober'
      }
      if (month == 11) {
        this.selectedBulan.value = '11'
        this.selectedBulan.text = 'November'
      }
      if (month == 12) {
        this.selectedBulan.value = '12'
        this.selectedBulan.text = 'Desember'
      }
    },
    prevMonth() {
      if (this.selectedBulan.value == '1') {
        this.selectedBulan.value = '12'
        this.selectedBulan.text = 'Desember'
        this.selectedTahun.value = this.selectedTahun.value - 1
        this.selectedTahun.text = this.selectedTahun.text - 1
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '2') {
        this.selectedBulan.value = '1'
        this.selectedBulan.text = 'Januari'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '3') {
        this.selectedBulan.value = '2'
        this.selectedBulan.text = 'Februari'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '4') {
        this.selectedBulan.value = '3'
        this.selectedBulan.text = 'Maret'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '5') {
        this.selectedBulan.value = '4'
        this.selectedBulan.text = 'April'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '6') {
        this.selectedBulan.value = '5'
        this.selectedBulan.text = 'Mei'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '7') {
        this.selectedBulan.value = '6'
        this.selectedBulan.text = 'Juni'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '8') {
        this.selectedBulan.value = '7'
        this.selectedBulan.text = 'Juli'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '9') {
        this.selectedBulan.value = '8'
        this.selectedBulan.text = 'Agustus'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '10') {
        this.selectedBulan.value = '9'
        this.selectedBulan.text = 'September'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '11') {
        this.selectedBulan.value = '10'
        this.selectedBulan.text = 'Oktober'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '12') {
        this.selectedBulan.value = '11'
        this.selectedBulan.text = 'November'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      }
    },
    nextMonth() {
      if (this.selectedBulan.value == '11') {
        this.selectedBulan.value = '12'
        this.selectedBulan.text = 'Desember'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '12') {
        this.selectedTahun.value = this.selectedTahun.value + 1
        this.selectedTahun.text = this.selectedTahun.text + 1
        this.selectedBulan.value = '1'
        this.selectedBulan.text = 'Januari'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '1') {
        this.selectedBulan.value = '2'
        this.selectedBulan.text = 'Februari'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '2') {
        this.selectedBulan.value = '3'
        this.selectedBulan.text = 'Maret'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '3') {
        this.selectedBulan.value = '4'
        this.selectedBulan.text = 'April'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '4') {
        this.selectedBulan.value = '5'
        this.selectedBulan.text = 'Mei'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '5') {
        this.selectedBulan.value = '6'
        this.selectedBulan.text = 'Juni'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '6') {
        this.selectedBulan.value = '7'
        this.selectedBulan.text = 'Juli'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '7') {
        this.selectedBulan.value = '8'
        this.selectedBulan.text = 'Agustus'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '8') {
        this.selectedBulan.value = '9'
        this.selectedBulan.text = 'September'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '9') {
        this.selectedBulan.value = '10'
        this.selectedBulan.text = 'Oktober'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      } else if (this.selectedBulan.value == '10') {
        this.selectedBulan.value = '11'
        this.selectedBulan.text = 'November'
        this.getDataJamKerja(this.idPegawaiJamKerja)
      }
    },
    separatorTglLahir(val) {
      if (val == '-') {
        return val
      } else {
        let value = val.split("-")
        let month = ''
        let mth = value[1]
        if (mth == '01' || mth == 1 || mth == '1') {
          month = 'Januari'
        } else if (mth == '02' || mth == 2 || mth == '2') {
          month = 'Februari'
        } else if (mth == '03' || mth == 3 || mth == '3') {
          month = 'Maret'
        } else if (mth == '04' || mth == 4 || mth == '4') {
          month = 'April'
        } else if (mth == '05' || mth == 5 || mth == '5') {
          month = 'Mei'
        } else if (mth == '06' || mth == 6 || mth == '6') {
          month = 'Juni'
        } else if (mth == '07' || mth == 7 || mth == '7') {
          month = 'Juli'
        } else if (mth == '08' || mth == 8 || mth == '8') {
          month = 'Agustus'
        } else if (mth == '09' || mth == 9 || mth == '9') {
          month = 'September'
        } else if (mth == 10 || mth == '10') {
          month = 'Oktober'
        } else if (mth == 11 || mth == '11') {
          month = 'November'
        } else if (mth == 12 || mth == '12') {
          month = 'Desember'
        }

        return value[2] + ' ' + month + ' ' + value[0]
      }
    },
    separatorHijab(value) {
      if (value == 1 || value == '1') {
        return 'Yes'
      } else if (value == 2 || value == '2') {
        return 'No'
      } else {
        return '-'
      }
    },
    changeDefault(e) {
      e.target.src = this.sampelImage
    },
    loadStyleImage(index) {
      if (index == 0) {
        return 'cursor:pointer;border-radius:50%;border:1px solid white;background-color:#dcdcdc;z-index:' + this.totalDataTeam
      } else {
        let z = this.totalDataTeam - index
        return 'cursor:pointer;border-radius:50%;border:1px solid white;background-color:#dcdcdc;;margin-left:-8px;z-index:' + z
      }
    },


    // CHANGE IMAGE
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImage = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.urlImage = e.target.result;
      };
      reader.readAsDataURL(file);
      setTimeout(this.saveImage, 300)
    },
    saveImage() {
      if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
        let imageData = this.showImage
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit1[3] = response.data.urlPath
                this.onSubmit('foto')
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImage == '') {
        this.arrDataEdit1[3] = ''
        this.onSubmit('foto')
      } else {
        this.arrDataEdit1[3] = this.urlImage
        this.onSubmit('foto')
      }
    },

    // DATA PEGAWAI
    getDataPegawai(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          bidang: '',
          jabatan: '',
          limit: 10,
          nama: this.queryPegawai.split(" - ")[0],
          pageIn: 1,
          pegawaiId: '',
          tipePegawai: ''
        }
      } else {
        payload = {
          bidang: '',
          jabatan: '',
          limit: 10,
          nama: '',
          pageIn: 1,
          pegawaiId: val,
          tipePegawai: ''
        }
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            this.dataPegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].idPegawai,
                text: tempData[i].nama + ' - ' + tempData[i].nik
              }
              this.dataPegawai.push(onPush)
            }
            if (val != 'null') {
              this.queryPegawai = this.dataPegawai[0].text
              this.idAtasan = this.dataPegawai[0].value
            }
          })
    },
    goSyncEmp() {
      this.loading = true
      DataApi.post("pegawai/sync_pegawai")
          .then(res => {
            let response = res.data
            this.success = response.success
            this.alertMess = response.message
            this.loading = false
            this.currentAlertCounter = 7
          })
    },
    toggleVisiblePegawai() {
      this.visiblePegawai = true;
    },
    hidePegawai() {
      this.visiblePegawai = false;
    },
    toggleCloseVisiblePegawai() {
      setTimeout(this.hidePegawai, 1000);
    },
    itemClickedPegawai(index) {
      this.selectedPegawai = index;
      this.selectItemPegawai();
    },
    selectItemPegawai() {
      if (!this.matchesPegawai.length) {
        return;
      }
      this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
      this.visiblePegawai = false;
      this.queryPegawai = this.selectedItemPegawai.text
      this.idAtasan = this.selectedItemPegawai.value
      if (this.shouldReset) {
        this.queryPegawai = '';
        this.selectedPegawai = 0;
      }
    },
    upPegawai() {
      if (this.selectedPegawai == 0) {
        return;
      }
      this.selectedPegawai -= 1;
      this.scrollToItemPegawai();
    },
    downPegawai() {
      if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
        return;
      }
      this.selectedPegawai += 1;
      this.scrollToItemPegawai();
    },
    scrollToItemPegawai() {
      this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
    },

    // DATA KANTOR
    getDataKantor(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          kantorId: '',
          kota: '',
          limit: 10,
          nama: this.queryKantor,
          pageIn: 1,
          provinsi: ''
        }
      } else {
        payload = {
          kantorId: val,
          kota: '',
          limit: 10,
          nama: '',
          pageIn: 1,
          provinsi: ''
        }
      }
      DataApi.post("kantor/get", payload)
          .then(res => {
            this.dataKantor = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].id,
                text: tempData[i].nama
              }
              this.dataKantor.push(onPush)
            }
            if (val != 'null') {
              this.queryKantor = this.dataKantor[0].text
              this.idKantor = this.dataKantor[0].value
            }
          })
    },
    toggleVisibleKantor() {
      this.visibleKantor = true;
    },
    hideKantor() {
      this.visibleKantor = false;
    },
    toggleCloseVisibleKantor() {
      setTimeout(this.hideKantor, 1000);
    },
    itemClickedKantor(index) {
      this.selectedKantor = index;
      this.selectItemKantor();
    },
    selectItemKantor() {
      if (!this.matchesKantor.length) {
        return;
      }
      this.selectedItemKantor = this.matchesKantor[this.selectedKantor];
      this.visibleKantor = false;
      this.queryKantor = this.selectedItemKantor.text
      this.idKantor = this.selectedItemKantor.value
      if (this.shouldReset) {
        this.queryKantor = '';
        this.selectedKantor = 0;
      }
    },
    upKantor() {
      if (this.selectedKantor == 0) {
        return;
      }
      this.selectedKantor -= 1;
      this.scrollToItemKantor();
    },
    downKantor() {
      if (this.selectedKantor >= this.matchesKantor.length - 1) {
        return;
      }
      this.selectedKantor += 1;
      this.scrollToItemKantor();
    },
    scrollToItemKantor() {
      this.$refs.optionsList.scrollTop = this.selectedKantor * this.itemHeight;
    },

    // DATA UNIT
    getDataUnit(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          limit: 10,
          namaUnit: this.queryUnit,
          pageIn: 1,
          namaParentUnit: '',
          idUnit: ''
        }
      } else {
        payload = {
          limit: 10,
          namaUnit: '',
          pageIn: 1,
          namaParentUnit: '',
          idUnit: val
        }
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataUnit = []
            let response = res.data.data
            let tempData = response.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = ''
              if (tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang
                }
              } else {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang + ' - ' + tempData[i].parentBidang
                }
              }
              this.dataUnit.push(onPush)
            }
            if (val != 'null') {
              this.queryUnit = this.dataUnit[0].text
              this.idUnits = this.dataUnit[0].value
            }
          })
    },
    toggleVisibleUnit() {
      this.visibleUnit = true;
    },
    hideUnit() {
      this.visibleUnit = false;
    },
    toggleCloseVisibleUnit() {
      setTimeout(this.hideUnit, 1000);
    },
    itemClickedUnit(index) {
      this.selectedUnit = index;
      this.selectItemUnit();
    },
    selectItemUnit() {
      if (!this.matchesUnit.length) {
        return;
      }
      this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
      this.queryUnit = this.selectedItemUnit.text
      this.idUnits = this.selectedItemUnit.value
      this.visibleUnit = false;
      if (this.shouldReset) {
        this.queryUnit = '';
        this.selectedUnit = 0;
      }
    },
    upUnit() {
      if (this.selectedUnit == 0) {
        return;
      }
      this.selectedUnit -= 1;
      this.scrollToItemUnit();
    },
    downUnit() {
      if (this.selectedUnit >= this.matchesUnit.length - 1) {
        return;
      }
      this.selectedUnit += 1;
      this.scrollToItemUnit();
    },
    scrollToItemUnit() {
      this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
    },

    // DATA SEARCH UNIT
    getDataUnitSerach() {
      let payload = {
        limit: 10,
        namaUnit: this.queryUnitSearch,
        pageIn: 1,
        namaParentUnit: '',
        idUnit: ''
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataUnitSearch = []
            let response = res.data.data
            let tempData = response.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = ''
              if (tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang
                }
              } else {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang + ' - ' + tempData[i].parentBidang
                }
              }
              this.dataUnitSearch.push(onPush)
            }
          })
    },
    toggleVisibleUnitSearch() {
      this.visibleUnitSearch = true;
    },
    hideUnitSearch() {
      this.visibleUnitSearch = false;
    },
    toggleCloseVisibleUnitSearch() {
      setTimeout(this.hideUnitSearch, 1000);
    },
    itemClickedUnitSearch(index) {
      this.selectedUnitSearch = index;
      this.selectItemUnitSearch();
    },
    selectItemUnitSearch() {
      if (!this.matchesUnitSearch.length) {
        return;
      }
      this.selectedItemUnitSearch = this.matchesUnitSearch[this.selectedUnitSearch];
      this.queryUnitSearch = this.selectedItemUnitSearch.text
      this.idUnitSearch = this.selectedItemUnitSearch.value
      this.visibleUnitSearch = false;
      if (this.shouldReset) {
        this.queryUnitSearch = '';
        this.selectedUnitSearch = 0;
      }
    },
    upUnitSearch() {
      if (this.selectedUnitSearch == 0) {
        return;
      }
      this.selectedUnitSearch -= 1;
      this.scrollToItemUnitSearch();
    },
    downUnitSearch() {
      if (this.selectedUnitSearch >= this.matchesUnitSearch.length - 1) {
        return;
      }
      this.selectedUnitSearch += 1;
      this.scrollToItemUnitSearch();
    },
    scrollToItemUnitSearch() {
      this.$refs.optionsList.scrollTop = this.selectedUnitSearch * this.itemHeight;
    },

    /**
     * SEARCH TIPE PEGAWAI
     */
    getDataTipePegawai() {
      this.dataTipePegawai = []
      let payload = {
        keterangan: this.queryTipePegawai,
        limit: 10,
        pageIn: 1
      }
      DataApi.post("pegawai/status/lihat", payload)
          .then(res => {
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].keterangan,
                pjtk: tempData[i].pjtk,
                pegawai: tempData[i].pegawai
              }
              this.dataTipePegawai.push(onPush)
            }
          })
    },
    toggleVisibleTipePegawai() {
      this.visibleTipePegawai = true;
    },
    hideTipePegawai() {
      this.visibleTipePegawai = false;
    },
    toggleCloseVisibleTipePegawai() {
      setTimeout(this.hideTipePegawai, 1000);
    },
    itemClickedTipePegawai(index) {
      this.selectedTipePegawai = index;
      this.selectItemTipePegawai();
    },
    itemClickedTipePegawaiBefore(index) {
      this.selectedTipePegawai = index;
      this.selectedItemTipePegawai = this.dataTipePegawai[this.selectedTipePegawai];
      this.kodeTipePegawai = this.selectedItemTipePegawai.value
      this.queryTipePegawai = this.selectedItemTipePegawai.text
      this.visibleTipePegawai = false;
    },
    selectItemTipePegawai() {
      if (!this.matchesTipePegawai.length) {
        return;
      }
      this.selectedItemTipePegawai = this.matchesTipePegawai[this.selectedTipePegawai];
      this.visibleTipePegawai = false;
      this.kodeTipePegawai = this.selectedItemTipePegawai.value
      this.queryTipePegawai = this.selectedItemTipePegawai.text
      if (this.shouldReset) {
        this.queryTipePegawai = '';
        this.selectedTipePegawai = 0;
      }
    },
    upTipePegawai() {
      if (this.selectedTipePegawai == 0) {
        return;
      }
      this.selectedTipePegawai -= 1;
      this.scrollToItemTipePegawai();
    },
    downTipePegawai() {
      if (this.selectedTipePegawai >= this.matchesTipePegawai.length - 1) {
        return;
      }
      this.selectedTipePegawai += 1;
      this.scrollToItemTipePegawai();
    },
    scrollToItemTipePegawai() {
      this.$refs.optionsList.scrollTop = this.selectedTipePegawai * this.itemHeight;
    },

    /**
     * SEARCH NEGARA
     */
    getDataNegara(val) {
      let payload = ''
      if (val == 'null' || val == '') {
        payload = {
          negara: this.queryNegara
        }
      } else {
        payload = {
          negara: val
        }
      }

      DataApi.post("kantor/get/negara", payload)
          .then(res => {
            this.dataNegara = []
            let response = res.data.data
            var i;
            for (i = 0; i < response.length; i++) {
              let values = {
                value: response[i],
                text: response[i]
              }
              this.dataNegara.push(values)
            }
            if (val != 'null' && val != '') {
              this.queryNegara = this.dataNegara[0].text
            }
          })
    },
    toggleVisibleNegara() {
      this.visibleNegara = true;
    },
    hideNegara() {
      this.visibleNegara = false;
    },
    toggleCloseVisibleNegara() {
      setTimeout(this.hideNegara, 1000);
    },
    itemClickedNegara(index) {
      this.selectedNegara = index;
      this.selectItemNegara();
    },
    itemClickedNegaraBefore(index) {
      this.selectedNegara = index;
      this.selectedItemNegara = this.dataNegara[this.selectedNegara];
      this.queryNegara = this.selectedItemNegara.text
      this.visibleNegara = false;
    },
    selectItemNegara() {
      if (!this.matchesNegara.length) {
        return;
      }
      this.selectedItemNegara = this.matchesNegara[this.selectedNegara];
      this.queryNegara = this.selectedItemNegara.text
      this.visibleNegara = false;
      if (this.shouldReset) {
        this.queryNegara = '';
        this.selectedNegara = 0;
      }
    },
    upNegara() {
      if (this.selectedNegara == 0) {
        return;
      }
      this.selectedNegara -= 1;
      this.scrollToItemNegara();
    },
    downNegara() {
      if (this.selectedNegara >= this.matchesNegara.length - 1) {
        return;
      }
      this.selectedNegara += 1;
      this.scrollToItemNegara();
    },
    scrollToItemNegara() {
      this.$refs.optionsList.scrollTop = this.selectedNegara * this.itemHeight;
    },


    /**
     * SEARCH EDIT TIPE PEGAWAI
     */
    getDataEditTipePegawai(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          keterangan: this.queryEditTipePegawai,
          limit: 10,
          pageIn: 1,
        }
      } else {
        payload = {
          keterangan: val,
          limit: 10,
          pageIn: 1
        }
      }
      DataApi.post("pegawai/status/lihat", payload)
          .then(res => {
            this.dataEditTipePegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].keterangan,
                pjtk: tempData[i].pjtk,
                pegawai: tempData[i].pegawai
              }
              this.dataEditTipePegawai.push(onPush)
            }
            if (val != 'null') {
              this.queryEditTipePegawai = this.dataEditTipePegawai[0].text
              this.kodeEditTipePegawai = this.dataEditTipePegawai[0].value
              if (this.dataEditTipePegawai[0].pjtk == 'Y') {
                this.disEditPjtk = false
              } else {
                this.disEditPjtk = true
              }

              if (this.dataEditTipePegawai[0].pegawai == 'Y') {
                this.disEditJenjang = false
              } else {
                this.disEditJenjang = true
              }
            }
          })
    },
    toggleVisibleEditTipePegawai() {
      this.visibleEditTipePegawai = true;
    },
    hideEditTipePegawai() {
      this.visibleEditTipePegawai = false;
    },
    toggleCloseVisibleEditTipePegawai() {
      setTimeout(this.hideEditTipePegawai, 1000);
    },
    itemClickedEditTipePegawai(index) {
      this.selectedEditTipePegawai = index;
      this.selectItemEditTipePegawai();
    },
    itemClickedEditTipePegawaiBefore(index) {
      this.selectedEditTipePegawai = index;
      this.selectedItemEditTipePegawai = this.dataEditTipePegawai[this.selectedEditTipePegawai];
      this.kodeEditTipePegawai = this.selectedItemEditTipePegawai.value
      this.queryEditTipePegawai = this.selectedItemEditTipePegawai.text
      this.visibleEditTipePegawai = false;
    },
    selectItemEditTipePegawai() {
      if (!this.matchesEditTipePegawai.length) {
        return;
      }
      this.selectedItemEditTipePegawai = this.matchesEditTipePegawai[this.selectedEditTipePegawai];
      this.visibleEditTipePegawai = false;
      this.kodeEditTipePegawai = this.selectedItemEditTipePegawai.value
      this.queryEditTipePegawai = this.selectedItemEditTipePegawai.text
      if (this.shouldReset) {
        this.queryEditTipePegawai = '';
        this.selectedEditTipePegawai = 0;
      }
    },
    upEditTipePegawai() {
      if (this.selectedEditTipePegawai == 0) {
        return;
      }
      this.selectedEditTipePegawai -= 1;
      this.scrollToItemEditTipePegawai();
    },
    downEditTipePegawai() {
      if (this.selectedEditTipePegawai >= this.matchesEditTipePegawai.length - 1) {
        return;
      }
      this.selectedEditTipePegawai += 1;
      this.scrollToItemEditTipePegawai();
    },
    scrollToItemEditTipePegawai() {
      this.$refs.optionsList.scrollTop = this.selectedEditTipePegawai * this.itemHeight;
    },

    /**
     * SEARCH EDIT TIPE ROLE
     */
    getDataEditTipeRole(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          limit: 10,
          pageIn: 1,
          nama: this.queryEditTipeRole,
        }
      } else {
        payload = {
          limit: 10,
          pageIn: 1,
          nama: val,
        }
      }
      DataApi.post("menu/role/get", payload)
          .then(res => {
            this.dataEditTipeRole = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].idRole,
                text: tempData[i].namaRole
              }
              this.dataEditTipeRole.push(onPush)
            }
            if (val != 'null') {
              this.queryEditTipeRole = this.dataEditTipeRole[0].text
              this.kodeEditTipeRole = this.dataEditTipeRole[0].value
            }
          })
    },
    toggleVisibleEditTipeRole() {
      this.visibleEditTipeRole = true;
    },
    hideEditTipeRole() {
      this.visibleEditTipeRole = false;
    },
    toggleCloseVisibleEditTipeRole() {
      setTimeout(this.hideEditTipeRole, 1000);
    },
    itemClickedEditTipeRole(index) {
      this.selectedEditTipeRole = index;
      this.selectItemEditTipeRole();
    },
    itemClickedEditTipeRoleBefore(index) {
      this.selectedEditTipeRole = index;
      this.selectedItemEditTipeRole = this.dataEditTipeRole[this.selectedEditTipeRole];
      this.kodeEditTipeRole = this.selectedItemEditTipeRole.value
      this.queryEditTipeRole = this.selectedItemEditTipeRole.text
      this.visibleEditTipeRole = false;
    },
    selectItemEditTipeRole() {
      if (!this.matchesEditTipeRole.length) {
        return;
      }
      this.selectedItemEditTipeRole = this.matchesEditTipeRole[this.selectedEditTipeRole];
      this.visibleEditTipeRole = false;
      this.kodeEditTipeRole = this.selectedItemEditTipeRole.value
      this.queryEditTipeRole = this.selectedItemEditTipeRole.text
      if (this.shouldReset) {
        this.queryEditTipeRole = '';
        this.selectedEditTipeRole = 0;
      }
    },
    upEditTipeRole() {
      if (this.selectedEditTipeRole == 0) {
        return;
      }
      this.selectedEditTipeRole -= 1;
      this.scrollToItemEditTipeRole();
    },
    downEditTipeRole() {
      if (this.selectedEditTipeRole >= this.matchesEditTipeRole.length - 1) {
        return;
      }
      this.selectedEditTipeRole += 1;
      this.scrollToItemEditTipeRole();
    },
    scrollToItemEditTipeRole() {
      this.$refs.optionsList.scrollTop = this.selectedEditTipeRole * this.itemHeight;
    },

    onFileChangeEditFotoKtp(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoKtp = files[0];
      this.createFotoKtp(files[0]);
    },
    onFileChangeEditFotoKk(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoKk = files[0];
      this.createFotoKk(files[0]);
    },
    onFileChangeEditFotoIjasah1(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoIjasah1 = files[0];
      this.createFotoIjasah1(files[0]);
    },
    onFileChangeEditFotoIjasah2(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoIjasah2 = files[0];
      this.createFotoIjasah2(files[0]);
    },
    onFileChangeEditFotoIjasah3(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoIjasah3 = files[0];
      this.createFotoIjasah3(files[0]);
    },
    onFileChangeEditFotoNpwp(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoNpwp = files[0];
      this.createFotoNpwp(files[0]);
    },
    onFileChangeEditFotoBpjsKesehatan(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoBpjsKesehatan = files[0];
      this.createFotoBpjsKesehatan(files[0]);
    },
    onFileChangeEditFotoBpjsKetenagakerjaan(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImageFotoBpjsKetenagakerjaan = files[0];
      this.createFotoBpjsKetenagakerjaan(files[0]);
    },

    createFotoKtp(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoKtp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoKk(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoKk = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoIjasah1(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoIjasah1 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoIjasah2(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoIjasah2 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoIjasah3(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoIjasah3 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoNpwp(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoNpwp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoBpjsKesehatan(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoBpjsKesehatan = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createFotoBpjsKetenagakerjaan(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.urlImageFotoBpjsKetenagakerjaan = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    saveImageKtp() {
      if (this.urlImageFotoKtp.split(":")[0] == 'data' && this.urlImageFotoKtp != '') {
        let imageData = this.showImageFotoKtp
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit10[0] = response.data.urlPath
                this.saveImageKk()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoKtp == '') {
        this.arrDataEdit10[0] = ''
        this.saveImageKk()
      } else {
        this.arrDataEdit10[0] = this.urlImageFotoKtp
        this.saveImageKk()
      }
    },
    saveImageKk() {
      if (this.urlImageFotoKk.split(":")[0] == 'data' && this.urlImageFotoKk != '') {
        let imageData = this.showImageFotoKk
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit10[1] = response.data.urlPath
                if (this.arrData2[5] == 'S2' || this.arrData2[5] == 'S3') {
                  this.saveImageIjasah1()
                } else {
                  this.saveImageIjasah3()
                }
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoKk == '') {
        this.arrDataEdit10[1] = ''
        if (this.arrData2[5] == 'S2' || this.arrData2[5] == 'S3') {
          this.saveImageIjasah1()
        } else {
          this.saveImageIjasah3()
        }
      } else {
        this.arrDataEdit10[1] = this.urlImageFotoKk
        if (this.arrData2[5] == 'S2' || this.arrData2[5] == 'S3') {
          this.saveImageIjasah1()
        } else {
          this.saveImageIjasah3()
        }
      }
    },
    saveImageIjasah1() {
      if (this.urlImageFotoIjasah1.split(":")[0] == 'data' && this.urlImageFotoIjasah1 != '') {
        let imageData = this.showImageFotoIjasah1
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.docFotoIjasahEdit1 = response.data.urlPath
                if (this.arrData2[5] == 'S3') {
                  this.saveImageIjasah2()
                } else {
                  this.saveImageIjasah3()
                }
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoIjasah1 == '') {
        this.docFotoIjasahEdit1 = ''
        if (this.arrData2[5] == 'S3') {
          this.saveImageIjasah2()
        } else {
          this.saveImageIjasah3()
        }
      } else {
        this.docFotoIjasahEdit1 = this.urlImageFotoIjasah1
        if (this.arrData2[5] == 'S3') {
          this.saveImageIjasah2()
        } else {
          this.saveImageIjasah3()
        }
      }
    },
    saveImageIjasah2() {
      if (this.urlImageFotoIjasah2.split(":")[0] == 'data' && this.urlImageFotoIjasah2 != '') {
        let imageData = this.showImageFotoIjasah2
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.docFotoIjasahEdit2 = response.data.urlPath
                this.saveImageIjasah3()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoIjasah2 == '') {
        this.docFotoIjasahEdit2 = ''
        this.saveImageIjasah3()
      } else {
        this.docFotoIjasahEdit2 = this.urlImageFotoIjasah2
        this.saveImageIjasah3()
      }
    },
    saveImageIjasah3() {
      if (this.urlImageFotoIjasah3.split(":")[0] == 'data' && this.urlImageFotoIjasah3 != '') {
        let imageData = this.showImageFotoIjasah3
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.docFotoIjasahEdit3 = response.data.urlPath
                this.saveImageNpwp()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoIjasah3 == '') {
        this.docFotoIjasahEdit3 = ''
        this.saveImageNpwp()
      } else {
        this.docFotoIjasahEdit3 = this.urlImageFotoIjasah3
        this.saveImageNpwp()
      }
    },
    saveImageNpwp() {
      if (this.urlImageFotoNpwp.split(":")[0] == 'data' && this.urlImageFotoNpwp != '') {
        let imageData = this.showImageFotoNpwp
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit10[3] = response.data.urlPath
                this.saveImageBpjsK()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoNpwp == '') {
        this.arrDataEdit10[3] = ''
        this.saveImageBpjsK()
      } else {
        this.arrDataEdit10[3] = this.urlImageFotoNpwp
        this.saveImageBpjsK()
      }
    },
    saveImageBpjsK() {
      if (this.urlImageFotoBpjsKesehatan.split(":")[0] == 'data' && this.urlImageFotoBpjsKesehatan != '') {
        let imageData = this.showImageFotoBpjsKesehatan
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit10[4] = response.data.urlPath
                this.saveImageBpjsTk()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoBpjsKesehatan == '') {
        this.arrDataEdit10[4] = ''
        this.saveImageBpjsTk()
      } else {
        this.arrDataEdit10[4] = this.urlImageFotoBpjsKesehatan
        this.saveImageBpjsTk()
      }
    },
    saveImageBpjsTk() {
      if (this.urlImageFotoBpjsKetenagakerjaan.split(":")[0] == 'data' && this.urlImageFotoBpjsKetenagakerjaan != '') {
        let imageData = this.showImageFotoBpjsKetenagakerjaan
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.arrDataEdit10[5] = response.data.urlPath
                this.onSubmit('U10')
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImageFotoBpjsKetenagakerjaan == '') {
        this.arrDataEdit10[5] = ''
        this.onSubmit('U10')
      } else {
        this.arrDataEdit10[5] = this.urlImageFotoBpjsKetenagakerjaan
        this.onSubmit('U10')
      }
    },

    editRemoveImage(il) {
      if (il == 'ktp') {
        this.showImageFotoKtp = ''
        this.urlImageFotoKtp = ''
        this.urlPathFotoKtp = ''
      }
      if (il == 'kk') {
        this.showImageFotoKk = ''
        this.urlImageFotoKk = ''
        this.urlPathFotoKk = ''
      }
      if (il == 'ijasah1') {
        this.showImageFotoIjasah1 = ''
        this.urlImageFotoIjasah1 = ''
        this.urlPathFotoIjasah1 = ''
      }
      if (il == 'ijasah2') {
        this.showImageFotoIjasah2 = ''
        this.urlImageFotoIjasah2 = ''
        this.urlPathFotoIjasah2 = ''
      }
      if (il == 'ijasah3') {
        this.showImageFotoIjasah3 = ''
        this.urlImageFotoIjasah3 = ''
        this.urlPathFotoIjasah3 = ''
      }
      if (il == 'npwp') {
        this.showImageFotoNpwp = ''
        this.urlImageFotoNpwp = ''
        this.urlPathFotoNpwp = ''
      }
      if (il == 'bpjsKesehatan') {
        this.showImageFotoBpjsKesehatan = ''
        this.urlImageFotoBpjsKesehatan = ''
        this.urlPathFotoBpjsKesehatan = ''
      }
      if (il == 'bpjsKetenagakerjaan') {
        this.showImageFotoBpjsKetenagakerjaan = ''
        this.urlImageFotoBpjsKetenagakerjaan = ''
        this.urlPathFotoBpjsKetenagakerjaan = ''
      }

    },


    /**
     * ADD AREA
     */
    goAddData() {
      this.areaAdd = true
      this.addUrlImageFotoProfil = '',
          this.addShowImageFotoProfil = '',
          this.addUrlPathFotoProfil = '',
          this.addNama = '',
          this.addNip = '',
          this.addJabatan = '',
          this.addRadius = '',
          this.addPJTK.value = '',
          this.addPJTK.text = ''
      this.addJenjang.value = ''
      this.addJenjang.text = ''
      this.addBidang = '',
          this.queryAddUnit = '',
          this.idAddUnit = '',
          this.queryAddPegawai = '',
          this.idAddPegawai = '',
          this.queryAddTipePegawai = '',
          this.kodeAddTipePegawai = '',
          this.selectedAddRole.value = '',
          this.selectedAddRole.text = '',
          this.addNamaAlias = '',
          this.addTempatLahir = '',
          this.addTanggalLahir = '',
          this.selectedAddStatus.value = '',
          this.selectedAddStatus.text = '',
          this.selectedAddGolonganDarah.value = '',
          this.selectedAddGolonganDarah.text = '',
          this.selectedAddAgama.value = '',
          this.selectedAddAgama.text = '',
          this.selectedAddJenisKelamin.value = '',
          this.selectedAddJenisKelamin.text = '',
          this.selectedAddIjasah.value = '',
          this.selectedAddIjasah.text = '',
          this.addBerakhirKontrak = '',
          this.checkTanggalBerakhir = '',
          this.addNegara = '',
          this.addTelp = '',
          this.checkWa = '',
          this.addWa = '',
          this.addEmail = '',
          this.addValidasiEmail = '',
          this.addUsername = '',
          this.selectedAddUsernameBy.text = '',
          this.selectedAddUsernameBy.value = '',
          this.queryAddProvinsi = '',
          this.queryAddKota = '',
          this.queryAddKecamatan = '',
          this.queryAddKelurahan = '',
          this.addAlamat = '',
          this.addAlamatDomisili = '',
          this.queryAddKantor = '',
          this.idAddKantor = '',
          this.addTanggalExpiredPenempatan = '',
          this.selectedAddTipeSeragam1.value = '',
          this.selectedAddTipeSeragam1.text = '',
          this.selectedAddTipeSeragam2.value = '',
          this.selectedAddTipeSeragam2.text = '',
          this.selectedAddTipeOlahraga.value = '',
          this.selectedAddTipeOlahraga.text = '',
          this.selectedAddSizeSeragam1.value = '',
          this.selectedAddSizeSeragam1.text = '',
          this.selectedAddSizeSeragam2.value = '',
          this.selectedAddSizeSeragam2.text = '',
          this.selectedAddSizeOlahraga.value = '',
          this.selectedAddSizeOlahraga.text = '',
          this.selectedAddHijab.value = '',
          this.selectedAddHijab.text = '',
          this.addNamaPasangan = '',
          this.addTanggalLahirPasangan = '',
          this.addTanggalMenikah = '',
          this.addNamaAnak1 = '',
          this.addNamaAnak2 = '',
          this.addNamaAnak3 = '',
          this.addTanggalLahirAnak1 = '',
          this.addTanggalLahirAnak2 = '',
          this.addTanggalLahirAnak3 = '',
          this.addNoAdmedikaPasangan = '',
          this.addNoAdmedikaAnak1 = '',
          this.addNoAdmedikaAnak2 = '',
          this.addNoAdmedikaAnak3 = '',
          this.addNamaIbuKandung = '',
          this.addTanggalAktif = '',
          this.selectedAddPolaAbsensi.value = '',
          this.selectedAddPolaAbsensi.text = '',
          this.selectedAddKodePolaAbsensi.value = '',
          this.selectedAddKodePolaAbsensi.text = '',
          this.selectedAddShiftKe.value = '',
          this.selectedAddShiftKe.text = '',
          this.selectedAddWajibGps.value = '',
          this.selectedAddWajibGps.text = '',
          this.selectedAddGpsInterval.value = '',
          this.selectedAddGpsInterval.text = '',
          this.selectedAddHideWfh.value = '',
          this.selectedAddHideWfh.text = '',
          this.addJumlahDevice = 1,
          this.addNik = '',
          this.addNpwp = '',
          this.addBpjsKesehatan = '',
          this.addBpjsKetenagakerjaan = '',
          this.addNoRekDplk = '',
          this.addNamaBankDplk = '',
          this.addNoRekGaji = '',
          this.addNamaBankGaji = '',
          this.addUrlImageFotoKtp = '',
          this.addShowImageFotoKtp = '',
          this.addUrlPathFotoKtp = '',
          this.addUrlImageFotoKk = '',
          this.addShowImageFotoKk = '',
          this.addUrlPathFotoKk = '',
          this.addUrlImageFotoIjasah = '',
          this.addShowImageFotoIjasah = '',
          this.addUrlPathFotoIjasah = '',
      this.addUrlImageFotoNpwp = '',
      this.addShowImageFotoNpwp = '',
      this.addUrlPathFotoNpwp = '',
      this.addUrlImageFotoBpjsKesehatan = '',
      this.addShowImageFotoBpjsKesehatan = '',
      this.addUrlPathFotoBpjsKesehatan = '',
      this.addUrlImageFotoBpjsKetenagakerjaan = '',
      this.addShowImageFotoBpjsKetenagakerjaan = '',
      this.addUrlPathFotoBpjsKetenagakerjaan = '',
      this.addSync.value = '2'
      this.addSync.text = 'No'

      this.getDataAddPJTK()
      this.getDataAddJenjang()
      this.getDataAddRole()
      this.getDataAddStatus()
      this.getDataAddGolonganDarah()
      this.getDataAddJenisKelamin()
      this.getDataAddAgama()
      this.getDataAddIjasah()
      this.getDataAddUsernameBy()
      this.getAddProvinsi()
      this.getDataAddKantor()
      this.getDataAddTipeSeragam1()
      this.getDataAddTipeSeragam2()
      this.getDataAddTipeOlahraga()
      this.getDataAddSizeSeragam1()
      this.getDataAddSizeSeragam2()
      this.getDataAddSizeOlahraga()
      this.getDataAddHijab()
      this.getDataAddPolaAbsensi()
      this.getDataAddWajibGps()
      this.getDataAddGpsInterval()
      this.getDataAddHideWfh()
      this.getDataAddSync()

      this.$v.$reset()
    },
    // kepegawaian
    onFileChangeFotoProfil(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.addShowImageFotoProfil = files[0];
      this.createImageFotoProfil(files[0]);
    },
    createImageFotoProfil(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoProfil = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    getDataAddUnit() {
      let payload = {
        limit: 10,
        namaUnit: this.queryAddUnit,
        pageIn: 1,
        namaParentUnit: '',
        idUnit: ''
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataAddUnit = []
            let response = res.data.data
            let tempData = response.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = ''
              if (tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang
                }
              } else {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang + ' - ' + tempData[i].parentBidang
                }
              }
              this.dataAddUnit.push(onPush)
            }
          })
    },
    toggleVisibleAddUnit() {
      this.visibleAddUnit = true;
    },
    hideAddUnit() {
      this.visibleAddUnit = false;
    },
    toggleCloseVisibleAddUnit() {
      setTimeout(this.hideAddUnit, 1000);
    },
    itemClickedAddUnit(index) {
      this.selectedAddUnit = index;
      this.selectItemAddUnit();
    },
    selectItemAddUnit() {
      if (!this.matchesAddUnit.length) {
        return;
      }
      this.selectedItemAddUnit = this.matchesAddUnit[this.selectedAddUnit];
      this.queryAddUnit = this.selectedItemAddUnit.text
      this.idAddUnit = this.selectedItemAddUnit.value
      this.addBidang = this.selectedItemAddUnit.text.split(" - ")
      this.visibleAddUnit = false;
      if (this.shouldReset) {
        this.queryAddUnit = '';
        this.selectedAddUnit = 0;
      }
    },
    upAddUnit() {
      if (this.selectedAddUnit == 0) {
        return;
      }
      this.selectedAddUnit -= 1;
      this.scrollToItemAddUnit();
    },
    downAddUnit() {
      if (this.selectedAddUnit >= this.matchesAddUnit.length - 1) {
        return;
      }
      this.selectedAddUnit += 1;
      this.scrollToItemAddUnit();
    },
    scrollToItemAddUnit() {
      this.$refs.optionsList.scrollTop = this.selectedAddUnit * this.itemHeight;
    },

    getDataAddPegawai() {
      let payload = {
        bidang: '',
        jabatan: '',
        limit: 10,
        nama: this.queryAddPegawai,
        pageIn: 1,
        pegawaiId: '',
        tipePegawai: ''
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            this.dataAddPegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].idPegawai,
                text: tempData[i].nama + ' - ' + tempData[i].nik
              }
              this.dataAddPegawai.push(onPush)
            }
          })
    },
    toggleVisibleAddPegawai() {
      this.visibleAddPegawai = true;
    },
    hideAddPegawai() {
      this.visibleAddPegawai = false;
    },
    toggleCloseVisibleAddPegawai() {
      setTimeout(this.hideAddPegawai, 1000);
    },
    itemClickedAddPegawai(index) {
      this.selectedAddPegawai = index;
      this.selectItemAddPegawai();
    },
    selectItemAddPegawai() {
      if (!this.matchesAddPegawai.length) {
        return;
      }
      this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
      this.visibleAddPegawai = false;
      this.queryAddPegawai = this.selectedItemAddPegawai.text
      this.idAddPegawai = this.selectedItemAddPegawai.value
      if (this.shouldReset) {
        this.queryAddPegawai = '';
        this.selectedAddPegawai = 0;
      }
    },
    upAddPegawai() {
      if (this.selectedAddPegawai == 0) {
        return;
      }
      this.selectedAddPegawai -= 1;
      this.scrollToItemAddPegawai();
    },
    downAddPegawai() {
      if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
        return;
      }
      this.selectedAddPegawai += 1;
      this.scrollToItemAddPegawai();
    },
    scrollToItemAddPegawai() {
      this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
    },

    getDataAddTipePegawai() {
      let payload = {
        keterangan: this.queryAddTipePegawai,
        limit: 10,
        pageIn: 1
      }
      DataApi.post("pegawai/status/lihat", payload)
          .then(res => {
            this.dataAddTipePegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].keterangan,
                pjtk: tempData[i].pjtk
              }
              this.dataAddTipePegawai.push(onPush)
            }
          })
    },
    toggleVisibleAddTipePegawai() {
      this.visibleAddTipePegawai = true;
    },
    hideAddTipePegawai() {
      this.visibleAddTipePegawai = false;
    },
    toggleCloseVisibleAddTipePegawai() {
      setTimeout(this.hideAddTipePegawai, 1000);
    },
    itemClickedAddTipePegawai(index) {
      this.selectedAddTipePegawai = index;
      this.selectItemAddTipePegawai();
    },
    itemClickedAddTipePegawaiBefore(index) {
      this.selectedAddTipePegawai = index;
      this.selectedItemAddTipePegawai = this.dataAddTipePegawai[this.selectedAddTipePegawai];
      this.kodeAddTipePegawai = this.selectedItemAddTipePegawai.value
      this.queryAddTipePegawai = this.selectedItemAddTipePegawai.text
      this.visibleAddTipePegawai = false;
    },
    selectItemAddTipePegawai() {
      if (!this.matchesAddTipePegawai.length) {
        return;
      }
      this.selectedItemAddTipePegawai = this.matchesAddTipePegawai[this.selectedAddTipePegawai];
      this.visibleAddTipePegawai = false;
      this.kodeAddTipePegawai = this.selectedItemAddTipePegawai.value
      this.queryAddTipePegawai = this.selectedItemAddTipePegawai.text
      if (this.shouldReset) {
        this.queryAddTipePegawai = '';
        this.selectedAddTipePegawai = 0;
      }
    },
    upAddTipePegawai() {
      if (this.selectedAddTipePegawai == 0) {
        return;
      }
      this.selectedAddTipePegawai -= 1;
      this.scrollToItemAddTipePegawai();
    },
    downAddTipePegawai() {
      if (this.selectedAddTipePegawai >= this.matchesAddTipePegawai.length - 1) {
        return;
      }
      this.selectedAddTipePegawai += 1;
      this.scrollToItemAddTipePegawai();
    },
    scrollToItemAddTipePegawai() {
      this.$refs.optionsList.scrollTop = this.selectedAddTipePegawai * this.itemHeight;
    },

    getDataAddPJTK() {
      let limit = 9999
      let page = 1
      let nama = ''

      let payload = {
        limit: 9999,
        namaOrganisasi: "",
        organisasi: "",
        pageIn: page,
        pjtk: 'Y'
      }
      DataApi.post("perusahaan/get", payload)
          .then(res => {
            this.addDataPJTK = []
            let response = res.data
            if (response.success == true) {
              let temp = response.data.data
              var i
              for (i = 0; i < temp.length; i++) {
                let push = {
                  text: temp[i].nama,
                  value: temp[i].kode
                }
                this.addDataPJTK.push(push)
              }
            }
          })
    },

    getDataAddJenjang() {
      let payload = {
        jenjang: ''
      }
      DataApi.post("pegawai/jenjang/lihat", payload)
          .then(response => {
            this.addDataJenjang = []
            let res = response.data
            if (res.success == true) {
              let data = res.data
              var i
              for (i = 0; i < data.length; i++) {
                let onPush = {
                  value: data[i].jenjang,
                  text: data[i].jenjang
                }
                this.addDataJenjang.push(onPush)
              }
            }
          })
    },

    getDataAddRole() {
      let limit = 9999
      let page = 1
      let nama = ''

      let payload = {
        limit: limit,
        pageIn: page,
        nama: nama
      }
      DataApi.post("menu/role/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let tempDataRole = response.data.data
              this.pharsAddRole(tempDataRole)
            } else {
              this.datas = []
              this.errorMessage = response.message
            }
          })
    },
    pharsAddRole(data) {
      this.dataAddRole = []
      var i = 0
      for (i = 0; i < data.length; i++) {
        let onPush = {
          value: data[i].idRole,
          text: data[i].namaRole
        }
        this.dataAddRole.push(onPush)
      }
    },

    // sekilas
    getDataAddStatus() {
      this.dataAddStatus = [
        {
          text: 'Belum Menikah',
          value: '0'
        },
        {
          text: 'Sudah Menikah',
          value: '1'
        },

      ]
    },
    getDataAddGolonganDarah() {
      this.dataAddGolonganDarah = [
        {
          text: 'A',
          value: 'A'
        },
        {
          text: 'B',
          value: 'B'
        },
        {
          text: 'AB',
          value: 'AB'
        },
        {
          text: 'O',
          value: 'O'
        }
      ]
    },
    getDataAddAgama() {
      this.dataAddAgama = [
        {
          text: 'Islam',
          value: 'Islam'
        },
        {
          text: 'Kristen',
          value: 'Kristen'
        },
        {
          text: 'Katolik',
          value: 'Katolik'
        },
        {
          text: 'Hindu',
          value: 'Hindu'
        },
        {
          text: 'Budha',
          value: 'Budha'
        },
        {
          text: 'Khonghucu',
          value: 'Khonghucu'
        },
        {
          text: 'Lainnya',
          value: 'Lainnya'
        }
      ]
    },
    getDataAddJenisKelamin() {
      this.dataAddJenisKelamin = [
        {
          text: 'Laki-Laki',
          value: '1'
        },
        {
          text: 'Perempuan',
          value: '0'
        }
      ]
    },
    getDataAddIjasah() {
      this.dataAddIjasah = [
        {
          text: 'SD/MI/Setingkat',
          value: 'SD'
        },
        {
          text: 'SMP/MTS/Setingkat',
          value: 'SMP'
        },
        {
          text: 'SMA/SMK/Setingkat',
          value: 'SMA'
        },
        {
          text: 'D1',
          value: 'D1'
        },
        {
          text: 'D2',
          value: 'D2'
        },
        {
          text: 'D3',
          value: 'D3'
        },
        {
          text: 'D4',
          value: 'D4'
        },
        {
          text: 'S1',
          value: 'S1'
        },
        {
          text: 'S2',
          value: 'S2'
        },
        {
          text: 'S3',
          value: 'S3'
        },
        {
          text: 'Lainnya',
          value: 'Lainnya'
        },
      ]
    },

    getDataAddNegara() {
      let payload = {
        negara: this.queryAddNegara
      }
      DataApi.post("kantor/get/negara", payload)
          .then(res => {
            this.dataAddNegara = []
            let response = res.data.data
            var i;
            for (i = 0; i < response.length; i++) {
              let values = {
                value: response[i],
                text: response[i]
              }
              this.dataAddNegara.push(values)
            }
          })
    },
    toggleVisibleAddNegara() {
      this.visibleAddNegara = true;
    },
    hideAddNegara() {
      this.visibleAddNegara = false;
    },
    toggleCloseVisibleAddNegara() {
      setTimeout(this.hideAddNegara, 1000);
    },
    itemClickedAddNegara(index) {
      this.selectedAddNegara = index;
      this.selectItemAddNegara();
    },
    itemClickedAddNegaraBefore(index) {
      this.selectedAddNegara = index;
      this.selectedItemAddNegara = this.dataAddNegara[this.selectedAddNegara];
      this.queryAddNegara = this.selectedItemAddNegara.text
      this.visibleAddNegara = false;
    },
    selectItemAddNegara() {
      if (!this.matchesAddNegara.length) {
        return;
      }
      this.selectedItemAddNegara = this.matchesAddNegara[this.selectedAddNegara];
      this.queryAddNegara = this.selectedItemAddNegara.text
      this.visibleAddNegara = false;
      if (this.shouldReset) {
        this.queryAddNegara = '';
        this.selectedAddNegara = 0;
      }
    },
    upAddNegara() {
      if (this.selectedAddNegara == 0) {
        return;
      }
      this.selectedAddNegara -= 1;
      this.scrollToItemAddNegara();
    },
    downAddNegara() {
      if (this.selectedAddNegara >= this.matchesAddNegara.length - 1) {
        return;
      }
      this.selectedAddNegara += 1;
      this.scrollToItemAddNegara();
    },
    scrollToItemAddNegara() {
      this.$refs.optionsList.scrollTop = this.selectedAddNegara * this.itemHeight;
    },

    // kontak
    getDataAddUsernameBy() {
      this.dataAddUsernameBy = [
        {value: '1', text: 'LDAP'},
        {value: '2', text: 'Google'},
      ]
    },
    getAddProvinsi() {
      let payload = {
        provinsi: this.queryAddProvinsi
      }
      DataApi.post("kantor/get/provinsi", payload)
          .then(res => {
            this.dataAddProvinsi = []
            let response = res.data.data
            var i;
            for (i = 0; i < response.length; i++) {
              let values = {
                value: response[i],
                text: response[i]
              }
              this.dataAddProvinsi.push(values)
            }
          })
    },
    toggleVisibleAddProvinsi() {
      this.visibleAddProvinsi = true;
    },
    hideAddProvinsi() {
      this.visibleAddProvinsi = false;
    },
    toggleCloseVisibleAddProvinsi() {
      setTimeout(this.hideAddProvinsi, 1000);
    },
    itemClickedAddProvinsi(index) {
      this.selectedAddProvinsi = index;
      this.selectItemAddProvinsi();
    },
    selectItemAddProvinsi() {
      if (!this.matchesAddProvinsi.length) {
        return;
      }
      this.selectedItemAddProvinsi = this.matchesAddProvinsi[this.selectedAddProvinsi];
      this.queryAddProvinsi = this.selectedItemAddProvinsi.text
      this.getAddKota()
      this.visibleAddProvinsi = false;
      if (this.shouldReset) {
        this.queryAddProvinsi = '';
        this.selectedAddProvinsi = 0;
      }
    },
    upAddProvinsi() {
      if (this.selectedAddProvinsi == 0) {
        return;
      }
      this.selectedAddProvinsi -= 1;
      this.scrollToItemAddProvinsi();
    },
    downAddProvinsi() {
      if (this.selectedAddProvinsi >= this.matchesAddProvinsi.length - 1) {
        return;
      }
      this.selectedAddProvinsi += 1;
      this.scrollToItemAddProvinsi();
    },
    scrollToItemAddProvinsi() {
      this.$refs.optionsList.scrollTop = this.selectedAddProvinsi * this.itemHeight;
    },

    getAddKota() {
      if (this.queryAddProvinsi.length == 0) {
        this.dataAddKota = []
      } else {
        let payload = {
          kabkota: this.queryAddKota,
          provinsi: this.queryAddProvinsi
        }
        DataApi.post("kantor/get/kabkota", payload)
            .then(res => {
              this.dataAddKota = []
              let response = res.data.data
              var i;
              for (i = 0; i < response.length; i++) {
                let values = {
                  value: response[i].kabkota,
                  text: response[i].kabkota
                }
                this.dataAddKota.push(values)
              }
            })
      }
    },
    toggleVisibleAddKota() {
      this.visibleAddKota = true;
    },
    hideAddKota() {
      this.visibleAddKota = false;
    },
    toggleCloseVisibleAddKota() {
      setTimeout(this.hideAddKota, 1000);
    },
    itemClickedAddKota(index) {
      this.selectedAddKota = index;
      this.selectItemAddKota();
    },
    itemClickedAddKotaBefore(index) {
      this.selectedAddKota = index;
      this.selectedItemAddKota = this.dataAddKota[this.selectedAddKota];
      this.queryAddKota = this.selectedItemAddKota.text
      this.getAddKecamatan()
      this.visibleAddKota = false;
    },
    selectItemAddKota() {
      if (!this.matchesAddKota.length) {
        return;
      }
      this.selectedItemAddKota = this.matchesAddKota[this.selectedAddKota];
      this.queryAddKota = this.selectedItemAddKota.text
      this.getAddKecamatan()
      this.visibleAddKota = false;
      if (this.shouldReset) {
        this.queryAddKota = '';
        this.selectedAddKota = 0;
      }
    },
    upAddKota() {
      if (this.selectedAddKota == 0) {
        return;
      }
      this.selectedAddKota -= 1;
      this.scrollToItemAddKota();
    },
    downAddKota() {
      if (this.selectedAddKota >= this.matchesAddKota.length - 1) {
        return;
      }
      this.selectedAddKota += 1;
      this.scrollToItemAddKota();
    },
    scrollToItemAddKota() {
      this.$refs.optionsList.scrollTop = this.selectedAddKota * this.itemHeight;
    },

    getAddKecamatan() {
      if (this.queryAddProvinsi.length == 0 && this.queryAddKota == 0) {
        this.dataAddKecamatan = []
      } else {
        let payload = {
          kecamatan: this.queryAddKecamatan,
          kabkota: this.queryAddKota,
          provinsi: this.queryAddProvinsi
        }
        DataApi.post("kantor/get/kecamatan", payload)
            .then(res => {
              this.dataAddKecamatan = []
              let response = res.data.data
              var i;
              for (i = 0; i < response.length; i++) {
                let values = {
                  value: response[i].kecamatan,
                  text: response[i].kecamatan
                }
                this.dataAddKecamatan.push(values)
              }
            })
      }
    },
    toggleVisibleAddKecamatan() {
      this.visibleAddKecamatan = true;
    },
    hideAddKecamatan() {
      this.visibleAddKecamatan = false;
    },
    toggleCloseVisibleAddKecamatan() {
      setTimeout(this.hideAddKecamatan, 1000);
    },
    itemClickedAddKecamatan(index) {
      this.selectedAddKecamatan = index;
      this.selectItemAddKecamatan();
    },
    itemClickedAddKecamatanBefore(index) {
      this.selectedAddKecamatan = index;
      this.selectedItemAddKecamatan = this.dataAddKecamatan[this.selectedAddKecamatan];
      this.queryAddKecamatan = this.selectedItemAddKecamatan.text
      this.getAddKelurahan()
      this.visibleAddKecamatan = false;
    },
    selectItemAddKecamatan() {
      if (!this.matchesAddKecamatan.length) {
        return;
      }
      this.selectedItemAddKecamatan = this.matchesAddKecamatan[this.selectedAddKecamatan];
      this.queryAddKecamatan = this.selectedItemAddKecamatan.text
      this.getAddKelurahan()
      this.visibleAddKecamatan = false;
      if (this.shouldReset) {
        this.queryAddKecamatan = '';
        this.selectedAddKecamatan = 0;
      }
    },
    upAddKecamatan() {
      if (this.selectedAddKecamatan == 0) {
        return;
      }
      this.selectedAddKecamatan -= 1;
      this.scrollToItemAddKecamatan();
    },
    downAddKecamatan() {
      if (this.selectedAddKecamatan >= this.matchesAddKecamatan.length - 1) {
        return;
      }
      this.selectedAddKecamatan += 1;
      this.scrollToItemAddKecamatan();
    },
    scrollToItemAddKecamatan() {
      this.$refs.optionsList.scrollTop = this.selectedAddKecamatan * this.itemHeight;
    },

    getAddKelurahan() {
      if (this.queryAddProvinsi.length == 0 && this.queryAddKota == 0 && this.queryAddKecamatan == 0) {
        this.dataAddKelurahan = []
      } else {
        let payload = {
          kelurahan: this.queryAddKelurahan,
          kecamatan: this.queryAddKecamatan,
          kabkota: this.queryAddKota,
          provinsi: this.queryAddProvinsi
        }
        DataApi.post("kantor/get/kelurahan", payload)
            .then(res => {
              this.dataAddKelurahan = []
              let response = res.data.data
              var i;
              for (i = 0; i < response.length; i++) {
                let values = {
                  value: response[i].kelurahan,
                  text: response[i].kelurahan
                }
                this.dataAddKelurahan.push(values)
              }
            })
      }
    },
    toggleVisibleAddKelurahan() {
      this.visibleAddKelurahan = true;
    },
    hideAddKelurahan() {
      this.visibleAddKelurahan = false;
    },
    toggleCloseVisibleAddKelurahan() {
      setTimeout(this.hideAddKelurahan, 1000);
    },
    itemClickedAddKelurahan(index) {
      this.selectedAddKelurahan = index;
      this.selectItemAddKelurahan();
    },
    itemClickedAddKelurahanBefore(index) {
      this.selectedAddKelurahan = index;
      this.selectedItemAddKelurahan = this.dataAddKelurahan[this.selectedAddKelurahan];
      this.queryAddKelurahan = this.selectedItemAddKelurahan.text
      this.visibleAddKelurahan = false;
    },
    selectItemAddKelurahan() {
      if (!this.matchesAddKelurahan.length) {
        return;
      }
      this.selectedItemAddKelurahan = this.matchesAddKelurahan[this.selectedAddKelurahan];
      this.queryAddKelurahan = this.selectedItemAddKelurahan.text
      this.visibleAddKelurahan = false;
      if (this.shouldReset) {
        this.queryAddKelurahan = '';
        this.selectedAddKelurahan = 0;
      }
    },
    upAddKelurahan() {
      if (this.selectedAddKelurahan == 0) {
        return;
      }
      this.selectedAddKelurahan -= 1;
      this.scrollToItemAddKelurahan();
    },
    downAddKelurahan() {
      if (this.selectedAddKelurahan >= this.matchesAddKelurahan.length - 1) {
        return;
      }
      this.selectedAddKelurahan += 1;
      this.scrollToItemAddKelurahan();
    },
    scrollToItemAddKelurahan() {
      this.$refs.optionsList.scrollTop = this.selectedAddKelurahan * this.itemHeight;
    },

    // penempatan
    getDataAddKantor() {
      let payload = {
        kantorId: '',
        kota: '',
        limit: 10,
        nama: this.queryAddKantor,
        pageIn: 1,
        provinsi: ''
      }
      DataApi.post("kantor/get", payload)
          .then(res => {
            this.dataAddKantor = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].id,
                text: tempData[i].nama
              }
              this.dataAddKantor.push(onPush)
            }
          })
    },
    toggleVisibleAddKantor() {
      this.visibleAddKantor = true;
    },
    hideAddKantor() {
      this.visibleAddKantor = false;
    },
    toggleCloseVisibleAddKantor() {
      setTimeout(this.hideAddKantor, 1000);
    },
    itemClickedAddKantor(index) {
      this.selectedAddKantor = index;
      this.selectItemAddKantor();
    },
    selectItemAddKantor() {
      if (!this.matchesAddKantor.length) {
        return;
      }
      this.selectedItemAddKantor = this.matchesAddKantor[this.selectedAddKantor];
      this.visibleAddKantor = false;
      this.queryAddKantor = this.selectedItemAddKantor.text
      this.idAddKantor = this.selectedItemAddKantor.value
      if (this.shouldReset) {
        this.queryAddKantor = '';
        this.selectedAddKantor = 0;
      }
    },
    upAddKantor() {
      if (this.selectedAddKantor == 0) {
        return;
      }
      this.selectedAddKantor -= 1;
      this.scrollToItemAddKantor();
    },
    downAddKantor() {
      if (this.selectedAddKantor >= this.matchesAddKantor.length - 1) {
        return;
      }
      this.selectedAddKantor += 1;
      this.scrollToItemAddKantor();
    },
    scrollToItemAddKantor() {
      this.$refs.optionsList.scrollTop = this.selectedAddKantor * this.itemHeight;
    },

    // seragam
    getDataAddTipeSeragam1() {
      this.dataAddTipeSeragam1 = [
        {value: 'Long', text: 'Long'},
        {value: 'Short', text: 'Short'}
      ]
    },
    getDataAddTipeSeragam2() {
      this.dataAddTipeSeragam2 = [
        {value: 'Long', text: 'Long'},
        {value: 'Short', text: 'Short'}
      ]
    },
    getDataAddTipeOlahraga() {
      this.dataAddTipeOlahraga = [
        {value: 'Long', text: 'Long'},
        {value: 'Short', text: 'Short'}
      ]
    },
    getDataAddSizeSeragam1() {
      this.dataAddSizeSeragam1 = [
        {value: 'S', text: 'S'},
        {value: 'M', text: 'M'},
        {value: 'L', text: 'L'},
        {value: 'XL', text: 'XL'}
      ]
    },
    getDataAddSizeSeragam2() {
      this.dataAddSizeSeragam2 = [
        {value: 'S', text: 'S'},
        {value: 'M', text: 'M'},
        {value: 'L', text: 'L'},
        {value: 'XL', text: 'XL'}
      ]
    },
    getDataAddSizeOlahraga() {
      this.dataAddSizeOlahraga = [
        {value: 'S', text: 'S'},
        {value: 'M', text: 'M'},
        {value: 'L', text: 'L'},
        {value: 'XL', text: 'XL'}
      ]
    },
    getDataAddHijab() {
      this.dataAddHijab = [
        {value: '1', text: 'Yes'},
        {value: '2', text: 'No'}
      ]
    },

    // jam kerja
    getAddDataNormal() {
      let payload = {
        limit: 9999,
        kode: '',
        pageIn: 1,
      }
      DataApi.post("jam_kerja/lihat", payload)
          .then(res => {
            this.dataAddKodePolaAbsensi = []
            let response = res.data.data
            let tempData = response.data
            let data = []
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              data.push(onPush)
            }
            let filter = []
            var j
            for (j = 0; j < data.length; j++) {
              if (filter.length == 0) {
                let inPush = {
                  value: data[j].value,
                  text: data[j].text
                }
                filter.push(inPush)
              } else {
                var k
                let status = false
                for (k = 0; k < filter.length; k++) {
                  if (data[j].value == filter[k].value) {
                    status = true
                    break
                  } else {
                    status = false
                  }
                }
                if (status == false) {
                  let inPush = {
                    value: data[j].value,
                    text: data[j].text
                  }
                  filter.push(inPush)
                }
              }
            }
            this.dataAddKodePolaAbsensi = filter
          })
    },
    getAddDataShift() {
      let payload = {
        limit: 9999,
        kodeShift: '',
        deskripsi: '',
        pageIn: 1,
      }
      DataApi.post("shift/lihat", payload)
          .then(res => {
            this.dataAddKodePolaAbsensi = []
            let response = res.data.data
            let tempData = response.data
            this.addTempShift = tempData
            this.getDataAddShiftKe()
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              this.dataAddKodePolaAbsensi.push(onPush)
            }
          })
    },
    getDataAddShiftKe() {
      let val = this.addTempShift
      this.dataAddShiftKe = []
      if (this.selectedAddPolaAbsensi.text == 'Shift') {
        var i = 0
        for (i = 0; i < val.length; i++) {
          if (this.selectedAddKodePolaAbsensi.value == val[i].kode) {
            let shift1 = parseInt(val[i].shift1Hari)
            let shift2 = parseInt(val[i].shift2Hari)
            let shift3 = parseInt(val[i].shift3Hari)
            let shift4 = parseInt(val[i].shift4Hari)
            let totalShift = shift1 + shift2 + shift3 + shift4
            var j = 0
            this.dataAddShiftKe = []
            for (j = 0; j < totalShift; j++) {
              let push = {
                text: (j + 1).toString(),
                value: j + 1
              }
              this.dataAddShiftKe.push(push)
            }
          }
        }
      }
    },
    getAddNormalOrShift() {
      if (this.selectedAddPolaAbsensi.value != '') {
        if (this.selectedAddPolaAbsensi.value == '1') {
          this.getAddDataNormal()
          this.dataAddShiftKe = []
          this.selectedAddShiftKe.value = ''
          this.selectedAddShiftKe.text = ''
        } else {
          this.getAddDataShift()
        }
      }
    },
    getDataAddPolaAbsensi() {
      this.dataAddPolaAbsensi = [
        {text: 'Normal', value: '1'},
        {text: 'Shift', value: '2'}
      ]
    },
    getDataAddWajibGps() {
      this.dataAddWajibGps = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
      this.selectedAddWajibGps.value = 'T'
      this.selectedAddWajibGps.text = 'No'
    },
    getDataAddGpsInterval() {
      this.dataAddGpsInterval = [
        {value: '15', text: '15 Menit'},
        {value: '30', text: '30 Menit'},
        {value: '60', text: '60 Menit'},
        {value: '120', text: '120 Menit'},
      ]
    },
    getDataAddHideWfh() {
      this.dataAddHideWfh = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
      this.selectedAddHideWfh.value = 'T'
      this.selectedAddHideWfh.text = 'No'
    },
    getDataAddSync() {
      this.dataAddSync = [
        {value: '1', text: 'Yes'},
        {value: '2', text: 'No'}
      ]
    },

    // device
    countJumlahDevice(key) {
      let val = parseInt(this.addJumlahDevice)
      if (key == 'min') {
        this.addJumlahDevice = val - 1
      } else {
        this.addJumlahDevice = val + 1
      }
    },

    // kelengkapan dokumen
    onFileChangeFotoKtp(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoKtp = files[0];
        this.createImageFotoKtp(files[0]);
      }
    },
    onFileChangeFotoKk(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoKk = files[0];
        this.createImageFotoKk(files[0]);
      }
    },
    onFileChangeFotoIjasah(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoIjasah = files[0];
        this.createImageFotoIjasah(files[0]);
      }
    },
    onFileChangeFotoNpwp(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoNpwp = files[0];
        this.createImageFotoNpwp(files[0]);
      }
    },
    onFileChangeFotoBpjsKesehatan(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoBpjsKesehatan = files[0];
        this.createImageFotoBpjsKesehatan(files[0]);
      }
    },
    onFileChangeFotoBpjsKetenagakerjaan(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        alert("Maaf, File Lebih dari 2 MB")
      } else {
        if (!files.length) return;
        this.addShowImageFotoBpjsKetenagakerjaan = files[0];
        this.createImageFotoBpjsKetenagakerjaan(files[0]);
      }
    },

    createImageFotoKtp(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoKtp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createImageFotoKk(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoKk = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createImageFotoIjasah(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoIjasah = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createImageFotoNpwp(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoNpwp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createImageFotoBpjsKesehatan(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoBpjsKesehatan = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createImageFotoBpjsKetenagakerjaan(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.addUrlImageFotoBpjsKetenagakerjaan = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    addRemoveImage(il) {
      if (il == 'ktp') {
        this.addShowImageFotoKtp = ''
        this.addUrlImageFotoKtp = ''
        this.addUrlPathFotoKtp = ''
      } else if (il == 'kk') {
        this.addShowImageFotoKk = ''
        this.addUrlImageFotoKk = ''
        this.addUrlPathFotoKk = ''
      } else if (il == 'ijasah') {
        this.addShowImageFotoIjasah = ''
        this.addUrlImageFotoIjasah = ''
        this.addUrlPathFotoIjasah = ''
      } else if (il == 'npwp') {
        this.addShowImageFotoNpwp = ''
        this.addUrlImageFotoNpwp = ''
        this.addUrlPathFotoNpwp = ''
      } else if (il == 'bpjsKesehatan') {
        this.addShowImageFotoBpjsKesehatan = ''
        this.addUrlImageFotoBpjsKesehatan = ''
        this.addUrlPathFotoBpjsKesehatan = ''
      } else if (il == 'bpjsKetenagakerjaan') {
        this.addShowImageFotoBpjsKetenagakerjaan = ''
        this.addUrlImageFotoBpjsKetenagakerjaan = ''
        this.addUrlPathFotoBpjsKetenagakerjaan = ''
      }

    },

    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.errModal = 'Harap melengkapi data yang wajib diisi terlebih dahulu'
      } else {
        this.saveImageFotoProfil()
        this.loadingAdd = true
        this.errModal = ''
      }
    },
    saveImageFotoProfil() {
      if (this.addUrlImageFotoProfil.split(":")[0] == 'data' && this.addUrlImageFotoProfil != '') {
        let imageData = this.addShowImageFotoProfil
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoProfil = response.data.urlPath
                this.saveImageFotoKtp()
              } else {
                alert('Upload Photo Failed !')
              }
            });
      } else {
        this.addUrlPathFotoProfil = ''
        this.saveImageFotoKtp()
      }
    },
    saveImageFotoKtp() {
      if (this.addUrlImageFotoKtp.split(":")[0] == 'data' && this.addUrlImageFotoKtp != '') {
        let imageData = this.addShowImageFotoKtp
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoKtp = response.data.urlPath
                this.saveImageFotoKk()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoKtp = ''
        this.saveImageFotoKk()
      }
    },
    saveImageFotoKk() {
      if (this.addUrlImageFotoKk.split(":")[0] == 'data' && this.addUrlImageFotoKk != '') {
        let imageData = this.addShowImageFotoKk
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoKk = response.data.urlPath
                this.saveImageFotoIjasah()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoKk = ''
        this.saveImageFotoIjasah()
      }
    },
    saveImageFotoIjasah() {
      if (this.addUrlImageFotoIjasah.split(":")[0] == 'data' && this.addUrlImageFotoIjasah != '') {
        let imageData = this.addShowImageFotoIjasah
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoIjasah = response.data.urlPath
                this.saveImageFotoNpwp()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoIjasah = ''
        this.saveImageFotoNpwp()
      }
    },
    saveImageFotoNpwp() {
      if (this.addUrlImageFotoNpwp.split(":")[0] == 'data' && this.addUrlImageFotoNpwp != '') {
        let imageData = this.addShowImageFotoNpwp
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoNpwp = response.data.urlPath
                this.saveImageFotoBpjsKesehatan()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoNpwp = ''
        this.saveImageFotoBpjsKesehatan()
      }
    },
    saveImageFotoBpjsKesehatan() {
      if (this.addUrlImageFotoBpjsKesehatan.split(":")[0] == 'data' && this.addUrlImageFotoBpjsKesehatan != '') {
        let imageData = this.addShowImageFotoBpjsKesehatan
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoBpjsKesehatan = response.data.urlPath
                this.saveImageFotoBpjsKetenagakerjaan()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoBpjsKesehatan = ''
        this.saveImageFotoBpjsKetenagakerjaan()
      }
    },
    saveImageFotoBpjsKetenagakerjaan() {
      if (this.addUrlImageFotoBpjsKetenagakerjaan.split(":")[0] == 'data' && this.addUrlImageFotoBpjsKetenagakerjaan != '') {
        let imageData = this.addShowImageFotoBpjsKetenagakerjaan
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.tokenOrganisasi
        let tanggalData = new Date()
        let lvlData = this.tokenLvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.addUrlPathFotoBpjsKetenagakerjaan = response.data.urlPath
                this.goSave()
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else {
        this.addUrlPathFotoBpjsKetenagakerjaan = ''
        this.goSave()
      }
    },
    goSave() {
      let x = '##'
      let tipe = 'C'

      // data1
      let organisasi = this.tokenOrganisasi
      let idPegawai = 0
      let aktif = 'Y'
      let fotoProfil = this.addUrlPathFotoProfil
      let nama = this.addNama
      let namaAlias = this.addNamaAlias
      let nip = this.addNip
      let lvl = this.idAddUnit
      let bidang = this.addBidang
      let jabatan = this.addJabatan
      let atasan = this.idAddPegawai
      let tipePegawai = this.kodeAddTipePegawai
      let role = this.selectedAddRole.value
      let radius = this.addRadius
      let pjtk = this.addPJTK.value
      let jenjang = this.addJenjang.value
      let sync = this.addSync.value

      // data2
      let tempatLahir = this.addTempatLahir
      let tanggalLahir = this.addTanggalLahir
      let status = this.selectedAddStatus.value
      let golonganDarah = this.selectedAddGolonganDarah.value
      let jenisKelamin = this.selectedAddJenisKelamin.value
      let ijasah = this.selectedAddIjasah.value
      let tanggalBerakhirKontrak = this.addBerakhirKontrak
      let negara = this.queryAddNegara
      let agama = this.selectedAddAgama.value
      let gpsInterval = ''
      if (this.selectedAddWajibGps.value == 'Y') {
        if (this.selectedAddGpsInterval.value == '') {
          gpsInterval = '0'
        } else {
          gpsInterval = this.selectedAddGpsInterval.value
        }
      } else {
        gpsInterval = '0'
      }

      //data3
      let telp = this.addTelp
      let wa = this.addWa
      let usernameBy = this.selectedAddUsernameBy.value
      let alamat = this.addAlamat + ', ' + this.queryAddKelurahan + ', ' + this.queryAddKecamatan + ', ' + this.queryAddKota + ', ' + this.queryAddProvinsi
      let alamatDomisili = this.addAlamatDomisili
      let email = this.addEmail
      let validasiEmail = this.addValidasiEmail
      let username = this.addUsername

      // data4
      let lokasi = this.idAddKantor
      let lokasiExp = this.addTanggalExpiredPenempatan

      // data5
      let tipeSeragam1 = this.selectedAddTipeSeragam1.value
      let sizeSeragam1 = this.selectedAddSizeSeragam1.value
      let tipeSeragam2 = this.selectedAddTipeSeragam2.value
      let sizeSeragam2 = this.selectedAddSizeSeragam2.value
      let tipeOlahraga = this.selectedAddTipeOlahraga.value
      let sizeOlahraga = this.selectedAddSizeOlahraga.value
      let hijab = this.selectedAddHijab.value

      // data6
      let namaPasangan = this.addNamaPasangan
      let tanggalLahirPasangan = this.addTanggalLahirPasangan
      let tanggalMenikah = this.addTanggalMenikah
      let namaAnak1 = this.addNamaAnak1
      let tanggalLahirAnak1 = this.addTanggalLahirAnak1
      let namaAnak2 = this.addNamaAnak2
      let tanggalLahirAnak2 = this.addTanggalLahirAnak2
      let namaAnak3 = this.addNamaAnak3
      let tanggalLahirAnak3 = this.addTanggalLahirAnak3
      let namaIbuKandung = this.addNamaIbuKandung
      let admedikaPasangan = this.addNoAdmedikaPasangan
      let admedikaAnak1 = this.addNoAdmedikaAnak1
      let admedikaAnak2 = this.addNoAdmedikaAnak2
      let admedikaAnak3 = this.addNoAdmedikaAnak3

      // data7
      let tanggalAktifKerja = this.addTanggalAktif
      let polaAbsensi = this.selectedAddPolaAbsensi.value
      let kodePolaAbsensi = this.selectedAddKodePolaAbsensi.value
      let shiftKe = this.selectedAddShiftKe.value
      let wajibGps = this.selectedAddWajibGps.value
      let hideWfh = this.selectedAddHideWfh.value

      // data8
      let device = this.addJumlahDevice

      // data9
      let noNpwp = this.addNpwp
      let nik = this.addNik
      let bpjsk = this.addBpjsKesehatan
      let bpjstk = this.addBpjsKetenagakerjaan
      let noDplk = this.addNoRekDplk
      let bankDplk = this.addNamaBankDplk
      let noGaji = this.addNoRekGaji
      let bankGaji = this.addNamaBankGaji
      let adMedika = this.addNoAdMedika

      // data10
      let fotoKtp = this.addUrlPathFotoKtp
      let fotoKk = this.addUrlPathFotoKk
      let fotoIjasah = this.addUrlPathFotoIjasah
      let fotoNpwp = this.addUrlPathFotoNpwp
      let fotoBpjsK = this.addUrlPathFotoBpjsKesehatan
      let fotoBpjsTK = this.addUrlPathFotoBpjsKetenagakerjaan


      let data1 = organisasi + x + idPegawai + x + aktif + x + fotoProfil + x + nama + x + namaAlias + x + nip + x + lvl + x + bidang + x + jabatan + x + atasan + x + tipePegawai + x + role + x + radius + x + pjtk + x + jenjang + x + sync

      let data2 = tempatLahir + x + tanggalLahir + x + status + x + golonganDarah + x + jenisKelamin + x + ijasah + x + tanggalBerakhirKontrak + x + negara + x + agama + x + gpsInterval

      let data3 = telp + x + wa + x + usernameBy + x + alamat + x + email + x + validasiEmail + x + username + x + alamatDomisili

      let data4 = lokasi + x + lokasiExp

      let data5 = tipeSeragam1 + x + sizeSeragam1 + x + tipeSeragam2 + x + sizeSeragam2 + x + tipeOlahraga + x + sizeOlahraga + x + hijab

      let data6 = namaPasangan + x + tanggalLahirPasangan + x + tanggalMenikah + x + admedikaPasangan + x + namaAnak1 + x + tanggalLahirAnak1 + x + admedikaAnak1 + x + namaAnak2 + x + tanggalLahirAnak2 + x + admedikaAnak2 + x + namaAnak3 + x + tanggalLahirAnak3 + x + admedikaAnak3 + x + namaIbuKandung

      let data7 = tanggalAktifKerja + x + polaAbsensi + x + kodePolaAbsensi + x + shiftKe + x + wajibGps + x + hideWfh

      let data8 = device

      let data9 = noNpwp + x + nik + x + bpjsk + x + bpjstk + x + noDplk + x + bankDplk + x + noGaji + x + bankGaji + x + adMedika

      let data10 = fotoKtp + x + fotoKk + x + fotoIjasah + x + fotoNpwp + x + fotoBpjsK + x + fotoBpjsTK


      let payload = {
        data1: data1,
        data2: data2,
        data3: data3,
        data4: data4,
        data5: data5,
        data6: data6,
        data7: data7,
        data8: data8,
        data9: data9,
        data10: data10,
        tipe: tipe,
        idPegawai: idPegawai
      }

      DataApi.post("pegawai/save/detail", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              if (response.data.Data1 == 'Y') {
                this.success = true
                this.areaAdd = false
                this.loading = false
                this.currentAlertCounter = 7
              } else {
                this.success = false
              }
              this.alertMess = response.data.Data2
            } else {
              this.alertMess = response.message
              this.success = false
              this.areaAdd = false
              this.loading = false
              this.currentAlertCounter = 7
            }
          })
    },

    setDateNow() {
      var dtToday = new Date();
      var month = dtToday.getMonth() + 1;
      var day = dtToday.getDate();
      var year = dtToday.getFullYear();
      if (month < 10)
        month = '0' + month.toString();
      if (day < 10)
        day = '0' + day.toString();

      this.now = year + '-' + month + '-' + day;
    },
    getDataToken() {
      this.$store.state.loadingScreen = true
      DataApi.get("pegawai/role/cek")
          .then(response => {
            let res = response.data
            if (res.success == true) {
              this.tokenLvl = res.data.lvl
              this.tokenOrganisasi = res.data.organisasi
              this.tokenRole = res.data.admin
              this.pegawaiID = res.data.idPegawai

            }
            this.$store.state.loadingScreen = false
          })
    },
    rupiahMode() {
      var number_string = this.hargaSatuan.toString().replace(/[^,\d]/g, '')
      var split = number_string.split(',')
      var sisa = split[0].length % 3
      var rupiah = split[0].substr(0, sisa)
      var ribuan = split[0].substr(sisa).match(/\d{3}/gi)
      var prefix = "Rp. "

      // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
      if (ribuan) {
        var separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
      }

      rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
      let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
      this.hargaSatuan = hasil
    }
  },
  computed: {
    matchesPegawai() {
      if (this.queryPegawai == '') {
        return [];
      }
      return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
    },
    matchesUnit() {
      if (this.queryUnit == '') {
        return [];
      }
      return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
    },
    matchesUnitSearch() {
      if (this.queryUnitSearch == '') {
        return [];
      }
      return this.dataUnitSearch.filter((item) => item['text'].toLowerCase().includes(this.queryUnitSearch.toLowerCase()))
    },
    matchesKantor() {
      if (this.queryKantor == '') {
        return [];
      }
      return this.dataKantor.filter((item) => item['text'].toLowerCase().includes(this.queryKantor.toLowerCase()))
    },
    matchesTipePegawai() {
      if (this.queryTipePegawai == '') {
        return [];
      }
      return this.dataTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryTipePegawai.toLowerCase()))
    },
    matchesEditTipePegawai() {
      if (this.queryEditTipePegawai == '') {
        return [];
      }
      return this.dataEditTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryEditTipePegawai.toLowerCase()))
    },
    matchesEditTipeRole() {
      if (this.queryEditTipeRole == '') {
        return [];
      }
      return this.dataEditTipeRole.filter((item) => item['text'].toLowerCase().includes(this.queryEditTipeRole.toLowerCase()))
    },
    matchesAddUnit() {
      if (this.queryAddUnit == '') {
        return [];
      }
      return this.dataAddUnit.filter((item) => item['text'].toLowerCase().includes(this.queryAddUnit.toLowerCase()))
    },
    matchesAddPegawai() {
      if (this.queryAddPegawai == '') {
        return [];
      }
      return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()))
    },
    matchesAddTipePegawai() {
      if (this.queryAddTipePegawai == '') {
        return [];
      }
      return this.dataAddTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddTipePegawai.toLowerCase()))
    },
    matchesNegara() {
      if (this.queryNegara == '') {
        return [];
      }
      return this.dataNegara.filter((item) => item['text'].toLowerCase().includes(this.queryNegara.toLowerCase()))
    },
    matchesAddNegara() {
      if (this.queryAddNegara == '') {
        return [];
      }
      return this.dataAddNegara.filter((item) => item['text'].toLowerCase().includes(this.queryAddNegara.toLowerCase()))
    },
    matchesAddProvinsi() {
      if (this.queryAddProvinsi == '') {
        return [];
      }
      return this.dataAddProvinsi.filter((item) => item['text'].toLowerCase().includes(this.queryAddProvinsi.toLowerCase()))
    },
    matchesAddKota() {
      if (this.queryAddKota == '') {
        return [];
      }
      return this.dataAddKota.filter((item) => item['text'].toLowerCase().includes(this.queryAddKota.toLowerCase()))
    },
    matchesAddKecamatan() {
      if (this.queryAddKecamatan == '') {
        return [];
      }
      return this.dataAddKecamatan.filter((item) => item['text'].toLowerCase().includes(this.queryAddKecamatan.toLowerCase()))
    },
    matchesAddKelurahan() {
      if (this.queryAddKelurahan == '') {
        return [];
      }
      return this.dataAddKelurahan.filter((item) => item['text'].toLowerCase().includes(this.queryAddKelurahan.toLowerCase()))
    },
    matchesAddKantor() {
      if (this.queryAddKantor == '') {
        return [];
      }
      return this.dataAddKantor.filter((item) => item['text'].toLowerCase().includes(this.queryAddKantor.toLowerCase()))
    },
    addJumlahDevice() {
      this.addJumlahDevice = parseInt(this.addJumlahDevice)
    },
  },
  mounted() {
    this.errorMessage = 'Find Your Data'
    this.getDataToken()
    this.getDataStatus()
    this.getDataTipePegawai()
    this.getDataEditTipePegawai('null')
    this.getDataEditTipeRole('null')
    this.getDataBulan()
    this.getDataTahun()
    this.setDate()
    this.getDataUnit('null')
    this.getDataUnitSerach()
    this.getDataPegawai('null')
    this.getDataKantor('null')
    this.getDataSex()
    this.getDataAgama()
    this.getDataMarrige()
    this.getDataIjasah()
    this.getDataGolonganDarah()
    this.getDataUsernameBy()
    this.getDataPolaAbsensi()
    this.getDataSeragam()
    this.getDataTipeKeluarga()
    this.getDataWajibGPS()
    this.getDataGpsInterval()
    this.getDataHideWFH()
    this.getDataAktif()
    this.getDataPJTK()
    this.getDataJenjang()
    this.getDataSync()
    this.getDataNegara('null')

    // add
    this.getDataAddRole()
    this.getDataAddStatus()
    this.getDataAddPJTK()
    this.getDataAddJenjang()
    this.getDataAddGolonganDarah()
    this.getDataAddJenisKelamin()
    this.getDataAddAgama()
    this.getDataAddIjasah()
    this.getDataAddNegara()
    this.getDataAddUsernameBy()
    this.getAddProvinsi()
    this.getDataAddKantor()
    this.getDataAddTipeSeragam1()
    this.getDataAddTipeSeragam2()
    this.getDataAddTipeOlahraga()
    this.getDataAddSizeSeragam1()
    this.getDataAddSizeSeragam2()
    this.getDataAddSizeOlahraga()
    this.getDataAddHijab()
    this.getDataAddPolaAbsensi()
    this.getDataAddWajibGps()
    this.getDataAddGpsInterval()
    this.getDataAddHideWfh()
    this.getDataAddSync()

    this.setDateNow()
  },
}
</script>
<style scoped>
.containers {
  background-color: rgba(249, 250, 252, 1);
  padding-bottom: 12px;
}

.list {
  background-color: white;
}

.headers {
  background-color: white;
}

.btn-search {
  border-radius: 4px;
  width: 100%;
  margin-left: 4px;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-search:hover {
  border-radius: 4px;
  width: 100%;
  margin-left: 4px;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}

.btn-edit {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-edit:hover {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}

.btn-add {
  border-radius: 4px;
  width: 100%;
  margin-right: 6px;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-add:hover {
  border-radius: 4px;
  width: 100%;
  margin-right: 6px;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.reloadOn {
  float: left;
  cursor: pointer;
  transform: rotate(-180deg);
  transition: 300ms linear all;
}

.reloadOff {
  float: left;
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms linear all;
}

div.search-area {
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}

div.sticky1 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 12px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}

div.sticky2 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 12px;
  margin-right: 20px;
  margin-left: 20px;
  padding-bottom: 12px !important;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  background-color: white;
  z-index: 1;
}

input {
  background-color: rgba(249, 250, 252, 1);
}

.detail {
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  background-color: white;
}

.menu-non-active {
  cursor: pointer;
  color: rgba(154, 154, 154, 1);
  font-size: 14px;
  margin-right: 24px;
}

.menu-active {
  border-bottom: 2px solid rgba(48, 107, 221, 1);
  padding-bottom: 20px;
  cursor: pointer;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-weight: bold;
  margin-right: 24px;
}

.contents {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}

.card-menu {
  border-radius: 8px;
  padding-left: 20px;
  padding-top: 24px;
  padding-right: 20px;
  padding-bottom: 24px;
}

.header-card {
  color: rgba(16, 16, 16, 1);
  font-size: 18px;
  font-weight: bold;
}

.sub-title {
  font-size: 12px;
  color: rgba(96, 96, 96, 1);
}

.sub-title-content {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
}

.card-family {
  padding-left: 20px;
  padding-top: 24px;
  padding-right: 20px;
  padding-bottom: 24px;
  border-radius: 8px;
  border: 1px solid rgba(224, 224, 224, 1);
}

.family-name {
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  font-weight: bold;
}

.family-lahir {
  color: rgba(154, 154, 154, 1);
  font-size: 12px;
}

table {
  width: 100%;
}

thead th {
  border: 1px solid rgba(224, 224, 224, 1);
  background-color: rgba(244, 244, 244, 1);
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
}

tbody td {
  border: 1px solid rgba(224, 224, 224, 1);
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
}

table .off {
  background-color: rgba(244, 244, 244, 1);
  color: rgba(255, 0, 0, 1);
}

.image-cam {
  position: absolute;
  border: 1px solid white;
  border-radius: 50%;
  background-color: rgba(234, 234, 234, 1);
  padding: 4px;
  z-index: 0;
  left: 125px;
  top: 115px;
}

.image-cam-foto {
  position: absolute;
  border: 1px solid white;
  border-radius: 50%;
  background-color: rgba(234, 234, 234, 1);
  padding: 4px;
  z-index: 0;
  left: auto;
  margin-left: -6%;
  bottom: 0px;
}

.card-team {
  cursor: pointer;
}

.card-team:hover {
  cursor: pointer;
  background-color: whitesmoke;
}

::v-deep .modal-header {
  border-bottom: none !important;
}

.headers-modal {
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(16, 16, 16, 1);
}

.modal-buttons {
  width: 156px;
  height: 36px;
}

.modal-button-cancel {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
}

.modal-button-cancel:hover {
  border: 1px solid rgba(48, 107, 240, 1);
  background-color: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.modal-button-simpan {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.modal-button-simpan:hover {
  border: 1px solid rgba(48, 107, 240, 1);
  background-color: rgba(48, 107, 240, 1);
  color: white;
}

.autocomplete {
  width: 100%;
  position: relative;
}

.input {
  cursor: text;
}

.close {
  position: absolute;
  right: 8px;
  top: 10px;
  background: none;
  border: none;
  font-size: 14px;
  color: lightgrey;
  cursor: pointer;
}

.placeholder {
  position: absolute;
  top: 7px;
  left: 16px;
  font-size: 14px;
  color: #d0d0d0;
}

.popovers {
  text-align: center;
  width: 100% !important;
  min-height: 50px;
  border: 1px solid #d8dbe0;
  position: absolute;
  top: 35px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 3;
}

.popovers input {
  right: 8px;
  left: 8px;
  width: 100%;
}

.options {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
}

.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}

.options ul li {
  border-bottom: 1px solid lightgrey;
  padding: 10px;
  cursor: pointer;
  background: white;
}

.options ul li:first-child {
  border-top: 1px solid lightgray;
}

.options ul li:not(.selected):hover {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.options ul li.selected {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.model-select .textarea {
  background-color: #f9fafc !important;
}

::v-deep .ui.selection.dropdown {
  background-color: #f9fafc !important;
}


.add-area {
  background-color: rgba(249, 250, 252, 1);
  padding-bottom: 36px;
}

.headers-add {
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 26px;
}

.headers-add .span-add {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
}

.arrow-add {
  background-color: white;
  padding: 20px;
  padding-top: 24px;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
}

.arrow-add div {
  padding-bottom: 12px;
}

.info-kepegawaian-add {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 24px;
}

.cards-add {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 26px;
  padding-bottom: 24px;
  border-radius: 8px;
}

.card .title-add {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  margin-bottom: 24px;
}

.button-add {
  width: 156px;
  border-radius: 4px;
  height: 36px;
}

.btn-kembali-add {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-kembali-add:hover {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  font-weight: 500;
  font-size: 14px;
  color: white;
}

.btn-submit-add {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
  font-weight: 500;
  font-size: 14px;
}

.btn-submit-add:hover {
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 240, 1);
  font-weight: 500;
  font-size: 14px;
  color: white;
}

.params-add {
  color: rgba(16, 16, 16, 1);
  font-size: 12px;
}

.params-input-add {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
}

.select-invalid {
  border: 1px solid #e55353 !important;
}

.select-valid {
  border: 1px solid #2eb85c !important;
}

.cards-image {
  text-align: center;
  font-size: 12px;
  color: rgba(96, 96, 96, 1);
  line-height: 65px;
  border: 1px dotted rgba(221, 221, 221, 1);
  width: 56px !important;
  background-color: rgba(250, 250, 250, 1);
  height: 70px !important;
}

</style>
